var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var SIZE_SM = 'sm';
        var THEME_DEFAULT = 'default';
        var THEME_SECONDARY = 'secondary';
        var THEME_TRANSPARENT = 'transparent';

        var i18nMessages = {
            labelBackBtn: 'Закрыть'
        };

        /**
         * @property {string} title
         * @property {string|null} titleSize
         * @property {string|null} titleFor
         * @property {HTMLElement|string|null} html - custom content
         */

        var FindFormModalHeader = function () {
            function FindFormModalHeader(props) {
                _classCallCheck(this, FindFormModalHeader);

                this.title = props.title;
                this.titleSize = props.titleSize || null;
                this.titleFor = props.titleFor || null;
                this.titleAlign = props.titleAlign || 'center'; // left | center
                this.html = props.html || null; // custom content
                this.theme = props.theme || THEME_DEFAULT;
            }

            _createClass(FindFormModalHeader, [{
                key: "isTransparent",
                value: function isTransparent() {
                    return this.theme === THEME_TRANSPARENT;
                }
            }, {
                key: "isSticky",
                value: function isSticky() {
                    return !this.isTransparent();
                }

                /** @return HTMLDivElement */

            }, {
                key: "render",
                value: function render() {
                    var _header$classList;

                    var header = document.createElement('div');
                    (_header$classList = header.classList).add.apply(_header$classList, ['mpopup_header', 'search-form-modal__header', 'theme-' + this.theme]);

                    if (this.isTransparent()) {
                        header.append(this.renderCloseButton());
                    } else {
                        header.classList.add('search-form-modal__header--rounded');
                        if (this.isSticky()) {
                            header.classList.add('sticky');
                        }
                        header.innerHTML = this.renderTitle();
                        if (this.html !== null) {
                            var customContent = document.createElement('div');
                            customContent.classList.add('header-content');
                            customContent.innerHTML = this.html;
                            header.append(customContent);
                        }
                    }

                    return header;
                }

                /**
                 * @private
                 * @return {HTMLDivElement}
                 */

            }, {
                key: "renderTitle",
                value: function renderTitle() {
                    var titleContent = void 0;
                    if (this.titleFor) {
                        titleContent = "<label class=\"header-title__label\" for=\"" + this.titleFor + "\">" + this.title + "</label>";
                    } else {
                        titleContent = this.title;
                    }

                    var classList = ['header-title', 'align-' + this.titleAlign];
                    if (this.titleSize !== null) {
                        classList.push('header-title--' + this.titleSize);
                    }
                    return '<div class="' + classList.join(' ') + ' text-ellipsis">' + titleContent + '</div>' + '<div class="aside-right">' + '<button type="button"' + ' class="mpopup-header-cross-button close_mpopup"' + ' aria-label="' + i18nMessages.labelBackBtn + '"></button>' + '</div>';
                }
            }, {
                key: "renderCloseButton",
                value: function renderCloseButton() {
                    var _button$classList;

                    var button = document.createElement('button');
                    button.type = 'button';
                    (_button$classList = button.classList).add.apply(_button$classList, ['btn-clear', 'mpopup-header-close-button', 'close_mpopup']);
                    button.innerHTML = '<span class="icon-close" aria-label="' + i18nMessages.labelBackBtn + '">✕</span>';
                    return button;
                }
            }]);

            return FindFormModalHeader;
        }();

        /**
         * @property {HTMLElement|string} html
         * @property {string} htmlDetachSelectorId
         * @property {string} theme
         */


        var FindFormModalContent = function () {
            function FindFormModalContent(props) {
                _classCallCheck(this, FindFormModalContent);

                this.html = props.html || '';
                this.htmlDetachSelectorId = props.htmlDetachSelectorId || '';
                this.theme = props.theme || THEME_DEFAULT;
            }

            /** @return {HTMLDivElement} */


            _createClass(FindFormModalContent, [{
                key: "render",
                value: function render() {
                    var _content$classList;

                    var content = document.createElement('div');
                    (_content$classList = content.classList).add.apply(_content$classList, ['mpopup_content', 'search-form-screen']);
                    return content;
                }
            }]);

            return FindFormModalContent;
        }();

        /**
         * @property {string} theme
         * @property {string} buttonLabel
         * @property {string} buttonCssClass
         * @property {number|null} height
         */


        var FindFormModalFooter = function () {
            function FindFormModalFooter(props) {
                _classCallCheck(this, FindFormModalFooter);

                this.theme = props.theme || THEME_DEFAULT;
                this.buttonLabel = props.buttonLabel || 'Выбрать';
                this.buttonCssClass = props.buttonCssClass || '';
                this.height = props.height || null;
            }

            /** @return {HTMLDivElement} */


            _createClass(FindFormModalFooter, [{
                key: "render",
                value: function render() {
                    var _footer$classList;

                    var footer = document.createElement('div');
                    (_footer$classList = footer.classList).add.apply(_footer$classList, ['mpopup_footer', 'search-form-screen', 'search-form-modal__footer', 'fade-animation', 'theme-' + this.theme]);
                    footer.append(this.renderButton());

                    return footer;
                }

                /**
                 * @private
                 * @return {HTMLButtonElement}
                 */

            }, {
                key: "renderButton",
                value: function renderButton() {
                    var _button$classList2;

                    var button = document.createElement('button');
                    button.type = 'button';
                    var classList = 'ht-button ht-button--primary close_mpopup';
                    if (this.buttonCssClass !== '') {
                        classList += ' ' + this.buttonCssClass;
                    }
                    classList = classList.trim().split(' ');
                    (_button$classList2 = button.classList).add.apply(_button$classList2, _toConsumableArray(classList));
                    button.innerHTML = this.buttonLabel;

                    return button;
                }
            }, {
                key: "getCssHeight",
                value: function getCssHeight() {
                    if (this.height === null) {
                        return null;
                    }
                    return this.height === 'auto' ? 'auto' : this.height + 'px';
                }
            }]);

            return FindFormModalFooter;
        }();

        /**
         * @property {string} id - Selecor ID модалки
         * @property {FindFormModalHeader} header - настройки отображения шапки
         * @property {FindFormModalContent} content - настройки отображения контента
         * @property {FindFormModalFooter|null} footer - настройки отображения футера
         * @property {Function|null} onAfterShow - колбек перед началом показа
         * @property {Function|null} onBeforeClose - колбек перед закрытием
         * @property {Function|null} onBeforeRemove - колбек перед удалением из DOM
         */


        var FindFormModalOptions = function () {
            function FindFormModalOptions(props) {
                _classCallCheck(this, FindFormModalOptions);

                // required
                this.header = props.header;
                this.content = props.content;
                // optional
                this.id = props.id || this.randomId();
                this.fixContentMaxHeight = props.fixContentMaxHeight || false;
                this.footer = props.footer || null;
                this.onAfterShow = typeof props.onAfterShow === 'function' ? props.onAfterShow : null;
                this.onBeforeClose = typeof props.onBeforeClose === 'function' ? props.onBeforeClose : null;
                this.onBeforeRemove = typeof props.onBeforeRemove === 'function' ? props.onBeforeRemove : null;
            }

            _createClass(FindFormModalOptions, [{
                key: "randomId",
                value: function randomId() {
                    return 'find-form-modal-' + new Date().getTime() + '-' + Math.ceil(Math.random() * 1000);
                }
            }]);

            return FindFormModalOptions;
        }();

        /**
         * Построение конфигурации из объекта
         * @param optionsConfig
         * @return {FindFormModalOptions}
         */


        function buildFindFormModalOptions(optionsConfig) {
            if (optionsConfig instanceof FindFormModalOptions) {
                return optionsConfig;
            }

            var footer = null;
            if (optionsConfig.footer) {
                footer = new FindFormModalFooter(optionsConfig.footer);
            }
            var header = null;
            if (optionsConfig.header) {
                header = new FindFormModalHeader(optionsConfig.header);
            }

            return new FindFormModalOptions({
                id: optionsConfig.id,
                // sections
                header: header,
                footer: footer,
                content: new FindFormModalContent(optionsConfig.content),
                // settings
                fixContentMaxHeight: optionsConfig.fixContentMaxHeight || null,
                // callbacks
                onAfterShow: optionsConfig.onAfterShow || null,
                onBeforeClose: optionsConfig.onBeforeClose || null,
                onBeforeRemove: optionsConfig.onBeforeRemove || null
            }, zIndex);
        }

        /**
         * @param {FindFormModalOptions} options
         */
        function buildModalOpenParams(options) {
            return {
                target: '#' + options.id,
                header: true,
                place: 'bottom',
                content: options.content.html,
                contentDetachSelectorId: options.content.htmlDetachSelectorId,
                removeAfterClose: true,
                onAfterShow: function onAfterShow($modal) {
                    options.onAfterShow && options.onAfterShow($modal);
                },
                onBeforeClose: function onBeforeClose($modal) {
                    options.onBeforeClose && options.onBeforeClose($modal);
                },
                onBeforeRemove: function onBeforeRemove($modal) {
                    options.onBeforeRemove && options.onBeforeRemove($modal);
                }
            };
        }

        /**
         * @param {FindFormModalOptions} options
         * @param {number} zIndex
         */
        function renderFindFormModal(options, zIndex) {
            var _popup$classList, _overlay$classList, _contentBody$classLis;

            var popup = document.createElement('div');
            popup.id = options.id;
            (_popup$classList = popup.classList).add.apply(_popup$classList, ['mpopup', 'search-form-modal']);

            var overlay = document.createElement('div');
            overlay.setAttribute('role', 'button');
            (_overlay$classList = overlay.classList).add.apply(_overlay$classList, ['mpopup_overlay', 'mpopup_overlay--blurred', 'fade-animation']);

            var content = options.content.render();
            if (options.fixContentMaxHeight) {
                content.classList.add('fix-max-height');
            }

            var isContentBg = true;
            if (options.header) {
                if (options.header.isSticky()) {
                    popup.classList.add('fixed-header');
                }
                content.append(options.header.render());
                isContentBg = !options.header.isTransparent();
            }

            var contentBody = document.createElement('div');
            (_contentBody$classLis = contentBody.classList).add.apply(_contentBody$classLis, ['mpopup_body', 'search-form-modal__body']);
            if (options.footer && options.footer.height !== null) {
                contentBody.style.paddingBottom = options.footer.height + 'px';
            }
            if (isContentBg) {
                content.classList.add('theme-' + options.content.theme);
            } else {
                contentBody.classList.add('theme-' + options.content.theme);
                contentBody.classList.add('rounded-top');
                content.classList.add('theme-' + THEME_TRANSPARENT); // overwrite defaults
            }
            content.append(contentBody);

            popup.append(overlay);
            popup.append(content);
            if (options.footer !== null) {
                var footer = options.footer.render();
                footer.style.zIndex = zIndex;
                popup.append(footer);
                popup.classList.add('fixed-footer');
            }
            content.style.zIndex = zIndex;
            popup.style.zIndex = zIndex;
            return popup;
        }

        var zIndex = 100001;
        /**
         * @param {FindFormModalOptions|{}} optionsConfig
         */
        function openFindFormModal(optionsConfig) {
            var options = buildFindFormModalOptions(optionsConfig);
            document.body.appendChild(renderFindFormModal(options, zIndex++));
            var modalOptions = buildModalOpenParams(options);
            window.modals.open(modalOptions);
        }

        window.findFormModal = {
            themes: {
                DEFAULT: THEME_DEFAULT,
                SECONDARY: THEME_SECONDARY,
                TRANSPARENT: THEME_TRANSPARENT
            },
            sizes: {
                SM: SIZE_SM
            },
            open: openFindFormModal,
            /**
             * @param {jQuery} $child
             * @param {Function|null} onAfterHide - пробрость колбек после закрытия
             *      e.g. Закрыть модалку опционально, и показать еще одну. Порядок действий важен
             * @return {boolean}
             */
            closeParent: function closeParent($child) {
                var onAfterHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                return window.modals.closeParent($child, onAfterHide);
            },
            toggleParentStickyButtons: window.modals.toggleParentStickyButtons,
            setTitle: function setTitle($child, title) {
                var searchLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var $modal = $child.closest('.mpopup');
                if ($modal.length) {
                    var $label = searchLabel ? $modal.find('.header-title__label') : [];
                    if ($label.length === 0) {
                        $label = $modal.find('.header-title');
                    }
                    $label.html(title);
                }
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var i18nMessages = {
            closeTooltip: 'Закрыть'
        };

        var Tooltip = function () {
            /**
             * @param {jQuery} $container
             * @param {string} content
             * @param {{
             *  theme?: string,
             *  cssClass?: string,
             *  onAfterShow?: Function,
             *  onAfterClose?: Function,
             * }} params
             */
            function Tooltip($container, content) {
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                _classCallCheck(this, Tooltip);

                this.$container = $container;
                this.onAfterShow = typeof params.onAfterShow === 'function' ? params.onAfterShow : null;

                if (this.$container.length !== 1) {
                    return;
                }

                this.createInstance(content, 'theme' in params ? params.theme : 'dark', 'cssClass' in params ? params.cssClass : '');
                // show
                this.$container.append(this.$instance);
                if (this.onAfterShow !== null) {
                    this.onAfterShow(this);
                }
            }

            /**
             * @param $target
             * @param {string|null} content
             * @param {{
             *     theme?: string,
             * }} params
             */


            _createClass(Tooltip, [{
                key: "createInstance",
                value: function createInstance(content, theme, cssClass) {
                    var _this = this;

                    this.$instance = $("<div class=\"brx-tooltip brx-tooltip-" + theme + " " + cssClass + "\">\n                <div role=\"button\" class=\"brx-tooltip__close\">\n                    <span class=\"sr-only\">" + i18nMessages.closeTooltip + "</span>\n                </div>\n                <div class=\"brx-tooltip-content\">" + content + "</div>\n            </div>");

                    // handlers
                    this.$instance.find('.brx-tooltip__close').one('click', function () {
                        _this.close();
                    });
                }
            }, {
                key: "close",
                value: function close() {
                    if (this.$container.hasClass('brx-tooltip-container')) {
                        this.$container.remove();
                    } else {
                        this.$instance.remove();
                    }
                }
            }], [{
                key: "toggle",
                value: function toggle($target) {
                    var content = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                    var $parent = $target.parent();
                    var $existingContainer = $parent.find('.brx-tooltip-container');
                    if ($existingContainer.length) {
                        $existingContainer.remove();
                    } else {
                        var $newContainer = $('<div class="brx-tooltip-container"></div>');
                        $target.before($newContainer);

                        params.theme = params.theme || 'bright';
                        new Tooltip($newContainer, content === null ? $target.data('content') : content, params);
                    }
                }
            }, {
                key: "closeChildren",
                value: function closeChildren($parent) {
                    $parent.find('.brx-tooltip-container').each(function () {
                        $(this).remove();
                    });
                }
            }, {
                key: "closeInContainer",
                value: function closeInContainer($parent) {
                    var $tooltip = $parent.find('.brx-tooltip');
                    if ($tooltip.length) {
                        $tooltip.remove();
                    }
                }
            }]);

            return Tooltip;
        }();

        module.exports = {
            Tooltip: Tooltip
        };
    }, {}], 2: [function (require, module, exports) {
        window.Tooltip = require('../../../../include/_js/tooltip').Tooltip; // TODO: make avilable globally

        // find form only:

        var _require = require('../../include/_js/select/MultipleSelect'),
            MultipleSelect = _require.MultipleSelect,
            MultipleSelectItem = _require.MultipleSelectItem,
            MultipleSelectRenderOptions = _require.MultipleSelectRenderOptions;

        window.MultipleSelect = {
            Select: MultipleSelect,
            Item: MultipleSelectItem,
            RenderOptions: MultipleSelectRenderOptions
        };
    }, { "../../../../include/_js/tooltip": 1, "../../include/_js/select/MultipleSelect": 3 }], 3: [function (require, module, exports) {
        /**
         * Элемент списка
         */
        var MultipleSelectItem =
        /**
         * @param {{
         *     value: string|number,
         *     label: string,
         * }} props
         */
        function MultipleSelectItem(props) {
            _classCallCheck(this, MultipleSelectItem);

            this.value = props.value;
            this.label = props.label;
            this.labelFor = props.labelFor;
            this.name = props.name;
            /**
             * При клике - "выбрать все"
             * @type {boolean}
             */
            this.selectAll = props.selectAll || false;
        };

        /**
         * Параметры отрисовки селекта
         */


        var MultipleSelectRenderOptions =
        /**
         * @param {{
         *     items: MultipleSelectItem[],
         *     values: string[]|number[]|*[],
         *     isRadio?: boolean,
         * }} props
         */
        function MultipleSelectRenderOptions(props) {
            _classCallCheck(this, MultipleSelectRenderOptions);

            /**
             * Список доступных значений
             * @type {MultipleSelectItem[]}
             */
            this.items = props.items || [];
            /**
             * Выбранные значения
             * @type {string[]|number[]|*[]}
             */
            this.values = props.values || [];
            /**
             * Работает как radio или как checkbox
             * @type {boolean}
             */
            this.isRadio = props.isRadio || false;
        };

        /**
         * Значения и текущее состояние виджета multiple селекта
         */


        var MultipleSelectValue = function () {
            function MultipleSelectValue() {
                _classCallCheck(this, MultipleSelectValue);

                /**
                 * ID элемента "Выбрать все". Может быть только 1 или отсутствовать
                 * @type {string|number|null}
                 */
                this.all = null;
                /**
                 * ID элементов с множественным выбором (данных элементов можно выбрать несколько)
                 * @type {string[]|number[]|*[]}
                 */
                this.one = [];
                /**
                 * ID Выбранных элементов
                 * @type {string[]}
                 */
                this.selected = [];
            }

            /**
             * @param {string|number} value
             * @return {boolean}
             */


            _createClass(MultipleSelectValue, [{
                key: "isSelected",
                value: function isSelected(value) {
                    return this.selected.indexOf(value.toString()) !== -1;
                }

                /**
                 * @param {string|number} value
                 */

            }, {
                key: "setSelectedValue",
                value: function setSelectedValue(value) {
                    this.selected = [value];
                }

                /**
                 * @param {string|number} value
                 */

            }, {
                key: "addSelectedValue",
                value: function addSelectedValue(value) {
                    if (!this.isSelected(value)) {
                        this.selected.push(value);
                    }
                }

                /**
                 * @param {string|number} value
                 */

            }, {
                key: "removeSelectedValue",
                value: function removeSelectedValue(value) {
                    var index = this.selected.indexOf(value);
                    if (index !== -1) {
                        this.selected.splice(index, 1);
                    }
                }

                /**
                 * @param {MultipleSelectRenderOptions} options
                 */

            }, {
                key: "set",
                value: function set(options) {
                    var _this2 = this;

                    this.reset();
                    options.items.forEach(function (item) {
                        _this2.one.push(item.value.toString());
                    });

                    options.values.forEach(function (value) {
                        _this2.selected.push(value.toString());
                    });
                }
            }, {
                key: "reset",
                value: function reset() {
                    this.all = null;
                    this.one = [];
                    this.selected = [];
                }
            }]);

            return MultipleSelectValue;
        }();

        /**
         * Виджет multiple селекта
         */


        var MultipleSelect = function () {
            /**
             * @param {{
             *  onSelect: Function,
             * }} props
             */
            function MultipleSelect(props) {
                _classCallCheck(this, MultipleSelect);

                /**
                 * @private
                 * @type {MultipleSelectValue}
                 */
                this.values = new MultipleSelectValue();
                /**
                 * Колбек на выбор значения
                 * @type {Function}
                 */
                this.onSelect = props.onSelect;
                this.$modal = null;
            }

            /**
             * @public
             * @param {MultipleSelectRenderOptions} options
             * @param {{
             *  id?: string,
             *  title: string,
             *  titleHtml?: string,
             *  labelBtnSelect?: string,
             *  titleAlign?: string,
             * }} settings
             */


            _createClass(MultipleSelect, [{
                key: "open",
                value: function open(options, settings) {
                    var _this3 = this;

                    this.values.set(options);
                    var modal = window.findFormModal;
                    var params = {
                        id: settings.id || null,
                        header: {
                            title: settings.title,
                            titleSize: modal.sizes.SM,
                            titleAlign: settings.titleAlign || null,
                            html: settings.titleHtml || null
                        },
                        content: {
                            html: this.render(options)
                        },
                        onAfterShow: function onAfterShow($modal) {
                            _this3.$modal = $modal;
                            var selector = options.isRadio ? '.ht-radio__input' : '.ht-checkbox__input';
                            var $items = $modal.find(selector);
                            $items.on('change', function (e) {
                                _this3.onItemChange(e.currentTarget);
                            });
                        },
                        onBeforeRemove: function onBeforeRemove($modal) {
                            _this3.$modal = null;
                            var selector = options.isRadio ? '.ht-radio__input' : '.ht-checkbox__input';
                            var $items = $modal.find(selector);
                            $items.off('click change');
                            _this3.dispatchOnSelect();
                            _this3.values.reset();
                        }
                    };
                    if (settings.labelBtnSelect) {
                        params.footer = {
                            buttonLabel: settings.labelBtnSelect
                        };
                    }
                    window.findFormModal.open(params);
                }
            }, {
                key: "updateSelectedLabel",
                value: function updateSelectedLabel(selector, html) {
                    if (this.$modal !== null) {
                        this.$modal.find(selector).html(html);
                    }
                }

                /**
                 * @private
                 * @param {MultipleSelectRenderOptions} options
                 */

            }, {
                key: "render",
                value: function render(options) {
                    return "<div class=\"custom-select\">\n            <ul class=\"ht-reset-list search-form-select\">\n               " + this.renderItems(options) + "\n            </ul>\n        </div>";
                }

                /**
                 * @private
                 * @param {MultipleSelectRenderOptions} options
                 */

            }, {
                key: "renderItems",
                value: function renderItems(options) {
                    var html = '';
                    var items = options.items;
                    var item = void 0;
                    for (var _i = 0; _i < items.length; _i++) {
                        item = items[_i];
                        html += options.isRadio ? this.renderRadioItem(item, _i) : this.renderCheckboxItem(item, _i);
                    }

                    return html;
                }

                /**
                 * @param {MultipleSelectItem} item
                 * @param {number} id
                 * @return {string}
                 */

            }, {
                key: "renderCheckboxItem",
                value: function renderCheckboxItem(item, id) {
                    var checked = this.values.isSelected(item.value) ? 'checked' : '';
                    var labelFor = item.labelFor + '-' + id;
                    return "<li class=\"item ht-checkbox\">\n            <input type=\"checkbox\"\n                   name=\"" + item.name + "\"\n                   " + checked + "\n                   value=\"" + item.value + "\"\n                   class=\"ht-checkbox__input\"\n                   id=\"" + labelFor + "\">\n            <label class=\"ht-checkbox__label\" for=\"" + labelFor + "\">" + item.label + "</label>\n        </li>";
                }

                /**
                 * @param {MultipleSelectItem} item
                 * @param {number} id
                 * @return {string}
                 */

            }, {
                key: "renderRadioItem",
                value: function renderRadioItem(item, id) {
                    var checked = this.values.isSelected(item.value) ? 'checked' : '';
                    var labelFor = item.labelFor + '-' + id;
                    return "<li class=\"item ht-radio\">\n            <input type=\"radio\"\n                   name=\"" + item.name + "\"\n                   " + checked + "\n                   value=\"" + item.value + "\"\n                   class=\"ht-radio__input\"\n                   id=\"" + labelFor + "\">\n            <label class=\"ht-radio__label close_mpopup\" for=\"" + labelFor + "\">" + item.label + "</label>\n        </li>";
                }

                /**
                 * @private
                 * @param {HTMLInputElement} checkboxOrRadio
                 */

            }, {
                key: "onItemChange",
                value: function onItemChange(checkboxOrRadio) {
                    var value = checkboxOrRadio.value;
                    var checked = checkboxOrRadio.checked;
                    if (checked) {
                        if (checkboxOrRadio.type === 'radio') {
                            this.values.setSelectedValue(value);
                        } else {
                            this.values.addSelectedValue(value);
                        }
                    } else {
                        this.values.removeSelectedValue(value);
                    }
                    this.dispatchOnSelect();
                }
            }, {
                key: "dispatchOnSelect",
                value: function dispatchOnSelect() {
                    var selectedValues = this.values.selected;
                    this.onSelect(selectedValues);
                }
            }]);

            return MultipleSelect;
        }();

        module.exports = {
            MultipleSelect: MultipleSelect,
            MultipleSelectItem: MultipleSelectItem,
            MultipleSelectRenderOptions: MultipleSelectRenderOptions
        };
    }, {}] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var FormFieldTooltip = function () {
            function FormFieldTooltip() {
                _classCallCheck(this, FormFieldTooltip);

                /**
                 * @type {window.Tooltip|null}
                 */
                this.tooltip = null;
                /**
                 * @type {int|null}
                 */
                this.timer = null;
            }

            _createClass(FormFieldTooltip, [{
                key: "showTooltip",
                value: function showTooltip($field, message) {
                    this.tooltip = new window.Tooltip($field, message, { cssClass: 'form-field-tooltip' });
                }

                /**
                 * @param $field
                 * @param timeout
                 */

            }, {
                key: "setRemoveTimeout",
                value: function setRemoveTimeout($field, timeout) {
                    this.unsetRemoveTimeout();
                    this.timer = setTimeout(function () {
                        FormFieldTooltip.remove($field);
                    }, timeout);
                }
            }, {
                key: "unsetRemoveTimeout",
                value: function unsetRemoveTimeout() {
                    if (this.timer) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                }
            }], [{
                key: "add",
                value: function add($field, message) {
                    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                    var formTooltip = $field.data('formTooltip');
                    if (!formTooltip) {
                        formTooltip = new FormFieldTooltip();
                        formTooltip.showTooltip($field, message);
                    }

                    if (timeout !== null) {
                        formTooltip.setRemoveTimeout($field, timeout);
                    }

                    $field.data('formTooltip', formTooltip);
                }
            }, {
                key: "remove",
                value: function remove($field) {
                    var formTooltip = $field.data('formTooltip');
                    if (formTooltip) {
                        formTooltip.unsetRemoveTimeout();
                        formTooltip.tooltip.close();
                        $field.data('formTooltip', null);
                    }
                }
            }]);

            return FormFieldTooltip;
        }();

        window.FormFieldTooltip = FormFieldTooltip;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var FindFormDepartCitySelect = function () {
            /**
             * @param {{
             *  allowChangeCityOnLocation: boolean,
             *  onChange: Function,
             * }} props
             */
            function FindFormDepartCitySelect(props) {
                var _this4 = this;

                _classCallCheck(this, FindFormDepartCitySelect);

                this.allowChangeCityOnLocation = props.allowChangeCityOnLocation;
                this.onChange = props.onChange;
                this.translates = window.findFormTranslates;
                this.messages = {
                    cityTitle: this.translates.cityTitle
                };
                this.select = new window.MultipleSelect.Select({
                    onSelect: function onSelect(values) {
                        _this4.dispatchOnChange(values[0]);
                    }
                });
                this.bindEventListeners();
            }

            _createClass(FindFormDepartCitySelect, [{
                key: "disableChangeOnLocation",
                value: function disableChangeOnLocation() {
                    this.allowChangeCityOnLocation = false;
                }

                /**
                 * @param {number} departCityId
                 * @param {Array<{ id: number, name: string, nameFrom: string }>} cities
                 */

            }, {
                key: "open",
                value: function open(cities, departCityId) {
                    this.allowChangeCityOnLocation = false; // event triggered by user
                    var items = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = cities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var city = _step.value;

                            items.push(new MultipleSelect.Item({
                                value: city.id,
                                label: city.name,
                                labelFor: 'search-form__cities',
                                name: 'SFDepartCity'
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    var options = new MultipleSelect.RenderOptions({
                        items: items,
                        values: [departCityId],
                        isRadio: true
                    });
                    this.select.open(options, {
                        title: this.messages.cityTitle
                    });
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this5 = this;

                    if (this.allowChangeCityOnLocation) {
                        // при определении города меняем город в форме поиска
                        $(window).on('onLocation', function () {
                            var city = window.CityItemSearch.getCurrent();
                            // если город уже успели поменять вручную, то ничего не делаем
                            if (_this5.allowChangeCityOnLocation && city && city.depart_id) {
                                _this5.dispatchOnChange(city.depart_id);
                            }
                        });
                    }
                }
            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange(departCityId) {
                    this.onChange(departCityId);
                }
            }]);

            return FindFormDepartCitySelect;
        }();

        window.FindFormDepartCitySelect = FindFormDepartCitySelect;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var ITEM_COUNTRY = 1; // Тип: Страна
        var ITEM_REGION = 2; // Тип: Регион
        var ITEM_HOTEL = 3; // Тип: Отель

        var REGION_ID_ALL = 0;

        // Экран страна/регион/отель
        var SCREEN_MAIN = 'main';
        // Экран регион/отель
        var SCREEN_REGION = 'region';

        // Режим автокомплита: Все
        var MODE_ALL = 'all';
        // Режим автокомплита: Только отели
        var MODE_ONLY_HOTELS = 'only-hotels';
        // Минимальное кол-во символов для поиска отелей
        var HOTEL_SEARCH_MIN_LENGTH = 3;

        var i18nPlural = window.brxUtils.i18n.plural;
        var i18nTemplate = window.brxUtils.i18n.template;
        var translates = window.findFormTranslates;

        var AUTOCOMPLETE_ID = 'find-form-autocomplete';
        var AUTOCOMPLETE_INPUT_ID = 'search-form-direction-input';

        var messages = {
            fromCity: translates.fromCity,
            labelBtnSelect: translates.labelBtnApply,
            destination: {
                title: translates.destinationTitle,
                titleRegion: translates.destinationTitleRegion,
                titleHotel: translates.destinationTitleHotel,
                placeholderAny: translates.destinationPlaceholderAny,
                placeholderRegions: translates.destinationPlaceholderRegions,
                placeholderHotel: translates.destinationPlaceholderHotel,
                allResorts: translates.destinationAllResorts,
                groupPopularResorts: translates.destinationGroupPopularResorts,
                groupOtherResorts: translates.destinationGroupOtherResorts,
                groupPopularCountries: translates.destinationGroupPopularCountries,
                groupOtherCountries: translates.destinationGroupOtherCountries,
                groupFromCity: translates.destinationGroupFromCity,
                groupCountries: translates.destinationGroupCountries,
                groupResorts: translates.destinationGroupResorts,
                groupHotels: translates.destinationGroupHotels,
                searchLoadingAny: translates.destinationSearchLoadingAny + '...',
                searchLoadingHotel: translates.destinationSearchLoadingHotel + '...',
                noRequestMatches: translates.destinationNoRequestMatches,
                noMatch: translates.destinationNoMatch,
                noMatchAny: translates.destinationNoMatchAny,
                noMatchResorts: translates.destinationNoMatchResorts,
                noMatchHotels: translates.destinationNoMatchHotels,
                reqCountry: translates.destinationReqCountry,
                priceFrom: translates.destinationPriceFrom,
                minRequestLength: translates.destinationMinRequestLength
            }
        };

        var ButtonItem = function () {
            /**
             * @param {number} type - Тип элемента страна|регион|отель
             * @param {number} id
             * @param {string} label
             * @param {string} valueInfo
             */
            function ButtonItem(type, id, label, valueInfo) {
                _classCallCheck(this, ButtonItem);

                this.type = type;
                this.id = Number(id);
                this.label = label;
                this.valueInfo = valueInfo;

                this.countryId = null;
                this.countryCode = '';
                this.cityId = null;
                this.hotelPhoto = null;
                this.hotelStars = null;
                this.inputType = 'radio';
            }

            _createClass(ButtonItem, [{
                key: "asCheckbox",
                value: function asCheckbox() {
                    this.inputType = 'checkbox';
                }

                /**
                 * @param {number|string} id
                 * @param {string} countryCode
                 */

            }, {
                key: "setCountry",
                value: function setCountry(id) {
                    var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

                    this.countryId = parseInt(id, 10);
                    this.countryCode = countryCode;
                }
            }, {
                key: "setHotel",
                value: function setHotel(photo, stars) {
                    this.hotelPhoto = photo;
                    this.hotelStars = stars;
                }

                /**
                 * @param {number|string} id
                 */

            }, {
                key: "setCityId",
                value: function setCityId(id) {
                    this.cityId = parseInt(id, 10);
                }
            }]);

            return ButtonItem;
        }();

        var DestinationFormHotel =
        /**
         * @param {{
         *  id: number,
         *  name: string,
         *  countryId: number
         * }|null} props
         */
        function DestinationFormHotel(props) {
            _classCallCheck(this, DestinationFormHotel);

            this.id = props.id;
            this.name = props.name;
            this.countryId = props.countryId;
        };

        var DestinationFormValues = function () {
            function DestinationFormValues() {
                _classCallCheck(this, DestinationFormValues);

                this.departCityId = 0;
                this.countryId = 0;
                /** @type {number[]} */
                this.regionIds = [];
                /** @type {DestinationFormHotel|null} */
                this.selectedHotel = null;
            }

            /**
             * @public
             * @param {number} id
             * @param {string} name
             * @param {number} countryId
             */


            _createClass(DestinationFormValues, [{
                key: "setHotel",
                value: function setHotel(_ref) {
                    var id = _ref.id,
                        name = _ref.name,
                        countryId = _ref.countryId;

                    this.resetValues(true);
                    this.countryId = countryId;
                    this.selectedHotel = new DestinationFormHotel({
                        id: id,
                        name: name,
                        countryId: countryId
                    });
                }

                /**
                 * @param {number} regionId
                 * @return {boolean}
                 */

            }, {
                key: "isRegionSelected",
                value: function isRegionSelected(regionId) {
                    return this.regionIds.indexOf(regionId) !== -1;
                }

                /**
                 * @param {number[]} regionIds
                 */

            }, {
                key: "setSelectedRegionIds",
                value: function setSelectedRegionIds(regionIds) {
                    this.regionIds = regionIds;
                }

                /**
                 * @param {number} regionId
                 */

            }, {
                key: "addSelectedRegionId",
                value: function addSelectedRegionId(regionId) {
                    if (!this.isRegionSelected(regionId)) {
                        this.regionIds.push(Number(regionId));
                    }
                }

                /**
                 * @param {number} regionId
                 */

            }, {
                key: "removeSelectedRegionValue",
                value: function removeSelectedRegionValue(regionId) {
                    var index = this.regionIds.indexOf(regionId);
                    if (index !== -1) {
                        this.regionIds.splice(index, 1);
                    }
                }

                /**
                 * @param {boolean} allowResetCountry
                 */

            }, {
                key: "resetValues",
                value: function resetValues(allowResetCountry) {
                    if (allowResetCountry) {
                        this.countryId = 0;
                    }
                    this.regionIds = [];
                    this.selectedHotel = null;
                }
            }]);

            return DestinationFormValues;
        }();

        var FormDestinationView = function () {
            function FormDestinationView() {
                _classCallCheck(this, FormDestinationView);

                this.panelsId = {
                    destination: 'find-form-destination-panel'
                };
                this.destinationForms = {
                    countryId: 'find-form-destinations',
                    regionId: 'find-form-regions'
                };
            }

            _createClass(FormDestinationView, [{
                key: "getAutoCompleteMessage",
                value: function getAutoCompleteMessage(messageText) {
                    return "<li data-role=\"message\">" + messageText + "</li>";
                }
            }, {
                key: "renderLoadingItem",
                value: function renderLoadingItem(text) {
                    return "<li data-role=\"loader\"><p>" + text + "</p></li>";
                }
            }, {
                key: "renderListDividerItem",
                value: function renderListDividerItem(label) {
                    return "<li data-role=\"list-divider\">" + label + "</li>";
                }
            }, {
                key: "getRoundFlagSrc",
                value: function getRoundFlagSrc(code) {
                    return "/fls/flag/round/" + code + ".svg";
                }

                /**
                 * Элемент на главном экране
                 * @param {ButtonItem} item
                 */

            }, {
                key: "renderCountryItem",
                value: function renderCountryItem(item) {
                    return "<li class=\"direction direction--country item-button\">\n            " + this.renderHiddenInput(item) + "\n            <img src=\"/fls/flag/round/" + item.countryCode + ".svg\"\n                 alt=\"\"\n                 class=\"direction__flag\">\n            <div class=\"direction__country\">" + item.label + "</div>\n            <div class=\"direction__info\">" + item.valueInfo + "</div>\n        </li>";
                }
            }, {
                key: "renderRegionItem",
                value: function renderRegionItem(item, selected) {
                    var options = {
                        name: 'SFRegions[]',
                        id: 'sf-regions-' + item.id,
                        cssClass: 'ht-checkbox__input'
                    };
                    return "<li class=\"direction direction--region item-button ht-checkbox\" role=\"button\">\n            " + this.renderHiddenInput(item, selected, options) + "\n            <label class=\"ht-checkbox__label direction__checkbox-label\" for=\"" + options.id + "\">" + item.label + "</label>\n        </li>";
                }

                /** @param {ButtonItem} item */

            }, {
                key: "renderAutocompleteItem",
                value: function renderAutocompleteItem(item) {
                    return "<li class=\"direction direction-island --sm item-button\" role=\"button\">\n            " + this.renderHiddenInput(item) + "\n            <div class=\"direction-island__picture\">\n                <img src=\"/fls/flag/round/" + item.countryCode + ".svg\" alt=\"\">\n            </div>\n            <div class=\"direction-island__info\">\n                <h5 class=\"direction-island__title\">" + item.label + "</h5>\n                <p class=\"direction-island__hint\">" + item.valueInfo + "</p>\n            </div>\n        </li>";
                }

                /** @param {ButtonItem} item */

            }, {
                key: "renderHotelItem",
                value: function renderHotelItem(item) {
                    var photoSrc = '/img/no-hotel.jpg';
                    if (item.hotelPhoto) {
                        photoSrc = window.app.staticDomain + '/img/h/sm4x3/' + item.hotelPhoto;
                    }
                    return "<li class=\"direction direction--hotel direction-island item-button\" role=\"button\">\n            " + this.renderHiddenInput(item) + "\n            <div class=\"direction-island__picture\">\n                <img src=\"" + photoSrc + "\" alt=\"\">\n            </div>\n            <div class=\"direction-island__info\">\n                <div class=\"direction-island__stars\">" + this.renderStars(item.hotelStars) + "</div>\n                <h5 class=\"direction-island__title hotel-name capitalize\">" + item.label + "</h5>\n                <p class=\"direction-island__hint hotel-location\">" + item.valueInfo + "</p>\n            </div>\n        </li>";
                }

                /**
                 * @param {ButtonItem} item
                 * @param {boolean} isChecked
                 * @param {{ name: string, id: string, cssClass?: string }|null} options
                 */

            }, {
                key: "renderHiddenInput",
                value: function renderHiddenInput(item) {
                    var isChecked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                    var countryId = item.type === ITEM_COUNTRY ? item.id : item.countryId;
                    var checked = isChecked ? 'checked' : '';
                    var name = '';
                    var id = '';
                    var cssClass = '';
                    if (options) {
                        name = "name=\"" + options.name + "\"";
                        id = "id=\"" + options.id + "\"";
                        cssClass = options.cssClass || '';
                    }
                    return "<input type=\"" + item.inputType + "\"\n                       class=\"item__input " + cssClass + "\"\n                       " + checked + " " + name + " " + id + "\n                       value=\"" + item.id + "\"\n                       data-type=\"" + item.type + "\"\n                       data-country=\"" + countryId + "\"\n                       data-city=\"" + item.cityId + "\">";
                }

                /**
                 * @param {number|string} hotelStars
                 * @return {*}
                 */

            }, {
                key: "renderStars",
                value: function renderStars(hotelStars) {
                    var stars = Number(hotelStars);
                    if (Number.isNaN(stars)) {
                        return hotelStars;
                    }
                    var starsHtml = '';
                    for (var _i2 = 0; _i2 < stars; _i2++) {
                        starsHtml += '<img src="/img/find-form/icons/star-active.svg" class="star" alt="">';
                    }
                    return starsHtml;
                }
            }, {
                key: "$destinationPanel",
                get: function get() {
                    return $('#' + this.panelsId.destination);
                }
            }, {
                key: "$countryPanel",
                get: function get() {
                    return $('#' + this.destinationForms.countryId);
                }
            }, {
                key: "$regionPanel",
                get: function get() {
                    return $('#' + this.destinationForms.regionId);
                }
            }, {
                key: "$countryItems",
                get: function get() {
                    return $('#' + this.destinationForms.countryId + ' .items');
                }
            }, {
                key: "$regionItems",
                get: function get() {
                    return $('#' + this.destinationForms.regionId + ' .items');
                }
            }, {
                key: "$destinationInput",
                get: function get() {
                    return $('#' + AUTOCOMPLETE_ID + ' .autocomplete-field');
                }
            }, {
                key: "$destinationReset",
                get: function get() {
                    return $('#' + AUTOCOMPLETE_ID + ' .clear-input-button');
                }
            }]);

            return FormDestinationView;
        }();

        var FindFormDestination = function () {
            /**
             * @param {BaseSearchFormData} formData - shared with SearchForm
             * @param {{
             *     onChange: Function,
             *     onBeforeClose: Function,
             * }} params
             */
            function FindFormDestination(formData, params) {
                _classCallCheck(this, FindFormDestination);

                this.data = formData;
                this.allMessages = messages;
                this.onChange = params.onChange;
                this.onBeforeClose = params.onBeforeClose;
                this.slug = '';

                this.values = new DestinationFormValues();
                this.view = new FormDestinationView();
                this.autocomplete = {
                    cacheItemCity: {}
                };

                /**
                 * Задержка для поиска по списку стран/отелей/регионов
                 * @type {number}
                 */
                this.debounceInputTime = 300;

                this.timers = {
                    /** @type {number} */
                    input: 0
                };
                /**
                 * Формат отображения формы направления
                 * @type {string}
                 */
                this.formMode = MODE_ALL;

                this.bindEventListeners();
            }

            _createClass(FindFormDestination, [{
                key: "setFormMode",


                /**
                 * @param {string} mode - MODE_ALL|MODE_ONLY_HOTELS
                 */
                value: function setFormMode(mode) {
                    this.formMode = mode;
                }

                /**
                 * Открытие модалки с выбором направления
                 * @param {number} countryId
                 * @param {number} departCityId
                 */

            }, {
                key: "open",
                value: function open(countryId, departCityId) {
                    var _this6 = this;

                    // По умолчанию главный экран
                    this.currentScreen = SCREEN_MAIN;
                    this.resetValues();
                    this.isValueSelectedAfterOpen = false;

                    if (this.formMode === MODE_ONLY_HOTELS && this.data.isCountryExists(countryId)) {
                        this.values.countryId = countryId;
                    }
                    this.values.departCityId = departCityId;

                    var placeholder = this.messages.placeholderAny;
                    var modalTitle = this.messages.title;
                    if (this.formMode === MODE_ALL) {
                        this.renderCountriesList();
                    } else {
                        placeholder = this.messages.placeholderHotel;
                        modalTitle = this.messages.titleHotel;
                        this.renderCountriesListEmpty();
                    }

                    var $autocompleteTemplate = $('#sf-autocomplete-template');
                    var inputFocusTimeout = 0;
                    window.findFormModal.open({
                        id: 'search-form-direction-modal',
                        header: {
                            title: modalTitle,
                            titleFor: AUTOCOMPLETE_INPUT_ID,
                            html: $autocompleteTemplate.html()
                        },
                        content: {
                            htmlDetachSelectorId: this.view.panelsId.destination
                        },
                        footer: {
                            buttonLabel: this.allMessages.labelBtnSelect
                        },
                        fixContentMaxHeight: true,
                        onAfterShow: function onAfterShow() {
                            var $destinationInput = _this6.view.$destinationInput;
                            $destinationInput.val('');
                            $destinationInput.prop('placeholder', placeholder);
                            if (_this6.currentScreen !== SCREEN_REGION) {
                                _this6.toggleBlocksOverlappingAutoCompleteScope(false);
                            }
                            _this6.bindAutocompleteEventListeners();
                            var ModalParamsAnimationDuration = 350; // Условно
                            if (_this6.formMode === MODE_ONLY_HOTELS) {
                                // Задержка до полного завершения анимации, иначе Safari
                                inputFocusTimeout = setTimeout(function () {
                                    _this6.view.$destinationInput.focus();
                                }, ModalParamsAnimationDuration);
                            }
                        },
                        onBeforeClose: function onBeforeClose() {
                            if (inputFocusTimeout) {
                                clearTimeout(inputFocusTimeout);
                            }
                            var isOpenedFindFormRequired = _this6.isValueSelectedAfterOpen && _this6.formMode === MODE_ONLY_HOTELS;
                            _this6.onBeforeClose(isOpenedFindFormRequired);
                        }
                    });
                }
            }, {
                key: "resetValues",
                value: function resetValues() {
                    // страну не сбрасываем:
                    // 1) На экране выбора региона (SCREEN_REGION)
                    // 2) в режиме поиска по отелю (MODE_ONLY_HOTELS)
                    var allowResetCountry = this.currentScreen === SCREEN_MAIN && this.formMode !== MODE_ONLY_HOTELS;

                    this.values.resetValues(allowResetCountry);
                    this.isValueSelectedAfterOpen = false;
                }

                /**
                 * Выбор страны/региона/отеля
                 * @private
                 */

            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this7 = this;

                    this.view.$destinationPanel.on('click', '.item-button', function (e) {
                        var $button = $(e.currentTarget);
                        var $input = $button.find('> .item__input');
                        var itemId = parseInt($input.val(), 10);
                        var isCheckbox = $input.prop('type') === 'checkbox';

                        var allowCloseModal = false;

                        var selectedRegionIds = _this7.values.regionIds;
                        _this7.resetValues();
                        _this7.values.countryId = parseInt($input.data('country'), 10);
                        _this7.values.departCityId = parseInt($input.data('city'), 10);
                        switch ($input.data('type')) {
                            case ITEM_REGION:
                                if (isCheckbox) {
                                    // Возвращаем регионы, выбранные до сброса
                                    _this7.values.setSelectedRegionIds(selectedRegionIds);
                                    var isChecked = $input.prop('checked');
                                    var allowToggle = itemId !== REGION_ID_ALL || !isChecked;
                                    if (allowToggle) {
                                        $input.prop('checked', !isChecked);
                                        _this7.onRegionCheckboxChange($input);
                                    }
                                } else {
                                    var values = itemId === REGION_ID_ALL ? [] : [itemId];
                                    _this7.values.setSelectedRegionIds(values);
                                    allowCloseModal = true;
                                }
                                break;
                            case ITEM_HOTEL:
                                var hotelLabel = $button.find('.hotel-name').text().trim();
                                hotelLabel += ' (' + $button.find('.hotel-location').text().trim() + ')';
                                _this7.values.setHotel({
                                    id: itemId,
                                    name: hotelLabel,
                                    countryId: _this7.values.countryId
                                });
                                allowCloseModal = true;
                                break;
                            case ITEM_COUNTRY:
                            default:
                                _this7.currentScreen = SCREEN_REGION;
                                // Ниже будет вызвано событие изменения, запрещаем
                                _this7.resetInputSelection(false);
                                break;
                        }

                        _this7.isValueSelectedAfterOpen = true;
                        _this7.dispatchOnChange();

                        if (allowCloseModal) {
                            window.findFormModal.closeParent($input);
                        }
                    });
                }
            }, {
                key: "bindAutocompleteEventListeners",
                value: function bindAutocompleteEventListeners() {
                    var _this8 = this;

                    $('#' + AUTOCOMPLETE_ID).on('click', '.clear-input-button', function () {
                        _this8.resetInputSelection();
                        if (_this8.currentScreen === SCREEN_REGION) {
                            _this8.toggleBlocksOverlappingAutoCompleteScope(true);
                        }
                    }).on('keyup', '.autocomplete-field', function (e) {
                        e.stopPropagation();
                        _this8.onDestinationChange(e.currentTarget.value.trim());
                    })
                    // В мобиле при paste не срабатывает keyup, ну либо срабатывает не всегда
                    // Из-за throttle не страшно если сработает и keyup и paste. Запрос на бек будет 1
                    .on('paste', '.autocomplete-field', function (e) {
                        var pasteValue = (e.originalEvent.clipboardData || window.clipboardData).getData('text').trim();
                        if (pasteValue.length) {
                            _this8.onDestinationEnter(pasteValue);
                        }
                    }).on('blur', '.autocomplete-field', function () {
                        if (_this8.currentScreen === SCREEN_REGION) {
                            // e.g. Выбрали страну, изменился экран. Нужно вернуть
                            _this8.toggleBlocksOverlappingAutoCompleteScope(true);
                        }
                    });
                }

                /**
                 * @private
                 * @param {jQuery} $checkbox
                 */

            }, {
                key: "onRegionCheckboxChange",
                value: function onRegionCheckboxChange($checkbox) {
                    var value = Number($checkbox.val());
                    var checked = $checkbox.prop('checked');
                    var isSelectAll = value === REGION_ID_ALL;

                    var $checkboxes = this.view.$regionItems.find('input.item__input');
                    if (isSelectAll) {
                        if (checked) {
                            this.setRegionAllItemAsSelected($checkboxes, $checkbox);
                        } else {
                            // nothing. uncheck all prevented on click
                        }
                    } else {
                        var $checkboxAll = $checkboxes.filter('[value="' + REGION_ID_ALL + '"]');
                        var variantsCount = $checkboxes.length - 1;
                        if (checked) {
                            this.values.addSelectedRegionId(value);
                            if (variantsCount > 1 && this.values.regionIds.length === variantsCount) {
                                // Выбраны все доступные значения
                                // Оставить выбранным только "Выбрать все"
                                this.setRegionAllItemAsSelected($checkboxes, $checkboxAll);
                            } else {
                                $checkboxAll.prop('checked', false);
                                this.values.removeSelectedRegionValue(REGION_ID_ALL);
                            }
                        } else {
                            this.values.removeSelectedRegionValue(value);
                            if (this.values.regionIds.length === 0) {
                                this.setRegionAllItemAsSelected($checkboxes, $checkboxAll);
                            }
                        }
                    }
                }

                /**
                 * Установить элемент "Выбрать все" как текущий
                 * @param $checkboxes - все доступные checkbox
                 * @param $checkboxAll - checkbox "Выбрать все"
                 */

            }, {
                key: "setRegionAllItemAsSelected",
                value: function setRegionAllItemAsSelected($checkboxes, $checkboxAll) {
                    // Снимаем выбор со всех, кроме "Выбрать все"
                    $checkboxes.not($checkboxAll).filter(':checked').prop('checked', false);
                    // Эмулируем выбор "Выбрать все"
                    $checkboxAll.prop('checked', true);
                    this.values.setSelectedRegionIds([]);
                }

                /**
                 * @param {string} value
                 */

            }, {
                key: "onDestinationChange",
                value: function onDestinationChange(value) {
                    if (value === '') {
                        if (this.currentScreen === SCREEN_REGION) {
                            this.toggleBlocksOverlappingAutoCompleteScope(true);
                        }
                    } else if (value.length === 1) {
                        this.toggleBlocksOverlappingAutoCompleteScope(false);
                    }
                    this.onDestinationEnter(value);
                }

                /**
                 * @param {boolean} show
                 * @private
                 */

            }, {
                key: "toggleBlocksOverlappingAutoCompleteScope",
                value: function toggleBlocksOverlappingAutoCompleteScope(show) {
                    // При появлении экранной клавиатуры и наборе тескта, освобождаем место по выдачу,
                    // убирая блоки, которые перекрывают/занимают часть экрана
                    window.modals.toggleParentStickyButtons(this.view.$destinationPanel, {
                        showFooter: show
                    });
                }
            }, {
                key: "resetInputSelection",
                value: function resetInputSelection() {
                    var allowDispatchOnChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                    this.resetValues();

                    this.toggleDestinationResetButton(false);
                    this.setDestinationInputValue('');

                    if (this.formMode === MODE_ALL) {
                        if (this.currentScreen === SCREEN_REGION) {
                            this.renderRegionsListPanel();
                        } else {
                            this.renderCountriesList();
                        }
                    } else {
                        // Только отели
                        this.renderCountriesListEmpty();
                    }

                    if (allowDispatchOnChange) {
                        this.dispatchOnChange();
                    }
                }
            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange() {
                    this.onChange(this.values);
                }

                /**
                 * @param {string} value
                 */

            }, {
                key: "setDestinationInputValue",
                value: function setDestinationInputValue(value) {
                    this.view.$destinationInput.val(value);
                }

                /**
                 * @param {boolean} show
                 */

            }, {
                key: "toggleDestinationResetButton",
                value: function toggleDestinationResetButton(show) {
                    var $autocompleteWrapper = this.view.$destinationReset.parent();
                    $autocompleteWrapper.toggleClass('reset-visible', show);
                }
            }, {
                key: "renderCountriesList",
                value: function renderCountriesList() {
                    this.currentScreen = SCREEN_MAIN;
                    this.view.$countryItems.html(this.getCountriesListHtml());

                    this.view.$regionPanel.addClass('hidden');
                    var $countryPanel = this.view.$countryPanel;
                    $countryPanel.removeClass('hidden');

                    window.findFormModal.setTitle($countryPanel, this.messages.title, true);
                }

                /**
                 * Показать экран списка стран не выводя страны.
                 * e.g. Автокомплит с поиском в режиме "Только отели"
                 */

            }, {
                key: "renderCountriesListEmpty",
                value: function renderCountriesListEmpty() {
                    this.currentScreen = SCREEN_MAIN;
                    this.view.$countryItems.html('');

                    this.view.$regionPanel.addClass('hidden');
                    var $countryPanel = this.view.$countryPanel;
                    $countryPanel.removeClass('hidden');

                    var title = this.formMode === MODE_ALL ? this.messages.title : this.messages.titleHotel;
                    window.findFormModal.setTitle($countryPanel, title, true);
                    this.toggleBlocksOverlappingAutoCompleteScope(false);
                }
            }, {
                key: "renderRegionsListPanel",
                value: function renderRegionsListPanel() {
                    var _this9 = this;

                    this.currentScreen = SCREEN_REGION;
                    this.view.$destinationInput.prop('placeholder', this.messages.placeholderRegions);
                    this.view.$regionItems.html(this.getRegionsListHtml());
                    this.view.$countryPanel.addClass('hidden');
                    setTimeout(function () {
                        var $regionPanel = _this9.view.$regionPanel;
                        $regionPanel.removeClass('hidden');
                        var country = _this9.data.getCountry(_this9.values.countryId);
                        window.findFormModal.setTitle($regionPanel, country.name, true);
                        _this9.toggleBlocksOverlappingAutoCompleteScope(true);
                    }, 1);
                }

                /**
                 * @return {string}
                 * @private
                 */

            }, {
                key: "getRegionsListHtml",
                value: function getRegionsListHtml() {
                    var html = '';
                    var buttonItem = void 0;

                    var regions = this.data.getSortedRegions(this.values.countryId);
                    var country = this.data.getCountry(this.values.countryId);
                    var visaLabel = this.data.getVisa(country.visaType);
                    buttonItem = new ButtonItem(ITEM_REGION, REGION_ID_ALL, this.messages.allResorts + ', ' + country.name, visaLabel);
                    buttonItem.setCountry(this.values.countryId, country.code);
                    buttonItem.setCityId(this.values.departCityId);
                    buttonItem.asCheckbox();
                    html += this.view.renderRegionItem(buttonItem, this.values.regionIds.length === 0);

                    var popularRegionsCount = 3;
                    var i = void 0;
                    var region = void 0;
                    if (regions.length) {
                        html += this.view.renderListDividerItem(this.messages.groupPopularResorts);
                        for (i = 0; i < regions.length; i++) {
                            if (i === popularRegionsCount) {
                                html += this.view.renderListDividerItem(this.messages.groupOtherResorts);
                            }
                            region = regions[i];
                            buttonItem = new ButtonItem(ITEM_REGION, region.id, region.name, visaLabel);
                            buttonItem.setCountry(this.values.countryId, country.code);
                            buttonItem.setCityId(this.values.departCityId);
                            buttonItem.asCheckbox();
                            html += this.view.renderRegionItem(buttonItem, this.values.isRegionSelected(buttonItem.id));
                        }
                    }

                    return html;
                }

                /**
                 * @return {string}
                 * @private
                 */

            }, {
                key: "getCountriesListHtml",
                value: function getCountriesListHtml() {
                    var _getCities = this.getCities(),
                        currentCity = _getCities.currentCity,
                        alternativeCity = _getCities.alternativeCity;

                    var directions = this.data.getSortedSplitDirections(currentCity.id, alternativeCity ? alternativeCity.id : null);

                    // Начало группы "Остальные"
                    var popularCount = directions.popular.length;
                    // Начало группы "из Альтернативного города"
                    var otherCount = directions.other.length;
                    var otherStartsIndex = otherCount > 0 ? popularCount : null;
                    var alternativeStartsIndex = otherCount > 0 ? popularCount + otherCount : popularCount;
                    directions = directions.popular.concat(directions.other, directions.alternative);

                    var item = void 0;
                    var direction = void 0;
                    var html = this.view.renderListDividerItem(this.messages.groupPopularCountries);
                    for (var _i3 = 0; _i3 < directions.length; _i3++) {
                        if (_i3 === otherStartsIndex) {
                            html += this.view.renderListDividerItem(this.messages.groupOtherCountries);
                        } else if (_i3 === alternativeStartsIndex) {
                            html += this.view.renderListDividerItem(i18nTemplate(this.messages.groupFromCity, { cityName: alternativeCity.nameFrom }));
                        }
                        direction = directions[_i3];
                        item = new ButtonItem(ITEM_COUNTRY, direction.country.id, direction.country.name, this.data.getVisa(direction.country.visaType));
                        item.setCountry(direction.country.id, direction.country.code);
                        item.setCityId(direction.departCity.id);
                        html += this.view.renderCountryItem(item);
                    }

                    return html;
                }

                /**
                 * @param {string} slug
                 */

            }, {
                key: "onDestinationEnter",
                value: function onDestinationEnter(slug) {
                    var _this10 = this;

                    if (this.timers.input) {
                        clearTimeout(this.timers.input);
                    }
                    this.timers.input = setTimeout(function () {
                        _this10.searchDestination(slug);
                    }, this.debounceInputTime);
                }

                /**
                 * @param {string} slug
                 */

            }, {
                key: "searchDestination",
                value: function searchDestination(slug) {
                    var _this11 = this;

                    slug = slug.trim();
                    this.slug = slug;
                    if (slug === '') {
                        // Эмулируем нажатие на кнопку "Сбросить"
                        this.resetInputSelection();

                        // Отменяем запрос списка отелей
                        this.data.intelligentSearch.abortGetDestinationsRequest();
                        return;
                    }
                    this.toggleDestinationResetButton(true);

                    var type = this.getIntelligentSearchType();
                    this.data.intelligentSearch.getDestinations(slug, type, function (response) {
                        _this11.onDestinationsSearchResponse(response);
                    }, this.values.countryId);

                    var loadingMessage = this.formMode === MODE_ONLY_HOTELS ? this.messages.searchLoadingHotel : this.messages.searchLoadingAny;
                    this.$itemsTarget.html(this.view.renderLoadingItem(loadingMessage));
                }
            }, {
                key: "onDestinationsSearchResponse",
                value: function onDestinationsSearchResponse(response) {
                    if (this.slug !== response.query) {
                        return;
                    }
                    if (!response.success) {
                        // При ошибке пока выводим сообщение "Не найдено"
                        this.$itemsTarget.html(this.view.getAutoCompleteMessage(i18nTemplate(this.messages.noRequestMatches, {
                            match: this.messages.noMatch
                        })));
                        return;
                    }

                    this.processSearchResponse(response);
                }

                /**
                 * @private
                 * @param response
                 */

            }, {
                key: "processSearchResponse",
                value: function processSearchResponse(response) {
                    var query = response.query;
                    var result = response.result;

                    var matches = {
                        countries: [],
                        countriesAlt: [],
                        regions: [],
                        regionsAlt: [],
                        hotels: [],
                        hotelsAlt: []
                    };

                    var i = void 0;
                    var countryId = void 0;
                    var tmpButton = void 0;
                    var departCityId = void 0;
                    var isAlternative = void 0;

                    if (this.currentScreen === SCREEN_REGION || this.formMode === MODE_ONLY_HOTELS) {
                        result.countries = [];
                        if (this.formMode === MODE_ONLY_HOTELS) {
                            result.regions = [];
                        }
                    }

                    var _getCities2 = this.getCities(),
                        currentCity = _getCities2.currentCity,
                        alternativeCity = _getCities2.alternativeCity;

                    var fromAlternative = alternativeCity ? i18nTemplate(this.allMessages.fromCity, { fromCity: alternativeCity.nameFrom }) : '';
                    var alternativeCityId = alternativeCity ? alternativeCity.id : null;
                    if (this.formMode === MODE_ALL) {
                        var country = void 0;
                        for (i = 0; i < result.countries.length; i++) {
                            countryId = Number(result.countries[i].id);
                            if (!this.data.isCountryExists(countryId)) {
                                continue; // unavailable for select
                            }
                            // Нужен ли альтернативный город
                            departCityId = this.getAutocompleteItemCityId(countryId, currentCity.id, alternativeCityId);
                            isAlternative = departCityId !== currentCity.id;

                            country = this.data.countries[countryId];
                            tmpButton = new ButtonItem(ITEM_COUNTRY, countryId, country.name, this.data.getVisa(country.visaType) + (isAlternative ? ', ' + fromAlternative : ''));
                            tmpButton.setCountry(country.id, country.code);
                            tmpButton.setCityId(departCityId);
                            if (isAlternative) {
                                matches.countriesAlt.push(tmpButton);
                            } else {
                                matches.countries.push(tmpButton);
                            }
                        }

                        var regionId = void 0;
                        var region = void 0;
                        for (i = 0; i < result.regions.length; i++) {
                            regionId = Number(result.regions[i].id);
                            countryId = Number(result.regions[i].countryId);
                            if (!this.data.isRegionExists(countryId, regionId)) {
                                continue; // unavailable for select
                            }
                            // Нужен ли альтернативный город
                            departCityId = this.getAutocompleteItemCityId(countryId, currentCity.id, alternativeCityId);
                            isAlternative = departCityId !== currentCity.id;

                            region = this.data.regions[countryId][regionId];

                            var _country = this.data.countries[countryId];
                            tmpButton = new ButtonItem(ITEM_REGION, region.id, _country.name + ', ' + region.name, this.data.getVisa(_country.visaType) + (isAlternative ? ', ' + fromAlternative : ''));
                            tmpButton.setCountry(countryId, _country.code);
                            tmpButton.setCityId(departCityId);
                            if (isAlternative) {
                                matches.regionsAlt.push(tmpButton);
                            } else {
                                matches.regions.push(tmpButton);
                            }
                        }
                    }

                    var hotel = void 0;
                    var valueInfo = void 0;
                    for (i = 0; i < result.hotels.length; i++) {
                        hotel = result.hotels[i];
                        countryId = Number(hotel.country.id);
                        if (!this.data.countries.hasOwnProperty(countryId)) {
                            continue;
                        }

                        // Нужен ли альтернативный город
                        departCityId = this.getAutocompleteItemCityId(countryId, currentCity.id, alternativeCityId);
                        isAlternative = departCityId !== currentCity.id;

                        valueInfo = hotel.country.name + ', ' + hotel.region.name + (isAlternative ? ' ' + fromAlternative : '');
                        tmpButton = new ButtonItem(ITEM_HOTEL, hotel.id, hotel.name, valueInfo);
                        tmpButton.setCountry(countryId);
                        tmpButton.setCityId(this.values.departCityId);
                        tmpButton.setHotel(hotel.photo, hotel.stars);

                        if (isAlternative) {
                            matches.hotelsAlt.push(tmpButton);
                        } else {
                            matches.hotels.push(tmpButton);
                        }
                    }

                    this.renderDestinationSearchResult(query, matches);
                }

                /**
                 * @private
                 * @param {string} query
                 * @param {{
                 *     countries: ButtonItem[],
                 *     countriesAlt: ButtonItem[],
                 *     regions: ButtonItem[],
                 *     regionsAlt: ButtonItem[],
                 *     hotels: ButtonItem[],
                 *     hotelsAlt: ButtonItem[],
                 * }} matches
                 */

            }, {
                key: "renderDestinationSearchResult",
                value: function renderDestinationSearchResult(query, matches) {
                    var isFoundSomething = matches.countries.length || matches.countriesAlt.length || matches.regions.length || matches.regionsAlt.length || matches.hotels.length || matches.hotelsAlt.length;

                    if (isFoundSomething) {
                        matches.countries = matches.countries.concat(matches.countriesAlt);
                        matches.regions = matches.regions.concat(matches.regionsAlt);
                        matches.hotels = matches.hotels.concat(matches.hotelsAlt);
                        matches.countriesAlt = [];
                        matches.regionsAlt = [];
                        matches.hotelsAlt = [];

                        // countries
                        // let itemsHtml = matches.countries.length
                        //     ? this.view.renderListDividerItem(this.messages.groupCountries)
                        //     : '';
                        var itemsHtml = '';
                        for (i = 0; i < matches.countries.length; i++) {
                            itemsHtml += this.view.renderAutocompleteItem(matches.countries[i]);
                        }
                        // regions
                        // itemsHtml += matches.regions.length
                        //     ? this.view.renderListDividerItem(this.messages.groupResorts)
                        //     : '';
                        for (i = 0; i < matches.regions.length; i++) {
                            itemsHtml += this.view.renderAutocompleteItem(matches.regions[i]);
                        }
                        // hotels
                        // itemsHtml += matches.hotels.length
                        //     ? this.view.renderListDividerItem(this.messages.groupHotels)
                        //     : '';
                        for (i = 0; i < matches.hotels.length; i++) {
                            itemsHtml += this.view.renderHotelItem(matches.hotels[i]);
                        }

                        this.$itemsTarget.html(itemsHtml);
                    } else {
                        var messageText = '';
                        if (this.formMode === MODE_ONLY_HOTELS) {
                            if (query.length < HOTEL_SEARCH_MIN_LENGTH) {
                                messageText = i18nTemplate(this.messages.minRequestLength, {
                                    min: HOTEL_SEARCH_MIN_LENGTH
                                });
                            }
                        }

                        if (messageText === '') {
                            var noMatchType = void 0;
                            if (this.formMode === MODE_ALL) {
                                noMatchType = this.currentScreen === SCREEN_REGION ? this.messages.noMatchResorts : this.messages.noMatchAny;
                            } else {
                                noMatchType = this.messages.noMatchHotels;
                            }
                            messageText = i18nTemplate(this.messages.noRequestMatches, {
                                match: noMatchType
                            });

                            var reqCountryId = this.values.countryId;
                            if (reqCountryId) {
                                var reqCountryName = this.data.countries[reqCountryId].name;
                                // Страна: {reqCountryName}
                                messageText += " (" + this.messages.reqCountry + ": " + reqCountryName + ")";
                                if (this.currentScreen === SCREEN_REGION) {
                                    // TODO: предложить искать по всем странам/выбрать другую страну
                                }
                            }
                        }

                        this.$itemsTarget.html(this.view.getAutoCompleteMessage(messageText));
                    }
                }
            }, {
                key: "getIntelligentSearchType",
                value: function getIntelligentSearchType() {
                    var types = this.data.intelligentSearch.types;
                    if (this.formMode === MODE_ONLY_HOTELS) {
                        return types.hotels;
                    }

                    return this.currentScreen === SCREEN_REGION ? types.regionsAndHotels : types.all;
                }

                /**
                 * @return {{alternativeCity: (SearchFormDataCity), currentCity: (SearchFormDataCity|null)}}
                 */

            }, {
                key: "getCities",
                value: function getCities() {
                    var currentCity = this.data.getCity(this.values.departCityId);
                    return {
                        currentCity: currentCity,
                        alternativeCity: currentCity.altId ? this.data.getCity(currentCity.altId) : null
                    };
                }

                /**
                 * @param {number} countryId
                 * @param {number} currentCityId
                 * @param {number} alternativeCityId
                 * @return {number}
                 */

            }, {
                key: "getAutocompleteItemCityId",
                value: function getAutocompleteItemCityId(countryId, currentCityId, alternativeCityId) {
                    var key = countryId + "_" + currentCityId + "_" + alternativeCityId;
                    // кешируем проверки. TODO: move to SearchFormData
                    var cachedCityId = this.autocomplete.cacheItemCity[key] || null;
                    if (cachedCityId !== null) {
                        return cachedCityId;
                    }

                    var cityId = currentCityId;
                    if (alternativeCityId && !this.data.isCountryDirectionAvailable(countryId, currentCityId) && this.data.isCountryDirectionAvailable(countryId, alternativeCityId)) {
                        cityId = alternativeCityId;
                    }

                    this.autocomplete.cacheItemCity[key] = cityId;
                    return cityId;
                }
            }, {
                key: "messages",
                get: function get() {
                    return this.allMessages.destination;
                }
            }, {
                key: "$itemsTarget",
                get: function get() {
                    return this.currentScreen === SCREEN_MAIN ? this.view.$countryItems : this.view.$regionItems;
                }
            }]);

            return FindFormDestination;
        }();

        window.FindFormDestination = FindFormDestination;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var _require2 = require('../../include/_js/ui/date/Datepicker'),
            Datepicker = _require2.Datepicker,
            datepickerModes = _require2.datepickerModes;

        var CalendarSettings = require('../../include/_js/ui/date/calendar/CalendarSettings');

        var MODAL_ID = 'search-form-calendar-modal';

        var today = new Date();
        today.setHours(0, 0, 0, 0);

        var i18nPlural = window.brxUtils.i18n.plural;
        var i18nTemplate = window.brxUtils.i18n.template;

        var translates = window.findFormTranslates;

        // Период доступный для выбора в календаре
        function createCalendarDateBounds() {
            var renderMonths = 6;
            var minDate = new Date();
            // + renderMonths месяцев. В maxDate последний день месяца maxDate
            var maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths + 1, 0);
            minDate.setHours(0, 0, 0, 0);
            maxDate.setHours(23, 59, 59);
            return { minDate: minDate, maxDate: maxDate };
        }

        var dateUtils = {
            /**
             * @param {Date} date1
             * @param {Date} date2
             * @return {boolean}
             */
            isSameMonth: function isSameMonth(date1, date2) {
                return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
            },
            /**
             * @param {Date} date1
             * @param {Date} date2
             * @return {boolean}
             */
            isSameDate: function isSameDate(date1, date2) {
                return dateUtils.isSameMonth(date1, date2) && date1.getDate() === date2.getDate();
            }
        };

        var FindFormCalendar = function () {
            /**
             * @param {{
             *  containerId: string,
             *  values: SearchFormValues,
             *  onChange: Function,
             *  getDateRangeLabel: Function,
             *  messages: { months: string[], dayNames: string[] },
             * }} params
             */
            function FindFormCalendar(params) {
                _classCallCheck(this, FindFormCalendar);

                this.containerId = params.containerId;
                this.onChange = params.onChange;
                this.getDateRangeLabel = params.getDateRangeLabel;
                this.availableDates = [];
                this.params = params.values;
                this.values = {
                    selectedDate: params.values.selectedDate,
                    isSoftDates: params.values.isSoftDates
                };
                this.rangeDays = params.values.rangeDays;
                this.messages = {
                    labelBtnApply: translates.labelBtnApply,
                    calendar: {
                        months: params.messages.months,
                        dayNames: params.messages.dayNames
                    }
                };
                /** @type {Datepicker|null} */
                this.datepicker = null;
            }

            /**
             * @param {Date} selectedDate
             * @param {boolean} isSoftDates
             */


            _createClass(FindFormCalendar, [{
                key: "setSelectedDate",
                value: function setSelectedDate(selectedDate, isSoftDates) {
                    var values = this.values;
                    var isDateChanged = !dateUtils.isSameDate(values.selectedDate, selectedDate);
                    if (isDateChanged || values.isSoftDates !== isSoftDates) {
                        this.values.selectedDate = selectedDate;
                        this.values.isSoftDates = isSoftDates;
                        this.dispatchOnChange();
                    }
                }

                /** @param {boolean} isSoftDates */

            }, {
                key: "setIsSoftDates",
                value: function setIsSoftDates(isSoftDates) {
                    if (this.values.isSoftDates === isSoftDates) {
                        return;
                    }
                    this.values.isSoftDates = isSoftDates;
                    this.dispatchOnChange();
                }

                /** @private */

            }, {
                key: "canSelectDate",


                /**
                 * Можно ли выбрать указанную дату в календаре
                 * @param {Date} date
                 */
                value: function canSelectDate(date) {
                    var _createCalendarDateBo = createCalendarDateBounds(),
                        minDate = _createCalendarDateBo.minDate,
                        maxDate = _createCalendarDateBo.maxDate;

                    return date.getTime() >= minDate.getTime() && date.getTime() <= maxDate.getTime();
                }

                /**
                 * @param {{
                 *     calendarTitle: string,
                 *     daysRangeLabel: string,
                 *     availableDates: string[],
                 *     onAfterInit: Function,
                 * }} settings
                 */

            }, {
                key: "open",
                value: function open(settings) {
                    var _this12 = this;

                    var $template = $('#sf-calendar-header-template');
                    var headerHTML = i18nTemplate($template.html(), {
                        labelDateDiff: settings.daysRangeLabel,
                        diffChecked: this.values.isSoftDates ? 'checked' : ''
                    });
                    var modal = window.findFormModal;
                    modal.open({
                        id: MODAL_ID,
                        header: {
                            title: settings.calendarTitle,
                            html: headerHTML
                        },
                        content: {
                            html: '<div id="' + this.containerId + '" class="find-form-datepicker-panel"></div>',
                            theme: modal.themes.SECONDARY
                        },
                        footer: {
                            buttonLabel: this.messages.labelBtnApply,
                            theme: modal.themes.SECONDARY
                        },
                        fixContentMaxHeight: true,
                        onAfterShow: function onAfterShow() {
                            var $switchInput = $('#search-form-calendar-days-switch');
                            $switchInput.on('change', function (e) {
                                var checkbox = e.currentTarget;
                                _this12.setIsSoftDates(checkbox.checked);
                            });
                            _this12.renderSummaryLabel();
                            var availableDates = settings.availableDates;
                            _this12.setAvailableDates(availableDates);
                            _this12.init(_this12.values.selectedDate, _this12.values.isSoftDates);
                            settings.onAfterInit(_this12);
                        },
                        onBeforeClose: function onBeforeClose() {
                            _this12.destroy();
                        }
                    });
                }

                /**
                 * @param {string[]} dates
                 */

            }, {
                key: "setAvailableDates",
                value: function setAvailableDates(dates) {
                    this.availableDates = dates;
                }

                /**
                 * @param {string[]} loadedDates
                 */

            }, {
                key: "setLoadedAvailableDates",
                value: function setLoadedAvailableDates(loadedDates) {
                    // Если есть данные о датах вылета по направлению
                    if (loadedDates.length
                    // Доступен ли календарь. Календарь может быть удален
                    // в onBeforeClose до завершения загрузки данных
                    && this.isReady()) {
                        this.setAvailableDates(loadedDates);
                        this.refresh();
                    }
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    this.datepicker.refresh();
                    this.markSelectedRange();
                }
            }, {
                key: "isReady",
                value: function isReady() {
                    return this.values.selectedDate !== null && this.datepicker;
                }
            }, {
                key: "markSelectedRange",
                value: function markSelectedRange() {
                    var selectedDate = this.datepicker.selectedDate;
                    var isRange = this.values.isSoftDates;
                    var startDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), isRange ? selectedDate.getDate() - this.rangeDays : selectedDate.getDate());
                    var rangeCellsCount = isRange ? this.rangeDays * 2 + 1 : 1;
                    this.datepicker.markRange(startDate, rangeCellsCount);
                }

                /** @private */

            }, {
                key: "destroy",
                value: function destroy() {
                    if (this.datepicker) {
                        this.datepicker.destroy();
                        this.datepicker = null;
                    }
                    this.availableDates = [];
                    this.datepicker = null;
                }

                /**
                 * @private
                 * @param {Date} selectedDate
                 * @param {boolean} isSoftDates
                 */

            }, {
                key: "init",
                value: function init(selectedDate, isSoftDates) {
                    var _this13 = this;

                    this.values.selectedDate = selectedDate;
                    this.values.isSoftDates = isSoftDates;

                    var _createCalendarDateBo2 = createCalendarDateBounds(),
                        minDate = _createCalendarDateBo2.minDate,
                        maxDate = _createCalendarDateBo2.maxDate;
                    // TODO: include selected date in range


                    var calendarSettings = new CalendarSettings({
                        minDate: minDate,
                        maxDate: maxDate,
                        showYear: true,
                        showEmptyDate: false,
                        messages: {
                            monthNames: this.messages.calendar.months,
                            weekDayNamesShort: this.messages.calendar.dayNames
                        },
                        /** @param {Date} date */
                        getDateCellCustomCssClass: function getDateCellCustomCssClass(date) {
                            var unselectDisableCalendarDateClasses = 'brx-calendar__date-disabled ';

                            if (_this13.availableDates.length === 0) {
                                return '';
                            }

                            // if (this.params.selectedHotel && this.params.selectedHotel.id) {
                            //     // Если в форме выбрали конкретный отель, то мы даем возможность выбрать любые будущие даты
                            //     // несмотря на отсутствие цен
                            //     unselectDisableCalendarDateClasses = '';
                            // }

                            return _this13.isDepartDateAvailable(date) ? 'available-date' : unselectDisableCalendarDateClasses + 'unavailable-date';
                        }
                    });
                    this.datepicker = new Datepicker({
                        containerId: this.containerId,
                        selectedDate: this.values.selectedDate,
                        viewMode: datepickerModes.FULL_RANGE,
                        onChange: function onChange(date) {
                            _this13.values.selectedDate = date;
                            _this13.dispatchOnChange();
                        }
                        // onChangeMonth: () => { this.markSelectedRange(); },
                    }, calendarSettings);

                    this.datepicker.init();
                    this.markSelectedRange();
                }

                /** @private */

            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange() {
                    this.onChange(this.values.selectedDate, this.values.isSoftDates);
                    if (this.isReady()) {
                        this.markSelectedRange();
                        this.renderSummaryLabel();
                    }
                }

                /**
                 * @private
                 * @param {Date} date
                 * @return {boolean}
                 */

            }, {
                key: "isDepartDateAvailable",
                value: function isDepartDateAvailable(date) {
                    if (!this.datepicker.isDateInRange(date)) {
                        return false;
                    }

                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);
                    var dateString = day + '.' + month + '.' + date.getFullYear();

                    return !this.availableDates.length || this.availableDates.indexOf(dateString) !== -1;
                }

                /** @private */

            }, {
                key: "renderSummaryLabel",
                value: function renderSummaryLabel() {
                    this.$summary.text(this.getDateRangeLabel());
                }
            }, {
                key: "$summary",
                get: function get() {
                    return $('#' + MODAL_ID + ' .calendar-summary');
                }
            }]);

            return FindFormCalendar;
        }();

        window.FindFormCalendar = FindFormCalendar;
    }, { "../../include/_js/ui/date/Datepicker": 2, "../../include/_js/ui/date/calendar/CalendarSettings": 4 }], 2: [function (require, module, exports) {
        var CalendarMonth = require('./calendar/CalendarMonth');

        var DATE_IN_RAGE = 'date-in-range';
        var DATE_IN_RAGE_START = 'date-in-range-start';
        var DATE_IN_RAGE_END = 'date-in-range-end';
        var DATE_SELECTED = 'selected';
        var DATE_SELECTED_ONE = 'selected--one'; // Для удобства оформления

        // TODO: вместо MODE, нужно
        // {
        // monthsPerView: number, // Сколько месяцев видимы
        // pageSize|stepMonths: number, // На какое кол-во месяцев двигаться при переключении назад/вперед
        // }
        var MODE_FULL_RANGE = 'range'; // Сразу весь календарь по от minDate до maxDate
        var MODE_SINGLE_MONTH = 'single'; // Только 1 месяц

        var Datepicker = function () {
            /**
             * @param {{
             *  containerId: string,
             *  selectedDate: Date,
             *  viewMode: string,
             *  allowOnceDispatchChangeOnSelected?: boolean,
             *  onChange: Function,
             *  onChangeMonth: Function|null
             * }} params
             * @param {CalendarSettings|null} calendarSettings
             */
            function Datepicker(params) {
                var calendarSettings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                _classCallCheck(this, Datepicker);

                this.containerId = params.containerId;
                this.$container = $('#' + this.containerId);
                this.$container.addClass('brx-datepicker-container');
                this.viewMode = params.viewMode;

                this.calendar = new CalendarMonth(calendarSettings);

                // т.к. календарь не умеет обрабатывать состояние "Не выбрано"
                this.allowOnceDispatchChangeOnSelected = params.allowOnceDispatchChangeOnSelected;
                this.selectedDate = params.selectedDate;
                // Видимый месяц, отсчет идет от него
                this.currentMonth = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);
                // if (!this.isDateInRange(this.selectedDate)) {
                //     // TODO:
                // }

                this.on = {
                    /** @type {null|Function} */
                    change: 'onChange' in params ? params.onChange : null,
                    /** @type {null|Function} */
                    changeMonth: 'changeMonth' in params ? params.changeMonth : null
                };

                /**
                 * @type {{$calendar: jQuery|null, $controls: jQuery|null}}
                 */
                this.elements = {
                    $calendar: null,
                    $controls: null
                };
            }

            _createClass(Datepicker, [{
                key: "init",
                value: function init() {
                    this.renderContainer();
                    this.elements = {
                        $calendar: this.$container.find('.brx-datepicker__content'),
                        $controls: this.$container.find('.brx-datepicker__controls')
                    };
                    this.renderCalendar();
                    this.setSelected();
                    this.bindEventListeners();
                    if (this.viewMode === MODE_SINGLE_MONTH) {
                        this.checkChangeMonthControlsState();
                    }
                }
            }, {
                key: "refresh",
                value: function refresh() {
                    this.renderCalendar();
                    this.setSelected();
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.$container.remove();
                }
            }, {
                key: "setSelected",
                value: function setSelected() {
                    this.elements.$calendar.find('.' + DATE_SELECTED).removeClass(DATE_SELECTED);
                    this.getCell(this.selectedDate).addClass(DATE_SELECTED);
                }

                /**
                 * @param {Date} date
                 * @return {jQuery}
                 */

            }, {
                key: "getCell",
                value: function getCell(date) {
                    var dateStrValue = this.calendar.dateToStringValue(date);
                    return this.elements.$calendar.find('.brx-calendar__date-button[data-date="' + dateStrValue + '"]');
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this14 = this;

                    this.elements.$calendar.on('click', '.brx-calendar__date-button', function (e) {
                        var $cellButton = $(e.currentTarget);
                        var $dateCell = $cellButton.parent();
                        if ($dateCell.hasClass('brx-calendar__date-disabled') || $dateCell.hasClass('brx-calendar__date-empty')) {
                            return;
                        }
                        if (_this14.allowOnceDispatchChangeOnSelected || !$cellButton.hasClass(DATE_SELECTED)) {
                            _this14.allowOnceDispatchChangeOnSelected = false;
                            var dateValue = $cellButton.data('date');
                            if (dateValue) {
                                _this14.selectedDate = _this14.calendar.getDateFromValue(dateValue);
                                _this14.dispatchOnChange();
                            }
                        }
                    });
                    if (this.viewMode === MODE_SINGLE_MONTH) {
                        this.elements.$controls.on('click', '.brx-datepicker__control', function (e) {
                            var $button = $(e.currentTarget);
                            if ($button.hasClass('previous')) {
                                _this14.renderPrevMonth();
                            } else {
                                _this14.renderNextMonth();
                            }
                            _this14.checkChangeMonthControlsState();
                            if (_this14.currentMonth.getMonth() === _this14.selectedDate.getMonth() && _this14.currentMonth.getFullYear() === _this14.selectedDate.getFullYear()) {
                                _this14.setSelected();
                            }
                        });
                    }
                }
            }, {
                key: "checkChangeMonthControlsState",
                value: function checkChangeMonthControlsState() {
                    var isPrevButtonDisabled = this.settings.minDate && this.isSameMonth(this.currentMonth, this.settings.minDate);
                    var isNextButtonDisabled = this.settings.maxDate && this.isSameMonth(this.currentMonth, this.settings.maxDate);

                    var $prev = this.elements.$controls.find('.previous');
                    var $next = this.elements.$controls.find('.next');
                    $prev.toggleClass('disabled', isPrevButtonDisabled);
                    $next.toggleClass('disabled', isNextButtonDisabled);
                }
            }, {
                key: "renderContainer",
                value: function renderContainer() {
                    this.$container.html('<div class="brx-datepicker__container">' + '<div class="brx-datepicker__controls">' + '<div class="brx-datepicker__control previous" role="button"><span class="sr-only">Предыдущий</span></div>' + '<div class="brx-datepicker__control next" role="button"><span class="sr-only">Следующий</span></div>' + '</div>' + '<div class="brx-datepicker__content"></div>' + '</div>');
                }
            }, {
                key: "renderCalendar",
                value: function renderCalendar() {
                    if (this.viewMode === MODE_SINGLE_MONTH) {
                        this._renderCurrentMonthCalendar();
                    } else if (this.viewMode === MODE_FULL_RANGE) {
                        this._renderCalendarFullRange();
                    }
                }
            }, {
                key: "renderNextMonth",
                value: function renderNextMonth() {
                    if (this.viewMode !== MODE_SINGLE_MONTH) {
                        return;
                    }
                    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() + 1, 1);
                    this.renderCalendar();
                    if (this.on.changeMonth) this.on.changeMonth();
                }
            }, {
                key: "renderPrevMonth",
                value: function renderPrevMonth() {
                    if (this.viewMode !== MODE_SINGLE_MONTH) {
                        return;
                    }
                    this.currentMonth = new Date(this.currentMonth.getFullYear(), this.currentMonth.getMonth() - 1, 1);
                    this.renderCalendar();
                    if (this.on.changeMonth) this.on.changeMonth();
                }
            }, {
                key: "_renderCurrentMonthCalendar",
                value: function _renderCurrentMonthCalendar() {
                    this.elements.$calendar.html(this.calendar.renderMonth(this.currentMonth.getMonth(), this.currentMonth.getFullYear()));
                }
            }, {
                key: "_renderCalendarFullRange",
                value: function _renderCalendarFullRange() {
                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;
                    if (minDate === null || maxDate === null) {
                        // Если ограничение не задано, выводим ограниченное кол-во месяцев
                        var renderMonths = 6;
                        minDate = new Date();
                        maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + renderMonths + 1, 0);
                        if (maxDate.getTime() < this.selectedDate.getTime()) {
                            var selectedDate = this.selectedDate;
                            maxDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
                        }
                    }
                    // Отрисовать календарь до указанного месяца, исключая renderTillMonth
                    var renderTillMonth = new Date(maxDate.getFullYear(), maxDate.getMonth() + 1, 1);

                    var renderFromMonth = new Date(minDate.getFullYear(), minDate.getMonth(), 1);
                    var calendarHtml = '';
                    do {
                        calendarHtml += this.calendar.renderMonth(renderFromMonth.getMonth(), renderFromMonth.getFullYear());
                        renderFromMonth = new Date(renderFromMonth.getFullYear(), renderFromMonth.getMonth() + 1, 1);
                    } while (!this.isSameMonth(renderFromMonth, renderTillMonth));
                    this.elements.$calendar.html(calendarHtml);

                    this.scrollToActiveMonth();
                }

                /**
                 * vertical orientation only
                 */

            }, {
                key: "scrollToActiveMonth",
                value: function scrollToActiveMonth() {
                    var $firstDateCell = this.getCell(this.currentMonth);
                    var $month = $firstDateCell.closest('.brx-calendar__wrapper');
                    window.scrollToElement($month, this.getContainerOffsetTop(), 0);
                }
            }, {
                key: "getContainerOffsetTop",
                value: function getContainerOffsetTop() {
                    if (!this.containerOffsetTop) {
                        var $datepickerContainer = this.$container.find('.brx-datepicker__container');
                        if ($datepickerContainer.length) {
                            this.containerOffsetTop = $datepickerContainer[0].offsetTop;
                        } else {
                            this.containerOffsetTop = 50;
                        }
                    }

                    return this.containerOffsetTop;
                }

                /**
                 * @param {Date} startDate
                 * @param {number} rangeCellsCount - кол-во ячеек для маркировки диапозона
                 */

            }, {
                key: "markRange",
                value: function markRange(startDate, rangeCellsCount) {
                    this.$container.find('.' + DATE_IN_RAGE).removeClass(DATE_IN_RAGE + ' ' + DATE_IN_RAGE_START + ' ' + DATE_IN_RAGE_END + ' ' + DATE_SELECTED_ONE);
                    if (rangeCellsCount > 1) {
                        for (var _i4 = 0; _i4 < rangeCellsCount; _i4++) {
                            var cssClass = DATE_IN_RAGE;
                            if (_i4 === 0 || this.isRangeStartDate(startDate)) {
                                cssClass += ' ' + DATE_IN_RAGE_START;
                            }
                            if (_i4 === rangeCellsCount - 1 || this.isRangeEndDate(startDate)) {
                                cssClass += ' ' + DATE_IN_RAGE_END;
                            }
                            if (this.isDateInRange(startDate)) {
                                this.getCell(startDate).addClass(cssClass);
                            }
                            startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1);
                        }
                    } else {
                        this.getCell(startDate).addClass(DATE_IN_RAGE + ' ' + DATE_IN_RAGE_START + ' ' + DATE_IN_RAGE_END + ' ' + DATE_SELECTED_ONE);
                    }
                }
            }, {
                key: "isSameMonth",
                value: function isSameMonth(date1, date2) {
                    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth();
                }
            }, {
                key: "isSameDate",
                value: function isSameDate(date1, date2) {
                    return this.isSameMonth(date1, date2) && date1.getDate() === date2.getDate();
                }

                /**
                 * Проверяет входит ли дата в заданный диапазон ограничений
                 * Если ограничения не заданы - вернет true
                 * @param {Date} date
                 */

            }, {
                key: "isDateInRange",
                value: function isDateInRange(date) {
                    var settings = this.calendar.settings;
                    return !(settings.minDate && settings.minDate.getTime() > date.getTime() || settings.maxDate && settings.maxDate.getTime() < date.getTime());
                }

                /** @param {Date} date */

            }, {
                key: "isRangeStartDate",
                value: function isRangeStartDate(date) {
                    var minDate = this.settings.minDate || null;
                    // Первый день месяца или начало доступного диапазона
                    return date.getDate() === 1 || minDate && this.isSameDate(date, minDate);
                }

                /** @param {Date} date */

            }, {
                key: "isRangeEndDate",
                value: function isRangeEndDate(date) {
                    var maxDate = this.settings.maxDate || null;
                    if (maxDate && this.isSameDate(date, maxDate)) {
                        // Последний день доступного диапазона
                        return true;
                    }
                    // Последний день месяца
                    var lastDateOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    return lastDateOfMonth.getDate() === date.getDate();
                }
            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange() {
                    if (this.on.change !== null) {
                        this.on.change(this.selectedDate);
                    }
                    this.setSelected();
                }
            }, {
                key: "settings",
                get: function get() {
                    return this.calendar.settings;
                }
            }]);

            return Datepicker;
        }();

        module.exports = {
            Datepicker: Datepicker,
            datepickerModes: {
                SINGLE: MODE_SINGLE_MONTH,
                FULL_RANGE: MODE_FULL_RANGE
            }
        };
    }, { "./calendar/CalendarMonth": 3 }], 3: [function (require, module, exports) {
        var _require3 = require('./calendar-labels-ru'),
            monthNames = _require3.monthNames,
            weekDayNamesShort = _require3.weekDayNamesShort;

        var CalendarSettings = require('./CalendarSettings');

        var CalendarMonth = function () {
            /**
             * @param {CalendarSettings|null} settings
             */
            function CalendarMonth() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                _classCallCheck(this, CalendarMonth);

                /** @type {CalendarSettings} */
                this.settings = settings !== null ? settings : new CalendarSettings();
                var messages = this.settings.messages;
                this.monthNames = messages ? messages.monthNames : monthNames;
                this.weekDayNamesShort = messages ? messages.weekDayNamesShort : weekDayNamesShort;
            }

            /**
             * @param {number} month - 0-11
             * @param {number} fullYear
             * @return {string}
             */


            _createClass(CalendarMonth, [{
                key: "renderMonth",
                value: function renderMonth(month, fullYear) {
                    var baseDate = new Date(fullYear, month, 1);
                    // Первый день месяца
                    var firstDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
                    // последний день месяца
                    var lastDateOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
                    // Последний день предыдущего месяца
                    var lastDateOfPrevMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0);

                    var firstDay = this.settings.firstDay;

                    var i = void 0;
                    var weekDay = void 0;
                    var weekDaysCellsHtml = '';
                    var startWeekDay = null;
                    var endWeekDay = null;
                    for (i = 0; i < 7; i++) {
                        weekDay = i + firstDay;
                        weekDay = weekDay > 6 ? weekDay - 7 : weekDay;
                        if (startWeekDay === null) {
                            startWeekDay = weekDay;
                        }
                        endWeekDay = weekDay;
                        weekDaysCellsHtml += '<td class="brx-calendar__day-name">' + this.weekDayNamesShort[i] + '</td>';
                    }

                    // Пустые клетки предыдущего месяца
                    var prevMonthEmptyCellCount = firstDateOfMonth.getDay() - firstDay;
                    if (prevMonthEmptyCellCount < 0) {
                        prevMonthEmptyCellCount = prevMonthEmptyCellCount + 7;
                    }
                    // Пустые клетки следующего месяца
                    // Если месяц заканчивается последним дней недели - 0
                    var nextMonthEmptyCellCount = lastDateOfMonth.getDay() === endWeekDay ? 0 : 7 + 1 - lastDateOfMonth.getDay() - firstDay;
                    // Кол-во дней в календаре
                    var datesCount = prevMonthEmptyCellCount + nextMonthEmptyCellCount + lastDateOfMonth.getDate();

                    // День предыдущего месяца, с которого начинается календарь
                    var prevMonthStartDate = lastDateOfPrevMonth.getDate() - prevMonthEmptyCellCount + 1;
                    // Начинаем рисовать с этой даты
                    var dateInstance = new Date(lastDateOfPrevMonth.getFullYear(), lastDateOfPrevMonth.getMonth(), prevMonthStartDate);
                    // dataInstance.getDay() === startWeekDay // Должно быть true

                    var calendarDatesHtml = '';
                    var rowHtml = '';
                    for (i = 0; i < datesCount; i++) {
                        rowHtml += this.getDateCell(dateInstance, dateInstance.getMonth() !== baseDate.getMonth());
                        if (endWeekDay === dateInstance.getDay()) {
                            // Конец недели
                            calendarDatesHtml += '<tr class="brx-calendar__row">' + rowHtml + '</tr>';
                            rowHtml = '';
                        }
                        // сдвигаем дату на след. день
                        dateInstance = new Date(dateInstance.getFullYear(), dateInstance.getMonth(), dateInstance.getDate() + 1);
                    }

                    var monthLabel = this.monthNames[baseDate.getMonth()] + (this.settings.showYear ? ' ' + baseDate.getFullYear() : '');
                    return '<div class="brx-calendar__wrapper">' + '<div class="brx-calendar__month">' + monthLabel + '</div>' + '<table class="brx-calendar__dates">' + '<thead><tr class="brx-calendar__row">' + weekDaysCellsHtml + '</tr></thead>' + '<tbody>' + calendarDatesHtml + '</tbody>' + '</table>' + '</div>';
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {string} - table cell html
                 */

            }, {
                key: "getDateCell",
                value: function getDateCell(date, empty) {
                    var today = new Date();
                    var settings = this.getDateSettings(date, empty);

                    var classList = 'brx-calendar__date' + (empty ? ' brx-calendar__date-empty' : '');

                    var minDate = this.settings.minDate;
                    var maxDate = this.settings.maxDate;

                    var disabled = empty;
                    if (minDate && minDate.getTime() > date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }
                    if (maxDate && maxDate.getTime() < date.getTime()) {
                        classList += ' brx-calendar__date-disabled';
                        disabled = true;
                    }

                    if (date.getMonth() === today.getMonth() && date.getDate() === today.getDate() && date.getFullYear() === today.getFullYear()) {
                        classList += ' today';
                    }
                    classList += settings.cssClass !== '' ? ' ' + settings.cssClass : '';

                    return '<td class="' + classList + '">' + (empty && !this.settings.showEmptyDate ? '&nbsp;' : this.renderDateCellButton(date)) + '</td>';
                }

                /**
                 * @private
                 * @param {Date} date
                 */

            }, {
                key: "renderDateCellButton",
                value: function renderDateCellButton(date) {
                    var dateStringValue = this.dateToStringValue(date);
                    return "<button type=\"button\"\n                        class=\"brx-calendar__date-button\"\n                        data-date=\"" + dateStringValue + "\"\n                        data-date-day=\"" + date.getDate() + "\">" + date.getDate() + "</button>";
                }

                /**
                 * @param {Date} date
                 * @param {boolean} [empty]
                 * @return {{cssClass: string}}
                 * @private
                 */

            }, {
                key: "getDateSettings",
                value: function getDateSettings(date, empty) {
                    var cssClass = this.settings.getDateCellCustomCssClass ? this.settings.getDateCellCustomCssClass(date, empty) : '';
                    return { cssClass: cssClass };
                }

                /**
                 * Формат значения в data-date
                 * @param {Date} date
                 * @return {string}
                 */

            }, {
                key: "dateToStringValue",
                value: function dateToStringValue(date) {
                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);

                    return day + '.' + month + '.' + date.getFullYear();
                }

                /**
                 * relates to this.dateToStringValue()
                 * @param {string} dateStringValue - Формат как и в dateToStringValue
                 * @return {Date}
                 */

            }, {
                key: "getDateFromValue",
                value: function getDateFromValue(dateStringValue) {
                    var values = dateStringValue.split('.');
                    return new Date(values[2], values[1] - 1, values[0]);
                }
            }]);

            return CalendarMonth;
        }();

        module.exports = CalendarMonth;
    }, { "./CalendarSettings": 4, "./calendar-labels-ru": 5 }], 4: [function (require, module, exports) {
        var CalendarSettings = function () {
            /**
             * @param {{}} settings
             */
            function CalendarSettings() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                _classCallCheck(this, CalendarSettings);

                /**
                 * @type {boolean}
                 */
                this.showYear = false;
                /**
                 * @type {boolean}
                 */
                this.showEmptyDate = false;
                /**
                 * @type {number}
                 */
                this.firstDay = 1;

                /**
                 * @type {Function|null}
                 */
                this.getDateCellCustomCssClass = null;

                /**
                 * @type {Date|null}
                 */
                this.minDate = null;
                /**
                 * @type {Date|null}
                 */
                this.maxDate = null;

                /**
                 * @type {{ monthNames: string[], weekDayNamesShort: string[] }|null}
                 */
                this.messages = null;

                this.load(settings);
            }

            _createClass(CalendarSettings, [{
                key: "load",
                value: function load(settings) {
                    if (!settings || (typeof settings === "undefined" ? "undefined" : _typeof(settings)) !== 'object') {
                        return false;
                    }
                    if (settings.hasOwnProperty('showYear')) {
                        this.showYear = !!settings.showYear;
                    }
                    if (settings.hasOwnProperty('showEmptyDate')) {
                        this.showEmptyDate = !!settings.showEmptyDate;
                    }
                    if (typeof settings.getDateCellCustomCssClass === 'function') {
                        this.getDateCellCustomCssClass = settings.getDateCellCustomCssClass;
                    }
                    if (settings.minDate instanceof Date) {
                        this.minDate = settings.minDate;
                        this.minDate.setHours(0, 0, 0, 0);
                    }
                    if (settings.maxDate instanceof Date) {
                        this.maxDate = settings.maxDate;
                        this.maxDate.setHours(23, 59, 59);
                    }

                    if (settings.messages) {
                        var _settings$messages = settings.messages,
                            monthNames = _settings$messages.monthNames,
                            weekDayNamesShort = _settings$messages.weekDayNamesShort;

                        if (monthNames && monthNames.length === 12 && weekDayNamesShort && weekDayNamesShort.length === 7) {
                            this.messages = settings.messages;
                        } else {
                            console.warn('missing required i18n messages. Ignored');
                        }
                    }

                    return true;
                }
            }, {
                key: "validate",
                value: function validate() {
                    if (this.orientation === 'vertical') {
                        if (!this.minDate || !this.maxDate) {
                            throw new Error('missing required fields: minDate & maxDate');
                        }
                    }

                    if (this.minDate && this.maxDate && this.maxDate.getTime() < this.minDate.getTime()) {
                        throw new Error('invalid date range');
                    }
                }
            }]);

            return CalendarSettings;
        }();

        module.exports = CalendarSettings;
    }, {}], 5: [function (require, module, exports) {
        module.exports = {
            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
            monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
            weekDayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
            weekDayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * Slider - Ползунок для выбора значений с возможностью выбирать range
         * @class
         * @prop {string} selector - селектор для DOM со слайдером
         * @prop {Array} values - массив с текущими значениями, сколько значений передадите, столько хэндлов на слайдере и будет
         * @prop {number} min=0 - минимальное значение слайдера
         * @prop {number} max=100 - максимальное значение слайдера
         * @prop {Function} onSlide - срабатывает на каждое перемещение хэндла
         * @prop {Function} onChange - срабатывает на каждое изменение значения (при отпускании хэндла)
         * @prop {boolean} isMobile - мобильная версия слайдера (определяется автоматически, но можно и передать)
         * @prop {JQueryObject} $main - jQuery объект слайдера
         **/
        var Slider = function () {
            function Slider(params) {
                _classCallCheck(this, Slider);

                this.selector = params.selector;
                this.$main = $(params.selector);
                this.handles = [];
                var isTouchDevice = navigator.maxTouchPoints || 'ontouchstart' in document.documentElement;
                this.isMobile = typeof params.isMobile === 'undefined' ? isTouchDevice : params.isMobile;
                this.onSlide = params.onSlide || null;
                this.onChange = params.onChange || null;
                this.$main.addClass('slider');
                this.setOptions(params);
                this.addListeners();
            }

            _createClass(Slider, [{
                key: "setOptions",
                value: function setOptions(options) {
                    this.values = options.values || [0];
                    this.min = options.min || 0;
                    this.max = options.max || 100;
                    this.drawHtml();
                }
            }, {
                key: "sortHandles",
                value: function sortHandles() {
                    this.handles.sort(function (a, b) {
                        return a.value > b.value ? 1 : b.value > a.value ? -1 : 0;
                    });
                }
            }, {
                key: "getPositionByValue",
                value: function getPositionByValue(value) {
                    var val = value - this.min;
                    var max = this.max - this.min;
                    return 100 * val / max;
                }
            }, {
                key: "getValueByPosition",
                value: function getValueByPosition(position) {
                    return (this.max - this.min) * position / 100 + this.min;
                }
            }, {
                key: "drawHtml",
                value: function drawHtml() {
                    this.$main.html('');
                    this.handles = [];

                    var $presentation = $('<div class="presentation"></div>');
                    this.$main.html($presentation);
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = this.values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var value = _step2.value;

                            var position = this.getPositionByValue(value);
                            var handle = {
                                value: value,
                                position: position,
                                $element: $("<div class=\"handle\" style=\"left: " + position + "%\" aria-valuenow=\"" + value + "\"></div>")
                            };
                            this.handles.push(handle);
                            $presentation.append(handle.$element);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }

                    if (this.isRange) {
                        this.$range = $("<div class=\"range\" style=\"\n                     left: " + this.handles[0].position + "%;\n                     width: " + (this.handles[1].position - this.handles[0].position) + "%;\n                 \"></div>");
                        $presentation.prepend(this.$range);
                    }
                    this.$main.append('<div class="touch-listener"></div>');
                    this.sortHandles();
                }

                // вернет handles в порядке возрастания их значений

            }, {
                key: "getHandles",
                value: function getHandles() {
                    this.sortHandles();
                    return this.handles;
                }
            }, {
                key: "addListeners",
                value: function addListeners() {
                    var _this15 = this;

                    var self = this;
                    var clickX = void 0;
                    var draggedHandle = void 0;
                    var sliderWidth = void 0;
                    var getPageX = function getPageX(e) {
                        return typeof e.pageX === 'undefined' ? e.touches[0].pageX : e.pageX;
                    };
                    var setHandlePositionByValue = function setHandlePositionByValue(handle, value) {
                        var animateDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

                        if (value > self.max) {
                            value = self.max;
                        } else if (value < self.min) {
                            value = self.min;
                        }
                        handle.value = Math.round(value);
                        handle.position = self.getPositionByValue(value);
                        handle.$element.attr('aria-valuenow', handle.value);
                        if (animateDuration) {
                            handle.$element.animate({ left: handle.position + '%' }, animateDuration);
                        } else {
                            handle.$element.css({ left: handle.position + '%' });
                        }
                        _this15.values = _this15.getHandles().map(function (h) {
                            return h.value;
                        });
                        adjustRange(animateDuration);
                    };
                    var adjustRange = function adjustRange() {
                        var animateDuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

                        if (_this15.isRange) {
                            var handles = _this15.getHandles();
                            var newCss = {
                                left: handles[0].position + '%',
                                width: handles[1].position - handles[0].position + '%'
                            };
                            if (animateDuration) {
                                _this15.$range.animate(newCss, animateDuration);
                            } else {
                                _this15.$range.css(newCss);
                            }
                        }
                    };
                    var moveHandle = function moveHandle(e) {
                        var curPageX = getPageX(e);
                        var diff = curPageX - clickX;
                        var newPosition = draggedHandle.position + diff / sliderWidth * 100;
                        var positionDiff = draggedHandle.position - newPosition;
                        if (newPosition < 0) {
                            newPosition = 0;
                        } else if (newPosition > 100) {
                            newPosition = 100;
                        }
                        var realPositionDiff = draggedHandle.position - newPosition;
                        // рассчитываем поправку, чтобы handle не сползал, когда ивент за пределами слайдера
                        var correction = realPositionDiff / positionDiff - 1;

                        if (draggedHandle.position !== newPosition) {
                            clickX = curPageX + diff * correction;
                            setHandlePositionByValue(draggedHandle, self.getValueByPosition(newPosition));
                            if (typeof self.onSlide === 'function') {
                                self.onSlide(self);
                            }
                        }
                    };
                    var endMoveHandle = function endMoveHandle() {
                        // перемещаем хэндл к целому значению, если он не на месте значения
                        if (Math.abs(draggedHandle.position - self.getPositionByValue(draggedHandle.value)) > 0.01) {
                            setHandlePositionByValue(draggedHandle, draggedHandle.value, 200);
                        }
                        draggedHandle.$element.removeClass('active');
                        // удаляем листнеры
                        draggedHandle = null;
                        window.removeEventListener(self.isMobile ? 'touchmove' : 'mousemove', moveHandle);
                        window.removeEventListener(self.isMobile ? 'touchend' : 'mouseup', endMoveHandle);
                        if (typeof self.onChange === 'function') {
                            self.onChange(self);
                        }
                    };
                    var startMoveHandle = function startMoveHandle(e) {
                        sliderWidth = self.$main.width();
                        clickX = getPageX(e.originalEvent);
                        var position = (getPageX(e.originalEvent) - self.$main.offset().left) / sliderWidth * 100;
                        var nearestHandle = self.handles[0];
                        // получаем ближайший хэндл
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = self.handles[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var handle = _step3.value;

                                if (Math.abs(handle.position - position) < Math.abs(nearestHandle.position - position)) {
                                    nearestHandle = handle;
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }

                        setHandlePositionByValue(nearestHandle, self.getValueByPosition(position), 0);

                        draggedHandle = nearestHandle;
                        draggedHandle.$element.addClass('active');
                        window.addEventListener(self.isMobile ? 'touchmove' : 'mousemove', moveHandle);
                        window.addEventListener(self.isMobile ? 'touchend' : 'mouseup', endMoveHandle);
                        if (typeof self.onSlide === 'function') {
                            self.onSlide(self);
                        }
                    };
                    this.$main.on(this.isMobile ? 'touchstart' : 'mousedown', '.touch-listener', startMoveHandle);
                }
            }, {
                key: "isRange",
                get: function get() {
                    return this.values.length === 2;
                }
            }]);

            return Slider;
        }();

        module.exports = Slider;
    }, {}], 2: [function (require, module, exports) {
        var Slider = require('@brx-js/slider/src/Slider');
        var i18nPlural = window.brxUtils.i18n.plural;

        function convertNightsToDays(nights) {
            var days = [];
            var count = nights.length;
            for (var _i5 = 0; _i5 < count; _i5++) {
                days.push(nights[_i5] + 1);
            }

            return days;
        }

        var FindFormDuration = function () {
            /**
             * @param {string} selector
             * @param {{onChange: Function, onHandleRelease: Function, onBeforeClose: Function}} params
             */
            function FindFormDuration(selector, params) {
                _classCallCheck(this, FindFormDuration);

                this.selector = selector;
                this.$main = $('#' + this.selector);

                this.defaultDays = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
                this.popularDays = [5, 7, 9, 11, 14, 16];
                this.defaultDaysValue = { from: 8, to: 10 };

                this.daysFrom = this.defaultDaysValue.from;
                this.daysTo = this.defaultDaysValue.to;
                this.availableValues = this.defaultDays;

                this.onChange = params.onChange;
                this.onHandleRelease = params.onHandleRelease;
                this.onBeforeClose = params.onBeforeClose;
                this.translates = window.findFormTranslates;

                this.messages = {
                    title: this.translates.durationTitle,
                    labelBtnApply: this.translates.labelBtnApply,
                    pluralDuration: this.translates.durationPluralDuration.split('|')
                };
            }

            _createClass(FindFormDuration, [{
                key: "init",
                value: function init() {
                    var _this16 = this;

                    this.slider = new Slider({
                        selector: '#' + this.selector + ' .duration-range',
                        min: this.availableValues[0],
                        max: this.availableValues[this.availableValues.length - 1],
                        values: [this.daysFrom, this.daysTo],
                        onSlide: function onSlide(slider) {
                            _this16.daysFrom = slider.values[0];
                            _this16.daysTo = slider.values[1];
                            _this16.$main.find('.duration-button.active').removeClass('active');
                            _this16.dispatchOnChange();
                        },
                        onChange: function onChange() {
                            _this16.onHandleRelease();
                        }
                    });
                    this.bindEventListeners();
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this17 = this;

                    this.$main.on('click', '.duration-button', function (e) {
                        var $button = $(e.currentTarget);
                        if ($button.hasClass('active')) {
                            return;
                        }
                        var days = Number($button.data('value'));
                        var $parent = $button.closest('.duration-buttons');
                        $parent.find('.duration-button.active').removeClass('active');
                        $button.addClass('active');
                        // refresh slider
                        _this17.setDaysValues(days, days, _this17.availableValues, false);
                        _this17.dispatchOnChange();
                    });
                }
            }, {
                key: "open",
                value: function open() {
                    window.findFormModal.open({
                        header: {
                            title: this.messages.title
                        },
                        content: {
                            htmlDetachSelectorId: this.selector
                        },
                        footer: {
                            buttonLabel: this.messages.labelBtnApply
                        },
                        onBeforeClose: this.onBeforeClose
                    });
                }
            }, {
                key: "renderSummary",
                value: function renderSummary(label) {
                    this.$main.find('.duration-summary').text(label);
                }
            }, {
                key: "setNightsValues",
                value: function setNightsValues(nightsFrom, nightsTo, nights) {
                    var renderButtons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

                    this.setDaysValues(nightsFrom + 1, nightsTo + 1, convertNightsToDays(nights), renderButtons);
                }
            }, {
                key: "setDaysValues",
                value: function setDaysValues(daysFrom, daysTo, days) {
                    var renderButtons = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

                    this.daysFrom = daysFrom;
                    this.daysTo = daysTo;
                    this.availableValues = days;

                    this.updateDurationRange();
                    if (renderButtons) {
                        // При установке значений снаружи нужно обновить кнопки
                        this.renderButtons();
                    }
                }
            }, {
                key: "renderButtons",
                value: function renderButtons() {
                    var buttons = '';
                    var activeDays = this.daysFrom === this.daysTo ? this.daysTo : null;
                    for (var _i6 = 0, count = this.popularDays.length; _i6 < count; _i6++) {
                        var days = this.popularDays[_i6];
                        var active = days === activeDays ? 'active' : '';
                        var disabled = this.isAvailable(days) ? '' : 'disabled="disabled"';
                        var label = days + ' ' + i18nPlural(days, this.messages.pluralDuration);
                        buttons += "<button type=\"button\"\n                    class=\"duration-button " + active + "\"\n                    data-value=\"" + days + "\"\n                    " + disabled + "\n                >" + label + "</button>";
                    }
                    this.$main.find('.duration-buttons').html(buttons);
                }
            }, {
                key: "updateDurationRange",
                value: function updateDurationRange() {
                    // меняем возможные варианты кол-ва дней
                    if (this.availableValues.length === 0) {
                        this.availableValues = this.defaultDays;
                    }
                    var bounds = {
                        min: this.daysFrom,
                        max: this.daysTo
                    };
                    var isResetDuration = false;
                    // так как у нас теперь слайдер, то клиент может выбирать значения, которых нет в availableValues,
                    // поэтому не сбрасываем его выбор,
                    // а проверяем только крайние значения на случай выхода за пределы слайдера

                    var maxAvailable = this.availableValues[this.availableValues.length - 1];
                    var minAvailable = this.availableValues[0];
                    if (bounds.min < minAvailable) {
                        isResetDuration = true;
                        bounds.min = minAvailable;
                    } else if (bounds.min > maxAvailable) {
                        isResetDuration = true;
                        bounds.min = maxAvailable;
                    }

                    if (bounds.max > maxAvailable) {
                        isResetDuration = true;
                        bounds.max = maxAvailable;
                    }

                    if (isResetDuration) {
                        // вычисление min|max надо если дата от в новом списке есть, а даты до нету.
                        // и выставляется от 15 до 8
                        this.daysFrom = Math.min(bounds.min, bounds.max);
                        this.daysTo = Math.max(bounds.min, bounds.max);
                    }

                    this.slider.setOptions({
                        min: this.availableValues[0],
                        max: this.availableValues[this.availableValues.length - 1],
                        values: [this.daysFrom, this.daysTo]
                    });

                    if (isResetDuration) {
                        // change value
                        this.dispatchOnChange();
                        this.dispatchOnHandleRelease();
                    }
                }

                /**
                 * Возвращает пересечение выбранного диапазона и доступных ночей(дней) из this.availableValues
                 * Если пусто - скорее всего нет туров на выбранное кол-во ночей
                 * @return {Array}
                 */

            }, {
                key: "getDaysInSelectedRange",
                value: function getDaysInSelectedRange() {
                    var intersectionDays = [];
                    var days = void 0;
                    for (var _i7 = 0; _i7 < this.availableValues.length; _i7++) {
                        days = this.availableValues[_i7];
                        if (this.daysFrom <= days && this.daysTo >= days) {
                            intersectionDays.push(days);
                        }
                    }

                    return intersectionDays;
                }

                /**
                 * @param {number} duration
                 * @return {boolean}
                 */

            }, {
                key: "isAvailable",
                value: function isAvailable(duration) {
                    return this.availableValues.indexOf(duration) !== -1;
                }
            }, {
                key: "dispatchOnChange",
                value: function dispatchOnChange() {
                    this.onChange();
                }
            }, {
                key: "dispatchOnHandleRelease",
                value: function dispatchOnHandleRelease() {
                    this.onHandleRelease();
                }
            }, {
                key: "values",
                get: function get() {
                    return {
                        nightsFrom: this.daysFrom - 1,
                        nightsTo: this.daysTo - 1
                    };
                }
            }]);

            return FindFormDuration;
        }();

        window.FindFormDuration = FindFormDuration;
    }, { "@brx-js/slider/src/Slider": 1 }] }, {}, [2]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var modal = window.modals;
        var i18nPlural = window.brxUtils.i18n.plural;
        var i18nTemplate = window.brxUtils.i18n.template;

        var FormTouristsAgeSelect = function () {
            function FormTouristsAgeSelect(_ref2) {
                var _this18 = this;

                var maxChildAge = _ref2.maxChildAge;

                _classCallCheck(this, FormTouristsAgeSelect);

                this.ageBounds = { min: 0, max: maxChildAge };
                this.onSelect = null;
                this.select = new window.MultipleSelect.Select({
                    onSelect: function onSelect(values) {
                        _this18.onSelect(values[0]);
                    }
                });
            }

            _createClass(FormTouristsAgeSelect, [{
                key: "open",
                value: function open(_ref3) {
                    var selectedAge = _ref3.selectedAge,
                        title = _ref3.title,
                        onSelect = _ref3.onSelect,
                        getAgeLabel = _ref3.getAgeLabel;

                    this.onSelect = onSelect;
                    var _ageBounds = this.ageBounds,
                        min = _ageBounds.min,
                        max = _ageBounds.max;

                    var items = [];
                    for (var _i8 = min; _i8 <= max; _i8++) {
                        items.push(new MultipleSelect.Item({
                            value: _i8,
                            label: getAgeLabel(_i8),
                            labelFor: 'search-form__ages',
                            name: 'SFChildAges'
                        }));
                    }

                    var options = new MultipleSelect.RenderOptions({
                        items: items,
                        values: selectedAge ? [] : [selectedAge],
                        isRadio: true
                    });
                    this.select.open(options, {
                        title: title
                    });
                }
            }]);

            return FormTouristsAgeSelect;
        }();

        var FindFormTourists = function () {
            /**
             * @param {string} containerId
             * @param {{
             *     getSelectionLabel: Function,
             *     onChange: Function,
             * }} params
             */
            function FindFormTourists(containerId, params) {
                var _this19 = this;

                _classCallCheck(this, FindFormTourists);

                this.containerId = containerId;
                // values
                this.adult = 2;
                this.child = 0;
                this.childAges = [];
                this.splitRooms = false;

                this.maxAdult = 10;
                this.maxChild = 4;
                this.maxChildAge = 16;

                this.onChange = params.onChange;
                this.getSelectionLabel = function () {
                    return params.getSelectionLabel(_this19.adult, _this19.child);
                };
                this.ageSelect = new FormTouristsAgeSelect({ maxChildAge: this.maxChildAge });
                this.translates = window.findFormTranslates;

                this.messages = {
                    title: this.translates.tourists,
                    titleAge: this.translates.labelBtnApply,
                    labelBtnApply: this.translates.labelBtnApply,
                    labelZeroYears: this.translates.labelZeroYears,
                    pluralAge: this.translates.pluralAge.split('|')
                };
                this.bindEventListeners();
            }

            _createClass(FindFormTourists, [{
                key: "dispatchOnChange",
                value: function dispatchOnChange() {
                    this.onChange();
                }
            }, {
                key: "open",
                value: function open() {
                    var _this20 = this;

                    window.findFormModal.open({
                        header: {
                            title: this.messages.title
                        },
                        content: {
                            htmlDetachSelectorId: this.containerId
                        },
                        footer: {
                            buttonLabel: this.messages.labelBtnApply
                        },
                        onBeforeClose: function onBeforeClose() {
                            _this20.dispatchOnChange();
                        }
                    });
                }
            }, {
                key: "bindEventListeners",
                value: function bindEventListeners() {
                    var _this21 = this;

                    var $container = this.$container;

                    $container.find('.find-form-counter').on('click', '.decrement', function (e) {
                        var $button = $(e.currentTarget);
                        if ($button.is(':disabled')) {
                            return;
                        }
                        _this21.onChangeCount($button.parent(), false);
                    }).on('click', '.increment', function (e) {
                        var $button = $(e.currentTarget);
                        if ($button.is(':disabled')) {
                            return;
                        }
                        _this21.onChangeCount($button.parent(), true);
                    });

                    $container
                    // Изменение выбранного возраста
                    .on('tourists.selectAge', '.age-input', function (e) {
                        var isNewClicked = e.isTrigger === 3; // click by trigger
                        var $ageInput = $(e.currentTarget);
                        var value = parseInt($ageInput.val(), 10);
                        _this21.ageSelect.open({
                            selectedAge: value,
                            title: _this21.messages.titleAge,
                            getAgeLabel: function getAgeLabel(age) {
                                return _this21.getAgeLabel(age);
                            },
                            onSelect: function onSelect(ageValue) {
                                $ageInput.val(ageValue); // set html value
                                _this21.renderChildAges(); // refresh values from html
                            }
                        });
                    })
                    // Добавление ребенка
                    .on('click', '.add-child-button', function () {
                        var $hiddenAges = $('.child-age.hidden');
                        var $hiddenAgeInput = $hiddenAges.first().find('.age-input');
                        // show age select
                        $hiddenAgeInput.trigger('tourists.selectAge');
                    }).on('click', '.js-remove-child-age', function (e) {
                        var $removeBtn = $(e.currentTarget);
                        var $ageItem = $removeBtn.closest('.child-age');
                        $ageItem.find('.age-input').val(''); // reset value
                        _this21.renderChildAges(); // refresh values from html
                        // элемент перекидываем в конец чтобы при добавлении появился в конце
                        _this21.$agesContainer.append($ageItem.detach());
                    })
                    // обработчик через container т.к. detach при показе
                    .on('change', '#search-form-split-rooms-switch', function (e) {
                        var checkbox = e.currentTarget;
                        _this21.setSplitRooms(checkbox.checked);
                    });
                }

                /**
                 * @param {boolean} isAdult
                 * @return {{min: number, max: number}}
                 * @private
                 */

            }, {
                key: "getBounds",
                value: function getBounds(isAdult) {
                    return {
                        min: isAdult ? 1 : 0,
                        max: isAdult ? this.maxAdult : this.maxChild
                    };
                }

                /**
                 * @param {boolean} isAdult
                 * @param {number} value
                 * @return {boolean}
                 * @private
                 */

            }, {
                key: "isValidValue",
                value: function isValidValue(isAdult, value) {
                    var bounds = this.getBounds(isAdult);
                    return value >= bounds.min && value <= bounds.max;
                }
            }, {
                key: "checkCounterControlsState",
                value: function checkCounterControlsState() {
                    var $controls = this.$container.find('.counter[data-type="adult"]');
                    var bounds = this.getBounds(true);

                    this.toggleEnabled($controls.find('.increment'), this.adult < bounds.max);
                    this.toggleEnabled($controls.find('.decrement'), this.adult > bounds.min);
                }

                /**
                 * @param $controls
                 * @param {boolean} increment
                 */

            }, {
                key: "onChangeCount",
                value: function onChangeCount($controls, increment) {
                    var $value = $controls.find('.counter-value');
                    var value = parseInt($value.text(), 10);
                    var newValue = increment ? value + 1 : value - 1;

                    if (this.isValidValue(true, newValue)) {
                        this.adult = newValue;
                        $value.text(newValue);
                        this.checkCounterControlsState();
                        this.updateSelectionLabel();
                        this.refreshSplitRooms();
                    }
                }
            }, {
                key: "updateSelectionLabel",
                value: function updateSelectionLabel() {
                    this.$container.find('.tourists-summary').text(this.getSelectionLabel());
                }

                /**
                 *
                 * @param $button - $(...)
                 * @param {Boolean} enabled
                 */

            }, {
                key: "toggleEnabled",
                value: function toggleEnabled($button, enabled) {
                    $button.prop('disabled', !enabled);
                    $button.toggleClass('disabled', !enabled);
                }

                /**
                 *
                 * @param {Number} adult
                 * @param {Number} child
                 * @param {[]} childAges
                 * @param {boolean} splitRooms
                 */

            }, {
                key: "setValues",
                value: function setValues(adult, child, childAges, splitRooms) {
                    this.adult = parseInt(adult, 10);
                    this.child = parseInt(child, 10);
                    this.splitRooms = splitRooms;

                    this.checkCounterControlsState(); // adult
                    var $container = this.$container;
                    $container.find('.find-form-counter.adult .counter-value').text(this.adult);

                    var ages = [];
                    if (this.child > 0) {
                        for (var _i9 = 0; _i9 < this.child; _i9++) {
                            var ageValue = parseInt(childAges[_i9], 10);
                            if (this.isValidChildAge(ageValue)) {
                                ages.push(ageValue);
                            }
                        }
                    }

                    this.renderChildAges(ages);
                    this.renderSplitRooms();
                    // В интерфейсе не предусмотрена возможность "нет возраста"
                    if (this.child !== child || this.splitRooms !== splitRooms) {
                        this.dispatchOnChange();
                    }
                }

                /**
                 * @param {string|number} age
                 * @private
                 */

            }, {
                key: "isValidChildAge",
                value: function isValidChildAge(age) {
                    age = parseInt(age, 10);
                    return age >= 0 && age <= this.maxChildAge;
                }

                /**
                 * @param {number} ageValue
                 * @return {string|string}
                 */

            }, {
                key: "getAgeLabel",
                value: function getAgeLabel(ageValue) {
                    return ageValue === 0 ? this.messages.labelZeroYears : ageValue + ' ' + i18nPlural(ageValue, this.messages.pluralAge);
                }

                /**
                 * Обновление HTML представления выбора кол-ва детей
                 * - show/hide selected age container
                 * - show/hide selected age item
                 * - show/hide add child button
                 * - refresh selected values (child, childAges) <----
                 * @param {number[]|null} forceChildAges
                 * @private
                 */

            }, {
                key: "renderChildAges",
                value: function renderChildAges() {
                    var _this22 = this;

                    var forceChildAges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    var $container = this.$container;
                    this.childAges = [];
                    $container.find('.child-age').each(function (i, element) {
                        var $ageItem = $(element);
                        var $ageInput = $ageItem.find('.age-input');
                        var $ageLabel = $ageItem.find('.age-label');

                        var ageValue = forceChildAges !== null ? forceChildAges[i] : $ageInput.val();

                        ageValue = parseInt(ageValue, 10);
                        if (_this22.isValidChildAge(ageValue)) {
                            _this22.childAges.push(ageValue);
                        } else {
                            ageValue = '';
                        }

                        var isValueSelected = ageValue !== '';
                        if (isValueSelected) {
                            var buttonLabel = 'Ребенок, ' + _this22.getAgeLabel(ageValue);
                            $ageLabel.text(buttonLabel);
                        }
                        $ageInput.val(ageValue).toggleClass('selected', isValueSelected);
                        $ageItem.toggleClass('hidden', !isValueSelected);
                    });

                    this.child = this.childAges.length;
                    var childBounds = this.getBounds(false);
                    // show/hide selected age container
                    $container.find('.child-ages').toggleClass('hidden', this.child === childBounds.min);
                    // show/hide add child button
                    $container.find('.add-child-button').toggleClass('hidden', this.child === childBounds.max);

                    this.updateSelectionLabel();
                    this.refreshSplitRooms();
                }

                /**
                 * Проверяем можно ли splitRooms. Вкл|Выкл в зависимости от кол-ва туристов
                 * @return {boolean}
                 */

            }, {
                key: "refreshSplitRooms",
                value: function refreshSplitRooms() {
                    var isChanged = false;
                    var isEnoughPeopleToSplitRoom = this.isEnoughPeopleToSplitRoom();
                    if (this.splitRooms && !isEnoughPeopleToSplitRoom) {
                        this.setSplitRooms(false);
                        this.renderSplitRooms();
                    } else if (!this.splitRooms && isEnoughPeopleToSplitRoom) {
                        this.setSplitRooms(true);
                        this.renderSplitRooms();
                    }
                    return isChanged;
                }

                /**
                 * Перерисовка требуется только при изменении кол-ва туристов
                 */

            }, {
                key: "renderSplitRooms",
                value: function renderSplitRooms() {
                    var $splitRoomsRow = this.$splitRoomsRow;
                    $splitRoomsRow.toggleClass('hidden', !this.isEnoughPeopleToSplitRoom());
                    var $switch = $splitRoomsRow.find('input[type="checkbox"]');
                    $switch.prop('checked', this.splitRooms);
                    $switch.trigger('change');
                }

                /**
                 * @private
                 * @param checked
                 */

            }, {
                key: "setSplitRooms",
                value: function setSplitRooms(checked) {
                    if (this.splitRooms !== checked) {
                        this.splitRooms = checked;
                    }
                }
            }, {
                key: "isEnoughPeopleToSplitRoom",
                value: function isEnoughPeopleToSplitRoom() {
                    return window.isEnoughPeopleToSplitRoom(this.adult, this.child);
                }
            }, {
                key: "values",
                get: function get() {
                    return {
                        adult: this.adult,
                        child: this.child,
                        childAges: this.childAges,
                        splitRooms: this.splitRooms
                    };
                }
            }, {
                key: "$container",
                get: function get() {
                    return $('#' + this.containerId);
                }
            }, {
                key: "$agesContainer",
                get: function get() {
                    return $('#' + this.containerId + ' .child-ages');
                }
            }, {
                key: "$splitRoomsRow",
                get: function get() {
                    return $('#' + this.containerId + ' .split-rooms');
                }
            }]);

            return FindFormTourists;
        }();

        window.FindFormTourists = FindFormTourists;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var i18nPlural = window.brxUtils.i18n.plural;
        var i18nTemplate = window.brxUtils.i18n.template;

        var FindFormStars = function () {
            function FindFormStars(props) {
                var _this23 = this;

                _classCallCheck(this, FindFormStars);

                this.translates = window.findFormTranslates;
                this.messages = {
                    starsTitle: this.translates.starsTitle,
                    labelBtnSelect: this.translates.labelBtnApply,
                    pluralStars: this.translates.pluralStars.split('|')
                };
                this.onChange = props.onChange;
                this.select = new window.MultipleSelect.Select({
                    onSelect: function onSelect(values) {
                        _this23.onChange(values);
                    }
                });
            }

            _createClass(FindFormStars, [{
                key: "renderSelectedLabel",


                /** @param {number[]} values */
                value: function renderSelectedLabel(values) {
                    return values.length > 0 ? values.join(',') + this.icon : '1 - 5' + this.icon;
                }

                /**
                 * @param {number[]} selectedValues
                 */

            }, {
                key: "open",
                value: function open(selectedValues) {
                    var items = [];
                    // 2-5 звезд
                    for (var _i10 = 5; _i10 > 1; _i10--) {
                        items.push(new MultipleSelect.Item({
                            value: _i10,
                            label: this.renderLabel(_i10),
                            labelFor: 'search-form__stars',
                            name: 'SFStars[]'
                        }));
                    }

                    var options = new MultipleSelect.RenderOptions({
                        items: items,
                        values: selectedValues.length ? selectedValues : [],
                        isRadio: false
                    });
                    this.select.open(options, {
                        id: 'search-form-stars-modal',
                        title: this.messages.starsTitle,
                        labelBtnSelect: this.messages.labelBtnSelect
                    });
                }
            }, {
                key: "renderLabel",
                value: function renderLabel(stars) {
                    var label = stars + ' ' + i18nPlural(stars, this.messages.pluralStars);
                    return "<span class=\"sr-only\">" + label + "</span>" + this.renderStars(stars);
                }
            }, {
                key: "renderStars",
                value: function renderStars(stars) {
                    var starsHtml = '';
                    for (var _i11 = 1; _i11 <= 5; _i11++) {
                        var type = _i11 > stars ? 'empty' : 'active';
                        starsHtml += "<span class=\"star-icon star-icon--" + type + "\"></span>";
                    }

                    return starsHtml;
                }
            }, {
                key: "icon",
                get: function get() {
                    return '<span class="star-icon star-icon--active"></span>';
                }
            }]);

            return FindFormStars;
        }();

        window.FindFormStars = FindFormStars;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var i18nPlural = window.brxUtils.i18n.plural;
        var i18nTemplate = window.brxUtils.i18n.template;

        var FindFormMeals = function () {
            function FindFormMeals(props) {
                var _this24 = this;

                _classCallCheck(this, FindFormMeals);

                this.translates = window.findFormTranslates;
                this.messages = {
                    mealsTitle: this.translates.mealsTitle,
                    labelBtnSelect: this.translates.labelBtnApply
                };
                this.onChange = props.onChange;
                this.select = new window.MultipleSelect.Select({
                    onSelect: function onSelect(values) {
                        _this24.onChange(values);
                    }
                });
            }

            /**
             * @param {SearchFormDataMeal[]} meals
             * @param {number[]} selectedValues
             */


            _createClass(FindFormMeals, [{
                key: "open",
                value: function open(meals, selectedValues) {
                    var items = [];
                    var meal = void 0;
                    for (var mealId in meals) {
                        if (!meals.hasOwnProperty(mealId)) {
                            continue;
                        }
                        meal = meals[mealId];
                        items.push(new MultipleSelect.Item({
                            value: meal.id,
                            label: meal.code + " - " + meal.name,
                            labelFor: 'search-form__meals',
                            name: 'SFMeals[]'
                        }));
                    }

                    var options = new MultipleSelect.RenderOptions({
                        items: items,
                        values: selectedValues.length ? selectedValues : [],
                        isRadio: false
                    });
                    this.select.open(options, {
                        title: this.messages.mealsTitle,
                        labelBtnSelect: this.messages.labelBtnSelect
                    });
                }
            }]);

            return FindFormMeals;
        }();

        window.FindFormMeals = FindFormMeals;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // const i18nPlural = window.brxUtils.i18n.plural;
        // const i18nTemplate = window.brxUtils.i18n.template;

        var FindFormOperators = function () {
            function FindFormOperators(props) {
                var _this25 = this;

                _classCallCheck(this, FindFormOperators);

                var translates = window.findFormTranslates;
                this.messages = {
                    modalTitle: translates.operatorsTitle,
                    labelBtnSelect: translates.labelBtnApply
                };
                this.onChange = props.onChange;
                this.select = new window.MultipleSelect.Select({
                    onSelect: function onSelect(values) {
                        _this25.onChange(values);
                    }
                });
            }

            /**
             * @param {SearchFormDataOperator[]} operators
             * @param {number[]} selectedValues
             */


            _createClass(FindFormOperators, [{
                key: "open",
                value: function open(operators, selectedValues) {
                    var items = [];
                    var operator = void 0;
                    for (var operatorId in operators) {
                        if (!operators.hasOwnProperty(operatorId)) {
                            continue;
                        }
                        operator = operators[operatorId];
                        items.push(new MultipleSelect.Item({
                            value: operator.id,
                            label: operator.code + " - " + operator.name,
                            labelFor: 'search-form__operators',
                            name: 'SFOperators[]'
                        }));
                    }

                    var options = new MultipleSelect.RenderOptions({
                        items: items,
                        values: selectedValues.length ? selectedValues : [],
                        isRadio: false
                    });
                    this.select.open(options, {
                        title: this.messages.modalTitle,
                        labelBtnSelect: this.messages.labelBtnSelect
                    });
                }
            }]);

            return FindFormOperators;
        }();

        window.FindFormOperators = FindFormOperators;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        // const i18nPlural = window.brxUtils.i18n.plural;
        // const i18nTemplate = window.brxUtils.i18n.template;

        var FindFormAirlines = function () {
            function FindFormAirlines(props) {
                var _this26 = this;

                _classCallCheck(this, FindFormAirlines);

                var translates = window.findFormTranslates;
                this.messages = {
                    modalTitle: translates.airlinesTitle,
                    labelBtnSelect: translates.labelBtnApply
                };
                this.onChange = props.onChange;
                this.select = new window.MultipleSelect.Select({
                    onSelect: function onSelect(values) {
                        _this26.onChange(values);
                    }
                });
            }

            /**
             * @param {SearchFormDataAirline[]} airlines
             * @param {number[]} selectedValues
             */


            _createClass(FindFormAirlines, [{
                key: "open",
                value: function open(airlines, selectedValues) {
                    var items = [];
                    var airline = void 0;
                    for (var code in airlines) {
                        if (!airlines.hasOwnProperty(code)) {
                            continue;
                        }
                        airline = airlines[code];
                        items.push(new MultipleSelect.Item({
                            value: airline.code,
                            label: airline.code + " - " + airline.name,
                            labelFor: 'search-form__airlines',
                            name: 'SFAirlines[]'
                        }));
                    }

                    var options = new MultipleSelect.RenderOptions({
                        items: items,
                        values: selectedValues.length ? selectedValues : [],
                        isRadio: false
                    });
                    this.select.open(options, {
                        title: this.messages.modalTitle,
                        labelBtnSelect: this.messages.labelBtnSelect
                    });
                }
            }]);

            return FindFormAirlines;
        }();

        window.FindFormAirlines = FindFormAirlines;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var CountryMenu = function () {
            function CountryMenu() {
                _classCallCheck(this, CountryMenu);

                this.currentCountryMenuId = null;
                this.allowCountryMenu = null;
            }

            _createClass(CountryMenu, [{
                key: "isCountryChanged",
                value: function isCountryChanged(countryId) {
                    return this.currentCountryMenuId !== countryId && countryId;
                }
            }, {
                key: "loadCountryMenu",
                value: function loadCountryMenu(countryId) {
                    var _this27 = this;

                    if (!this.isCountryMenuEnabled()) {
                        return;
                    }

                    if (this.isCountryChanged(countryId)) {
                        this.currentCountryMenuId = countryId;
                        var setCountryMenu = function setCountryMenu(html) {
                            var $widgets = $('.page-top-widgets');
                            var $countryMenu = $widgets.find('.header-country-menu');
                            if (!$countryMenu.length) {
                                $widgets.prepend('<div class="header-country-menu">' + html + '</div>');
                            } else {
                                $countryMenu.html(html);
                            }
                        };
                        if (!this.countriesMenuHtml) {
                            this.countriesMenuHtml = {};
                        }
                        if (this.countriesMenuHtml[countryId]) {
                            setCountryMenu(this.countriesMenuHtml[countryId]);
                        } else {
                            $.get('/tours/country/getMenu?id=' + countryId, function (html) {
                                _this27.countriesMenuHtml[countryId] = html;
                                setCountryMenu(html);
                            });
                        }
                    }
                }

                /**
                 * @private
                 * @return {boolean}
                 */

            }, {
                key: "isCountryMenuEnabled",
                value: function isCountryMenuEnabled() {
                    if (this.allowCountryMenu === null) {
                        var $widgets = $('.page-top-widgets');
                        this.allowCountryMenu = $widgets.data('country-menu') === 1;
                    }

                    return this.allowCountryMenu;
                }
            }]);

            return CountryMenu;
        }();

        window.CountryMenu = CountryMenu;
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var SearchFormDataMeals = require('./BaseSearchFormDataMeals');
        var SearchFormDataOperators = require('./BaseSearchFormDataOperators');
        var SearchFormDataAirlines = require('./BaseSearchFormDataAirlines');

        /**
         * @property {number} id
         * @property {string} name
         * @property {string} nameFrom
         * @property {number|null} altId - Альтернативный город вылета
         */

        var SearchFormDataCity = function SearchFormDataCity(cityId, props) {
            _classCallCheck(this, SearchFormDataCity);

            this.id = cityId;
            this.name = props.name;
            this.nameFrom = props.nameFrom;
            this.altId = props.altId;
        };

        /**
         * Автокомплит отеля
         */


        var SearchFormIntelligentSearch = function () {
            function SearchFormIntelligentSearch(_ref4) {
                var url = _ref4.url;

                _classCallCheck(this, SearchFormIntelligentSearch);

                this.url = url;
                this.timers = {
                    /** @type {object|null} */
                    getDestinationsRequest: null,
                    /** @type {number} */
                    getHotelsCall: 0
                };
            }

            _createClass(SearchFormIntelligentSearch, [{
                key: "abortGetDestinationsRequest",
                value: function abortGetDestinationsRequest() {
                    if (this.timers.getDestinationsRequest) {
                        this.timers.getDestinationsRequest.abort();
                        this.timers.getDestinationsRequest = null;
                    }
                    if (this.timers.getHotelsCall) {
                        clearInterval(this.timers.getHotelsCall);
                    }
                }

                /**
                 * @param {string} slug
                 * @param {string} type
                 * @param {Function} callback
                 * @param {number} [countryId]
                 */

            }, {
                key: "getDestinations",
                value: function getDestinations(slug, type, callback, countryId) {
                    var _this28 = this;

                    this.abortGetDestinationsRequest();
                    var params = {
                        query: slug,
                        type: type,
                        limit: 20
                    };
                    if (countryId) {
                        params.countryId = countryId;
                    }
                    this.timers.getHotelsCall = setTimeout(function () {
                        _this28.timers.getDestinationsRequest = $.getJSON(_this28.url, params, function (data) {
                            callback(data);
                        });
                    }, 100);
                }
            }, {
                key: "types",
                get: function get() {
                    return {
                        all: 'all',
                        regionsAndHotels: 'regions-hotels',
                        hotels: 'hotels'
                    };
                }
            }]);

            return SearchFormIntelligentSearch;
        }();

        var BaseSearchFormData = function () {
            /**
             * @param {{
             *  urls: {},
             *  cities?: {},
             *  countries?: {},
             *  regions?: {},
             *  directions?: {},
             *  defaultValues?: {},
             *  meals?: [],
             *  operators?: [],
             *  airlines?: [],
             *  visaTypes: string[],
             * }} data
             */
            function BaseSearchFormData(data) {
                _classCallCheck(this, BaseSearchFormData);

                this.urls = {
                    getData: data.urls.getData,
                    getRegions: data.urls.getRegions,
                    getDestinations: data.urls.getDestinations, // query=qwe&country_id=2&type=hotels
                    getDates: data.urls.getDates
                    // queryParams: {
                    //     from: data.urls.queryParams.from || null,
                    // },
                };

                this.isLoaded = {
                    data: false,
                    nonPopularRegions: false
                };

                this.loading = {
                    data: {
                        /** @type {boolean} */
                        started: false,
                        /** @type {Function|null} */
                        onLoad: null
                    },
                    nonPopularRegions: {
                        /** @type {boolean} */
                        started: false,
                        /** @type {Function|null} */
                        onLoad: null
                    }
                };

                this.cities = data.cities || {};
                this.countries = data.countries || {};
                this.regions = data.regions || {};
                this.directions = data.directions || {};
                this.defaultValues = data.defaultValues || {};
                this.visaTypes = data.visaTypes || [];

                if (data.directions) {
                    this.isLoaded.data = true;
                    this.isLoaded.nonPopularRegions = true;
                }

                this.availableDates = {};

                this.meals = new SearchFormDataMeals();
                this.meals.load(data.meals || []);

                this.operators = new SearchFormDataOperators();
                this.operators.load(data.operators || []);

                this.airlines = new SearchFormDataAirlines();
                this.airlines.load(data.airlines || []);

                this.intelligentSearch = new SearchFormIntelligentSearch({ url: this.urls.getDestinations });
            }

            /**
             * @param {Function} onLoad
             * @param {number|null} countryId
             */


            _createClass(BaseSearchFormData, [{
                key: "load",
                value: function load(onLoad) {
                    var _this29 = this;

                    var countryId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    if (this.isLoaded.data) {
                        onLoad();
                    } else {
                        this.loading.data.onLoad = onLoad;
                        this.loading.nonPopularRegions.started = true;
                        if (this.loading.data.started !== true) {
                            this.loading.data.started = true;
                            var qp = [];
                            if (countryId) {
                                qp.push('countryId=' + encodeURIComponent(countryId));
                            }
                            // if (this.urls.queryParams.from) {
                            //     qp.push('from=' + this.urls.queryParams.from);
                            // }
                            var url = this.urls.getData;
                            if (qp.length) {
                                url += '?' + qp.join('&');
                            }

                            $.getJSON(url, {}, function (data) {
                                _this29.cities = data.cities;
                                _this29.countries = data.countries;
                                _this29.regions = data.regions;
                                _this29.directions = data.directions;
                                _this29.defaultValues = data.defaultValues || {};
                                _this29.meals.load(data.meals);
                                _this29.operators.load(data.operators);
                                _this29.airlines.load(data.airlines);
                                _this29.visaTypes = data.visaTypes;

                                _this29.isLoaded.data = true;
                                _this29.isLoaded.nonPopularRegions = true;

                                // last call callback
                                _this29.loading.data.onLoad();
                                if (typeof _this29.loading.nonPopularRegions.onLoad === 'function') {
                                    _this29.loading.nonPopularRegions.onLoad();
                                }
                            });
                        }
                    }
                }

                /**
                 * @deprecated
                 * @param {Function} [callback]
                 */

            }, {
                key: "loadRegions",
                value: function loadRegions(callback) {
                    var _this30 = this;

                    return;
                    if (this.isLoaded.nonPopularRegions) {
                        if (typeof callback === 'function') {
                            callback();
                        }
                    } else {
                        this.loading.nonPopularRegions.onLoad = callback || null;
                        if (this.loading.nonPopularRegions.started !== true) {
                            this.loading.nonPopularRegions.started = true;
                            $.getJSON(this.urls.getRegions, {}, function (regionsByCountry) {
                                _this30._addRegions(regionsByCountry);
                                _this30.isLoaded.nonPopularRegions = true;
                                if (typeof _this30.loading.nonPopularRegions.onLoad === 'function') {
                                    _this30.loading.nonPopularRegions.onLoad();
                                }
                            });
                        }
                    }
                }

                /**
                 * @param {{}|null} regionsByCountry
                 * @private
                 */

            }, {
                key: "_addRegions",
                value: function _addRegions(regionsByCountry) {
                    if (!regionsByCountry) {
                        return;
                    }
                    var countryId = void 0;
                    for (countryId in regionsByCountry) {
                        if (!regionsByCountry.hasOwnProperty(countryId)) {
                            continue;
                        }
                        // extends already loaded popular countries regions
                        this.regions[countryId] = regionsByCountry[countryId];
                    }
                }

                /**
                 * return {[{ id: number, name: string, nameFrom: string, sort: number }]}
                 */

            }, {
                key: "getSortedCities",
                value: function getSortedCities() {
                    var sortedCities = [];
                    var city = void 0;
                    for (var cityId in this.cities) {
                        if (!this.cities.hasOwnProperty(cityId)) {
                            continue;
                        }
                        city = this.cities[cityId];
                        sortedCities.push({
                            id: cityId,
                            name: city.name,
                            nameFrom: city.nameFrom,
                            sort: city.sort
                        });
                    }

                    return sortedCities.sort(function (a, b) {
                        return a.sort - b.sort;
                    });
                }

                /**
                 *
                 * @param {number[]} departCitiesId
                 * @param {number} preferDepartCityId - город, который должен быть в начале
                 */

            }, {
                key: "getSortedCountryDepartCities",
                value: function getSortedCountryDepartCities(departCitiesId, preferDepartCityId) {
                    departCitiesId.sort(function (a, b) {
                        if (b === preferDepartCityId) {
                            return 1;
                        }
                        return 0;
                    });

                    return departCitiesId;
                }

                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @param {object} regionIds
                 * @param {number|null} selectedHotel
                 * @param {number} nightsFrom
                 * @param {number} nightsTo
                 * @return {boolean}
                 */

            }, {
                key: "isDatesLoaded",
                value: function isDatesLoaded(cityId, countryId, regionIds, selectedHotel, nightsFrom, nightsTo) {
                    return cityId in this.availableDates && countryId in this.availableDates[cityId] && this.availableDates[cityId][countryId] && "regions" in this.availableDates[cityId][countryId] && "hotelId" in this.availableDates[cityId][countryId] && this.availableDates[cityId][countryId].regions.includes(regionIds) && (this.availableDates[cityId][countryId].hotelId === null && selectedHotel === null || Number(this.availableDates[cityId][countryId].hotelId) === selectedHotel) && "nightsFrom" in this.availableDates[cityId][countryId] && "nightsTo" in this.availableDates[cityId][countryId] && nightsFrom === +this.availableDates[cityId][countryId].nightsFrom && nightsTo === +this.availableDates[cityId][countryId].nightsTo;
                }

                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @param {object} regionIds
                 * @param {number|null} selectedHotel
                 * @param {number} nightsFrom
                 * @param {number} nightsTo
                 * @param {Function} onLoad
                 */

            }, {
                key: "loadDates",
                value: function loadDates(cityId, countryId, regionIds, selectedHotel, nightsFrom, nightsTo, onLoad) {
                    var _this31 = this;

                    $.getJSON(this.urls.getDates, {
                        depart_city_id: cityId,
                        country_id: countryId,
                        region_ids: regionIds,
                        selected_hotel: selectedHotel,
                        nightsFrom: nightsFrom,
                        nightsTo: nightsTo
                    }, function (data) {
                        if (!_this31.availableDates.hasOwnProperty(data.depart_city_id)) {
                            _this31.availableDates[data.depart_city_id] = {};
                        }
                        var minStartDate = _this31.getMinStartDate(cityId, countryId);

                        if (data.dates.length > 0) {
                            data.dates = _this31.minStartDateFilterAndSortDates(data.dates, minStartDate);
                        }

                        _this31.availableDates[data.depart_city_id][data.country_id] = {
                            dates: data.dates,
                            regions: data.region_ids,
                            hotelId: data.hotel_id,
                            nightsFrom: data.nightsFrom,
                            nightsTo: data.nightsTo
                        };
                        onLoad();
                    }).fail(function () {
                        onLoad();
                    });
                }
            }, {
                key: "getDates",


                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @param {object} regionIds
                 * @param {number|null} selectedHotel
                 * @param {number} nightsFrom
                 * @param {number} nightsTo
                 * @return {Array}
                 */
                value: function getDates(cityId, countryId, regionIds, selectedHotel, nightsFrom, nightsTo) {
                    return this.isDatesLoaded(cityId, countryId, regionIds, selectedHotel, nightsFrom, nightsTo) ? this.availableDates[cityId][countryId].dates : null;
                }

                /**
                 * @param {number} cityId
                 * @param {number|null} alternativeCityId
                 * @return {{other, popular, alternative}}
                 */

            }, {
                key: "getSortedSplitDirections",
                value: function getSortedSplitDirections(cityId) {
                    var alternativeCityId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    var sortedDirections = this.getSortedDirections(cityId);
                    return {
                        popular: sortedDirections.slice(0, 6),
                        other: sortedDirections.slice(6), // TODO: sorted by name
                        alternative: alternativeCityId === null ? []
                        // TODO:  Полотнищем может быть неудобно (Sort by name | split | ...)
                        : this.getSortedDirections(alternativeCityId)
                    };
                }

                /**
                 * Возвращает направления
                 * @param {number} skipDepartCityId
                 * @return {Array}
                 */

            }, {
                key: "getOtherSortedDirections",
                value: function getOtherSortedDirections(skipDepartCityId) {
                    var sortedOtherDirections = [];
                    for (var departCityId in this.directions) {
                        if (!this.directions.hasOwnProperty(departCityId)) {
                            continue;
                        }
                        departCityId = parseInt(departCityId, 10);
                        if (Number(departCityId) === skipDepartCityId) {
                            continue;
                        }
                        var directions = this.getCityDirections(departCityId);
                        sortedOtherDirections = sortedOtherDirections.concat(this._prepareCityDirectionsForSort(departCityId, directions));
                    }

                    return BaseSearchFormData._sortDirections(sortedOtherDirections);
                }

                /**
                 * @param {number} cityId
                 * return {[]}
                 */

            }, {
                key: "getSortedDirections",
                value: function getSortedDirections(cityId) {
                    var directions = this.getCityDirections(cityId);
                    return BaseSearchFormData._sortDirections(this._prepareCityDirectionsForSort(cityId, directions));
                }

                /**
                 * @param {number} cityId
                 * @param {{}} cityDirections
                 * @return {Array}
                 * @private
                 */

            }, {
                key: "_prepareCityDirectionsForSort",
                value: function _prepareCityDirectionsForSort(cityId, cityDirections) {
                    var direction = void 0;
                    var countryId = void 0;

                    var sortedDirections = [];
                    for (countryId in cityDirections) {
                        if (!cityDirections.hasOwnProperty(countryId)) {
                            continue;
                        }
                        direction = cityDirections[countryId];
                        sortedDirections.push({
                            departCity: {
                                id: cityId
                            },
                            country: {
                                id: parseInt(countryId, 10),
                                name: this.countries[countryId].name,
                                code: this.countries[countryId].code,
                                visaType: this.countries[countryId].visaType
                            },
                            sort: this.countries[countryId].sort,
                            price: direction.price || 0,
                            currency: direction.cur || ''
                        });
                    }

                    return sortedDirections;
                }
            }, {
                key: "getCityDirections",


                /**
                 * @param {number} cityId
                 * @return {*|{}}
                 */
                value: function getCityDirections(cityId) {
                    return this.directions[cityId] || {};
                }

                /**
                 * @param {number} cityId
                 * @return {boolean}
                 */

            }, {
                key: "isCityExists",
                value: function isCityExists(cityId) {
                    return cityId in this.cities;
                }

                /**
                 * @note Не дергайте в циклах. Нужна будет оптимизация
                 * @param {number} cityId
                 * @return {SearchFormDataCity|null}
                 */

            }, {
                key: "getCity",
                value: function getCity(cityId) {
                    return this.isCityExists(cityId) ? new SearchFormDataCity(cityId, this.cities[cityId]) : null;
                }

                /**
                 * @param {number} countryId
                 * @return {boolean}
                 */

            }, {
                key: "isCountryExists",
                value: function isCountryExists(countryId) {
                    return countryId in this.countries;
                }

                /**
                 * @param {number} countryId
                 * @return {{
                 *  name: string,
                 *  nameTo: string,
                 *  to: string,
                 *  sort: number,
                 *  departCitiesId: Array,
                 *  code: string,
                 *  visaType: number|null
                 * }}
                 */

            }, {
                key: "getCountry",
                value: function getCountry(countryId) {
                    var country = this.isCountryExists(countryId) ? this.countries[countryId] : null;
                    return {
                        name: country ? country.name : 'N/A',
                        nameTo: country ? country.nameTo : 'N/A',
                        to: country ? country.to : 'в',
                        sort: country ? country.sort : 0,
                        code: country ? country.code : '',
                        departCitiesId: country ? country.departs : [],
                        visaType: country ? country.visaType : null
                    };
                }
            }, {
                key: "getCountryCode",
                value: function getCountryCode(countryId) {
                    if (this.isCountryExists(countryId)) {
                        return this.countries[countryId].code;
                    }
                    return null;
                }
            }, {
                key: "getCountryVisaType",
                value: function getCountryVisaType(countryId) {
                    if (this.isCountryExists(countryId)) {
                        return this.countries[countryId].visaType;
                    }
                    return null;
                }

                /**
                 * @param {number} countryId
                 * @param {number} regionId
                 * @return {boolean}
                 */

            }, {
                key: "isRegionExists",
                value: function isRegionExists(countryId, regionId) {
                    return this.regions.hasOwnProperty(countryId) && this.regions[countryId].hasOwnProperty(regionId);
                }

                /**
                 * @param {number} countryId
                 * @param {number} regionId
                 * @return {string}
                 */

            }, {
                key: "getRegionName",
                value: function getRegionName(countryId, regionId) {
                    var regionName = '';
                    if (this.isRegionExists(countryId, regionId)) {
                        regionName = this.regions[countryId][regionId].name;
                    }

                    return regionName;
                }

                /**
                 * @param {number} countryId
                 * @param {number[]} regionIds
                 * @return {string}
                 */

            }, {
                key: "getRegionNames",
                value: function getRegionNames(countryId, regionIds) {
                    var _this32 = this;

                    return regionIds.map(function (regionId) {
                        return _this32.getRegionName(countryId, regionId);
                    }).join(', ');
                }

                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return {{value: number, currency: string}}
                 */

            }, {
                key: "getDirectionPrice",
                value: function getDirectionPrice(cityId, countryId) {
                    var haveDirection = this.isDirectionAvailable(cityId, countryId);
                    return {
                        value: haveDirection ? this.directions[cityId][countryId]['price'] : 0,
                        currency: haveDirection ? this.directions[cityId][countryId]['cur'] : ''
                    };
                }

                /**
                 * @param {number} countryId
                 * @param {number} cityId
                 */

            }, {
                key: "isCountryDirectionAvailable",
                value: function isCountryDirectionAvailable(countryId, cityId) {
                    return this.countries[countryId].departs.indexOf(cityId) !== -1;
                }

                /**
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return boolean
                 */

            }, {
                key: "isDirectionAvailable",
                value: function isDirectionAvailable(cityId, countryId) {
                    return this.directions.hasOwnProperty(cityId) && this.directions[cityId].hasOwnProperty(countryId);
                }

                /**
                 *
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return {Array}
                 */

            }, {
                key: "getDirectionNights",
                value: function getDirectionNights(cityId, countryId) {
                    var nights = [];
                    if (this.isDirectionAvailable(cityId, countryId)) {
                        nights = this.directions[cityId][countryId].nights;
                    }

                    return nights.sort(function (a, b) {
                        return a - b;
                    });
                }

                /**
                 * @note Не юзайте в автокомплите. Может лагать из-за GC
                 * @param {number} countryId
                 * @return {Array}
                 */

            }, {
                key: "getSortedRegions",
                value: function getSortedRegions(countryId) {
                    var regions = [];
                    if (countryId in this.regions) {
                        for (var regionId in this.regions[countryId]) {
                            if (this.regions[countryId].hasOwnProperty(regionId)) {
                                regions.push(this.regions[countryId][regionId]);
                            }
                        }
                    }

                    if (regions.length) {
                        regions.sort(function (a, b) {
                            return b.popularity - a.popularity;
                        });
                    }

                    return regions;
                }

                /**
                 * @param {number} visaType
                 * @return {string|number}
                 */

            }, {
                key: "getVisa",
                value: function getVisa(visaType) {
                    return this.visaTypes[visaType] || visaType;
                }

                /**
                 * Получить минимальную дату начала для указанного направления
                 * @param {number} cityId
                 * @param {number} countryId
                 * @return {string}
                 */

            }, {
                key: "getMinStartDate",
                value: function getMinStartDate(cityId, countryId) {
                    // Проверяем, есть ли у направления minStartDate
                    if (this.isDirectionAvailable(cityId, countryId) && this.directions[cityId][countryId].hasOwnProperty('minStartDate') && this.directions[cityId][countryId].minStartDate !== null) {
                        return this.directions[cityId][countryId].minStartDate;
                    }

                    // Если нет minStartDate, проверяем defaultValues
                    if (this.defaultValues && this.defaultValues.hasOwnProperty('dateFrom') && this.defaultValues.dateFrom !== null) {
                        return this.defaultValues.dateFrom;
                    }

                    // Если нет defaultValues, то берем сегодня + 2 дня
                    var today = new Date();
                    today.setDate(today.getDate() + 2);

                    return String(today.getDate()).padStart(2, '0') + '.' + String(today.getMonth() + 1).padStart(2, '0') + '.' + today.getFullYear();
                }

                /**
                 * Отфильтровать массив по minStartDate
                 * @param {Array} dates
                 * @param {string} minStartDate
                 * @return {Array}
                 */

            }, {
                key: "minStartDateFilterAndSortDates",
                value: function minStartDateFilterAndSortDates(dates, minStartDate) {
                    var target = new Date(minStartDate.split(".").reverse().join("-")); // Преобразуем в объект Date

                    // Убедимся, что минимальная дата есть в массиве
                    if (!dates.includes(minStartDate)) {
                        dates.push(minStartDate); // Добавляем дату, если её нет
                    }

                    // Фильтруем массив, оставляя только даты от минимальной и позже
                    var filteredDates = dates.filter(function (date) {
                        var current = new Date(date.split(".").reverse().join("-"));
                        return current >= target;
                    });

                    // Сортируем массив по возрастанию
                    return filteredDates.sort(function (a, b) {
                        var dateA = new Date(a.split(".").reverse().join("-"));
                        var dateB = new Date(b.split(".").reverse().join("-"));
                        return dateA - dateB;
                    });
                }
            }], [{
                key: "_sortDirections",
                value: function _sortDirections(sortedDirections) {
                    sortedDirections.sort(function (a, b) {
                        return a.sort - b.sort;
                    });
                    return sortedDirections;
                }
            }]);

            return BaseSearchFormData;
        }();

        module.exports = BaseSearchFormData;
    }, { "./BaseSearchFormDataAirlines": 2, "./BaseSearchFormDataMeals": 3, "./BaseSearchFormDataOperators": 4 }], 2: [function (require, module, exports) {
        var SearchFormDataAirline = function SearchFormDataAirline(props) {
            _classCallCheck(this, SearchFormDataAirline);

            this.id = props.id;
            this.name = props.name;
            this.code = props.code;
            this.sort = props.sort;
        };

        /**
         * @property {Array<SearchFormDataAirline>} list
         * @property {{}} listByName
         */


        var SearchFormDataOperators = function () {
            function SearchFormDataOperators() {
                _classCallCheck(this, SearchFormDataOperators);

                this.reset();
            }

            /**
             * @param {Array<{}>} airlines
             */


            _createClass(SearchFormDataOperators, [{
                key: "load",
                value: function load(airlines) {
                    var _this33 = this;

                    if (airlines.length > 0) {
                        this.reset();
                        airlines.forEach(function (item, index) {
                            item.sort = index;
                            _this33.list[item.code] = new SearchFormDataAirline(item);
                        });
                    }
                }

                /** @private */

            }, {
                key: "reset",
                value: function reset() {
                    this.list = {};
                    this.listByNameDict = {};
                }

                /**
                 * @param {string[]} selectedCodes - если передали - поднять в начало списка в приоритете
                 * @return {SearchFormDataAirline[]}
                 */

            }, {
                key: "getListSorted",
                value: function getListSorted() {
                    var selectedCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                    var items = Object.values(this.list);
                    if (items.length === 0) {
                        return [];
                    }

                    items.sort(function (a, b) {
                        return a.sort - b.sort;
                    });
                    if (selectedCodes.length) {
                        // для менеджеров, чтобы могли легко отжать
                        var split = {
                            selected: [],
                            other: []
                        };
                        for (var _i12 = 0; _i12 < items.length; _i12++) {
                            if (selectedCodes.indexOf(items[_i12].code) !== -1) {
                                split.selected.push(items[_i12]);
                            } else {
                                split.other.push(items[_i12]);
                            }
                        }

                        items = split.selected.concat(split.other);
                    }

                    return items;
                }

                /**
                 * @param {string[]} airlinesCodes
                 * @return {boolean}
                 */

            }, {
                key: "isValidCodes",
                value: function isValidCodes(airlinesCodes) {
                    var len = airlinesCodes.length;
                    for (var _i13 = 0; _i13 < len; _i13++) {
                        if (!this.isExists(airlinesCodes[_i13])) {
                            return false;
                        }
                    }

                    return true;
                }

                /**
                 * @param {string} airlinesCode
                 * @return {boolean}
                 */

            }, {
                key: "isExists",
                value: function isExists(airlinesCode) {
                    return typeof this.list[airlinesCode] !== 'undefined';
                }

                /**
                 * @param {string} airlinesCode
                 * @param {boolean} short
                 * @return {string}
                 */

            }, {
                key: "getNameByCode",
                value: function getNameByCode(airlinesCode) {
                    var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var name = '';
                    if (this.isExists(airlinesCode)) {
                        name = short ? this.list[airlinesCode].code : this.list[airlinesCode].name;
                    }

                    return name;
                }

                /**
                 * @param {Array<string>} airlinesCodes
                 * @param {boolean} short
                 * @return {string[]}
                 */

            }, {
                key: "getNamesByCode",
                value: function getNamesByCode(airlinesCodes) {
                    var _this34 = this;

                    var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var names = [];
                    airlinesCodes.forEach(function (id) {
                        var name = _this34.getNameById(id, short);
                        if (name !== '') {
                            names.push(name);
                        }
                    });

                    return names;
                }

                /**
                 * Получение ID питаний по названию
                 * @param {Array<string>} names
                 * @return {number[]}
                 */

            }, {
                key: "getCodeByName",
                value: function getCodeByName(names) {
                    this.fillDictionaries();
                    var codes = [];
                    for (var _i14 = 0; _i14 < names.length; _i14++) {
                        if (this.listByNameDict.hasOwnProperty(names[_i14])) {
                            codes.push(this.listByNameDict[names[_i14]]);
                        }
                    }

                    return codes;
                }

                /** @private */

            }, {
                key: "fillDictionaries",
                value: function fillDictionaries() {
                    if (jQuery.isEmptyObject(this.listByNameDict)) {
                        for (var _i15 = 0; _i15 < this.list.length; _i15++) {
                            this.listByNameDict[this.list[_i15].name] = Number(this.list[_i15].code);
                        }
                    }
                }
            }]);

            return SearchFormDataOperators;
        }();

        module.exports = SearchFormDataOperators;
    }, {}], 3: [function (require, module, exports) {
        var SearchFormDataMeal = function SearchFormDataMeal(props) {
            _classCallCheck(this, SearchFormDataMeal);

            this.id = props.id;
            this.name = props.name;
            this.code = props.code;
            this.sort = props.sort;
        };

        /**
         * @property {Array<SearchFormDataMeal>} list
         * @property {{}} listByName
         */


        var SearchFormDataMeals = function () {
            function SearchFormDataMeals() {
                _classCallCheck(this, SearchFormDataMeals);

                this.reset();
            }

            /**
             * @param {Array<{}>} meals
             */


            _createClass(SearchFormDataMeals, [{
                key: "load",
                value: function load(meals) {
                    var _this35 = this;

                    if (meals.length > 0) {
                        this.reset();
                        meals.forEach(function (meal, index) {
                            meal.sort = index;
                            _this35.list[meal.id] = new SearchFormDataMeal(meal);
                        });
                    }
                }

                /** @private */

            }, {
                key: "reset",
                value: function reset() {
                    this.list = {};
                    this.listByNameDict = {};
                }

                /**
                 *
                 * @return {SearchFormDataMeal[]}
                 */

            }, {
                key: "getListSorted",
                value: function getListSorted() {
                    var meals = [];
                    for (var mealId in this.list) {
                        meals.push(this.list[mealId]);
                    }
                    if (meals.length) {
                        meals.sort(function (a, b) {
                            return a.sort - b.sort;
                        });
                    }

                    return meals;
                }

                /**
                 * @param {number[]} mealIds
                 * @return {boolean}
                 */

            }, {
                key: "isValidIds",
                value: function isValidIds(mealIds) {
                    var mealsCount = mealIds.length;
                    for (var _i16 = 0; _i16 < mealsCount; _i16++) {
                        if (!this.isExists(mealIds[_i16])) {
                            return false;
                        }
                    }

                    return true;
                }

                /**
                 * @param {number} mealId
                 * @return {boolean}
                 */

            }, {
                key: "isExists",
                value: function isExists(mealId) {
                    return typeof this.list[mealId] !== 'undefined';
                }

                /**
                 * @param {number} mealId
                 * @param {boolean} short
                 * @return {string}
                 */

            }, {
                key: "getNameById",
                value: function getNameById(mealId) {
                    var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var name = '';
                    if (this.isExists(mealId)) {
                        name = short ? this.list[mealId].code : this.list[mealId].name;
                    }

                    return name;
                }
                /**
                 * @param {Array<number>} mealIds
                 * @param {boolean} short
                 * @return {string[]}
                 */

            }, {
                key: "getNamesById",
                value: function getNamesById(mealIds) {
                    var _this36 = this;

                    var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var names = [];
                    mealIds.forEach(function (mealId) {
                        var name = _this36.getNameById(mealId, short);
                        if (name !== '') {
                            names.push(name);
                        }
                    });
                    return names;
                }

                /**
                 * Получение ID питаний по названию
                 * @param {Array<string>} mealNames
                 * @return {number[]}
                 */

            }, {
                key: "getIdByName",
                value: function getIdByName(mealNames) {
                    this.fillDictionaries();
                    var mealId = [];
                    for (var _i17 = 0; _i17 < mealNames.length; _i17++) {
                        if (this.listByNameDict.hasOwnProperty(mealNames[_i17])) {
                            mealId.push(this.listByNameDict[mealNames[_i17]]);
                        }
                    }

                    return mealId;
                }

                /** @private */

            }, {
                key: "fillDictionaries",
                value: function fillDictionaries() {
                    if (jQuery.isEmptyObject(this.listByNameDict)) {
                        for (var _i18 = 0; _i18 < this.list.length; _i18++) {
                            this.listByNameDict[this.list[_i18].name] = Number(this.list[_i18].id);
                        }
                    }
                }
            }]);

            return SearchFormDataMeals;
        }();

        module.exports = SearchFormDataMeals;
    }, {}], 4: [function (require, module, exports) {
        var SearchFormDataOperator = function SearchFormDataOperator(props) {
            _classCallCheck(this, SearchFormDataOperator);

            this.id = props.id;
            this.name = props.name;
            this.code = props.code;
            this.sort = props.sort;
        };

        /**
         * @property {Array<SearchFormDataOperator>} list
         * @property {{}} listByName
         */


        var SearchFormDataOperators = function () {
            function SearchFormDataOperators() {
                _classCallCheck(this, SearchFormDataOperators);

                this.reset();
            }

            /**
             * @param {Array<{}>} operators
             */


            _createClass(SearchFormDataOperators, [{
                key: "load",
                value: function load(operators) {
                    var _this37 = this;

                    if (operators.length > 0) {
                        this.reset();
                        operators.forEach(function (item, index) {
                            item.sort = index;
                            _this37.list[item.id] = new SearchFormDataOperator(item);
                        });
                    }
                }

                /** @private */

            }, {
                key: "reset",
                value: function reset() {
                    this.list = {};
                    this.listByNameDict = {};
                }

                /**
                 * @param {number[]} selectedIds - если передали - поднять в начало списка в приоритете
                 * @return {SearchFormDataOperator[]}
                 */

            }, {
                key: "getListSorted",
                value: function getListSorted() {
                    var selectedIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                    var items = Object.values(this.list);
                    if (items.length === 0) {
                        return [];
                    }

                    items.sort(function (a, b) {
                        return a.sort - b.sort;
                    });
                    if (selectedIds.length) {
                        // для менеджеров, чтобы могли легко отжать
                        var split = {
                            selected: [],
                            other: []
                        };
                        for (var _i19 = 0; _i19 < items.length; _i19++) {
                            if (selectedIds.indexOf(items[_i19].id) !== -1) {
                                split.selected.push(items[_i19]);
                            } else {
                                split.other.push(items[_i19]);
                            }
                        }

                        items = split.selected.concat(split.other);
                    }

                    return items;
                }

                /**
                 * @param {number[]} operatorIds
                 * @return {boolean}
                 */

            }, {
                key: "isValidIds",
                value: function isValidIds(operatorIds) {
                    var len = operatorIds.length;
                    for (var _i20 = 0; _i20 < len; _i20++) {
                        if (!this.isExists(operatorIds[_i20])) {
                            return false;
                        }
                    }

                    return true;
                }

                /**
                 * @param {number} operatorId
                 * @return {boolean}
                 */

            }, {
                key: "isExists",
                value: function isExists(operatorId) {
                    return typeof this.list[operatorId] !== 'undefined';
                }

                /**
                 * @param {number} operatorId
                 * @param {boolean} short
                 * @return {string}
                 */

            }, {
                key: "getNameById",
                value: function getNameById(operatorId) {
                    var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var name = '';
                    if (this.isExists(operatorId)) {
                        name = short ? this.list[operatorId].code : this.list[operatorId].name;
                    }

                    return name;
                }
                /**
                 * @param {Array<number>} operatorIds
                 * @param {boolean} short
                 * @return {string[]}
                 */

            }, {
                key: "getNamesById",
                value: function getNamesById(operatorIds) {
                    var _this38 = this;

                    var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var names = [];
                    operatorIds.forEach(function (id) {
                        var name = _this38.getNameById(id, short);
                        if (name !== '') {
                            names.push(name);
                        }
                    });
                    return names;
                }

                /**
                 * Получение ID питаний по названию
                 * @param {Array<string>} names
                 * @return {number[]}
                 */

            }, {
                key: "getIdByName",
                value: function getIdByName(names) {
                    this.fillDictionaries();
                    var ids = [];
                    for (var _i21 = 0; _i21 < names.length; _i21++) {
                        if (this.listByNameDict.hasOwnProperty(names[_i21])) {
                            ids.push(this.listByNameDict[names[_i21]]);
                        }
                    }

                    return ids;
                }

                /** @private */

            }, {
                key: "fillDictionaries",
                value: function fillDictionaries() {
                    if (jQuery.isEmptyObject(this.listByNameDict)) {
                        for (var _i22 = 0; _i22 < this.list.length; _i22++) {
                            this.listByNameDict[this.list[_i22].name] = Number(this.list[_i22].id);
                        }
                    }
                }
            }]);

            return SearchFormDataOperators;
        }();

        module.exports = SearchFormDataOperators;
    }, {}], 5: [function (require, module, exports) {
        var STARS_ANY = 0;

        var REGIONS_ANY = 0;

        var CITY_DEFAULT = 1; // ALMATY

        var MOMENT_DATE_FORMAT = 'DD.MM.YYYY';

        var _require4 = require('./BaseSearchFormValuesHotel'),
            BaseSearchFormValuesHotel = _require4.BaseSearchFormValuesHotel;

        /**
         * @param {string[]|number[]} array
         */


        function arrayToInt(array) {
            var arrayInt = [];
            array.forEach(function (value) {
                arrayInt.push(parseInt(value, 10));
            });

            return arrayInt;
        }
        /**
         * @protected {Date} selectedDate
         * @protected {boolean} isSoftDates
         */

        var BaseSearchFormValues = function () {
            /**
             * @param {{}} values
             */
            function BaseSearchFormValues(values) {
                _classCallCheck(this, BaseSearchFormValues);

                console.info(values);
                this.departCityId = parseInt(values.departCityId, 10);
                this.countryId = parseInt(values.countryId, 10) || 0;

                /** @type {number[]} */
                this.regionIds = [];
                if (values.regionIds.length) {
                    this.setRegionIds(values.regionIds);
                }

                /** @type {BaseSearchFormValuesHotel|null} */
                this.selectedHotel = values.selectedHotel ? new BaseSearchFormValuesHotel(values.selectedHotel) : null;

                var selectedDate = void 0;
                if (typeof values.selectedDate === 'string') {
                    var date = values.selectedDate.split('.');
                    selectedDate = new Date(date[2], date[1] - 1, date[0]);
                } else {
                    // Например, this.clone()
                    selectedDate = values.selectedDate;
                }
                /** @type {Date} */
                this.selectedDate = selectedDate;
                /** @type {boolean} Гибкий поиск +- 3дня */
                this.isSoftDates = !!values.isSoftDates;
                this.rangeDays = 2;

                /** @type {number} */
                this.nightsFrom = parseInt(values.nightsFrom, 10);
                /** @type {number} */
                this.nightsTo = parseInt(values.nightsTo, 10);
                /** @type {number} */
                this.adult = parseInt(values.adult, 10);
                /** @type {number} */
                this.child = parseInt(values.child, 10);
                /** @type {number[]} */
                this.childAges = values.childAges;
                /** @type {number[]} */
                this.starsList = [];
                if (values.starsList.length) {
                    this.setStarsList(values.starsList);
                }

                /** @type {number[]} */
                this.mealIds = values.mealIds;

                /** @type {number[]} */
                this.operatorIds = values.operatorIds || [];

                /** @type {string[]} */
                this.airlineCodes = values.airlineCodes || [];

                /** @type {boolean} */
                this.search = !!values.search;

                /** @type {boolean} */
                this.emitSearchParams = !!values.emitSearchParams;

                /** @type {number} - 0|1|2 */
                this.combined = values.combined;
                /** @type {boolean} */
                this.splitRooms = false; // !!values.splitRooms;
                /** @type {boolean} */
                this.allowGds = true; // true|false
            }

            /**
             * @return {{from: Date, to: Date}}
             */


            _createClass(BaseSearchFormValues, [{
                key: "setSelectedHotel",


                /**
                 * @param {number} hotelId
                 * @param {string} hotelName
                 * @param {number} countryId
                 */
                value: function setSelectedHotel(hotelId, hotelName, countryId) {
                    this.selectedHotel = new BaseSearchFormValuesHotel({
                        id: Number(hotelId),
                        name: hotelName,
                        countryId: Number(countryId)
                    });
                }
            }, {
                key: "resetHotel",
                value: function resetHotel() {
                    this.selectedHotel = null;
                }
            }, {
                key: "setDefaultDepartCity",
                value: function setDefaultDepartCity() {
                    this.departCityId = CITY_DEFAULT;
                }
            }, {
                key: "resetMealsList",
                value: function resetMealsList() {
                    this.mealIds = [];
                }
            }, {
                key: "resetOperatorsList",
                value: function resetOperatorsList() {
                    this.operatorIds = [];
                }
            }, {
                key: "resetAirlineCodesList",
                value: function resetAirlineCodesList() {
                    this.airlineCodes = [];
                }
            }, {
                key: "resetDestination",
                value: function resetDestination() {
                    this.countryId = 0;
                    this.regionIds = [];
                    this.resetHotel();
                }

                /**
                 * @param {Date} date
                 * @param {string|null} format
                 * @return {string}
                 */

            }, {
                key: "getDateAsValue",
                value: function getDateAsValue(date) {
                    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    var day = ('0' + date.getDate()).slice(-2);
                    var month = ('0' + (date.getMonth() + 1)).slice(-2);
                    if (format === 'YYYY-MM-DD') {
                        return date.getFullYear() + "-" + month + "-" + day;
                    }
                    return day + '.' + month + '.' + date.getFullYear(); // MOMENT_DATE_FORMAT
                }
            }, {
                key: "getSelectedHotelsId",
                value: function getSelectedHotelsId() {
                    var hotelIds = [];
                    if (this.selectedHotel) {
                        hotelIds.push(this.selectedHotel.id);
                    }

                    return hotelIds;
                }

                /**
                 * Поиск будет начинаться на этой же странице, без перехода
                 * @return {boolean}
                 */

            }, {
                key: "isStartOnCurrentPage",
                value: function isStartOnCurrentPage() {
                    return this.search;
                }

                /** @param {number[]} regionIds */

            }, {
                key: "setRegionIds",
                value: function setRegionIds(regionIds) {
                    this.regionIds = arrayToInt(regionIds);
                }

                /** @param {number[]} stars */

            }, {
                key: "setStarsList",
                value: function setStarsList(stars) {
                    this.starsList = arrayToInt(stars).sort(function (a, b) {
                        return a - b;
                    });
                }

                /** @param {number[]} mealIds */

            }, {
                key: "setMealsList",
                value: function setMealsList(mealIds) {
                    this.mealIds = arrayToInt(mealIds);
                }
            }, {
                key: "setOperatorIds",
                value: function setOperatorIds(operatorIds) {
                    this.operatorIds = arrayToInt(operatorIds);
                }
            }, {
                key: "setAirlineCodes",
                value: function setAirlineCodes(airlineCodes) {
                    this.airlineCodes = airlineCodes;
                }

                /**
                 * @return {window.search.Query}
                 */

            }, {
                key: "getSearchQuery",
                value: function getSearchQuery() {
                    var params = Object.assign({}, this);
                    params.hotelIds = this.getSelectedHotelsId();
                    var dateRange = this.dateRange;
                    params.dateFrom = dateRange.from;
                    params.dateTo = dateRange.to;
                    params.combined = this.combined;
                    params.notGDS = !this.allowGds; // disable gds true|false
                    params.operatorIds = this.operatorIds;
                    params.airlineCodes = this.airlineCodes;
                    if (params.mealIds.length) {
                        params.mealIds = this.mealIds;
                    }
                    if (params.child) {
                        params.childAges = params.childAges.slice(0, this.child);
                    }

                    return new window.search.Query(params);
                }

                /**
                 * Возвращает значения в формате для календаря в angular
                 * @returns {BaseSearchFormValues}
                 */

            }, {
                key: "getNgCalendarParams",
                value: function getNgCalendarParams() {
                    var paramsValues = Object.assign({}, this);
                    paramsValues.selectedDate = this.getDateAsValue(paramsValues.selectedDate, 'YYYY-MM-DD');
                    return paramsValues;
                }
            }, {
                key: "dateRange",
                get: function get() {
                    var date = this.selectedDate.getDate();
                    var rangeDays = this.isSoftDates ? this.rangeDays : 0;
                    var from = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), date - rangeDays);
                    var to = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), date + rangeDays);

                    return { from: from, to: to };
                }
            }]);

            return BaseSearchFormValues;
        }();

        module.exports = {
            BaseSearchFormValues: BaseSearchFormValues,
            STARS_ANY: STARS_ANY,
            MOMENT_DATE_FORMAT: MOMENT_DATE_FORMAT
        };
    }, { "./BaseSearchFormValuesHotel": 6 }], 6: [function (require, module, exports) {
        var BaseSearchFormValuesHotel =
        /**
         * @param {{
         *   id: number,
         *   name: string,
         *   countryId: number
         * }} props
         */
        function BaseSearchFormValuesHotel(props) {
            _classCallCheck(this, BaseSearchFormValuesHotel);

            this.id = props.id;
            this.name = props.name;
            this.countryId = props.countryId;
        };

        module.exports = {
            BaseSearchFormValuesHotel: BaseSearchFormValuesHotel
        };
    }, {}], 7: [function (require, module, exports) {
        var MODE_DEFAULT = 'default';
        var MODE_ONLY_CURRENT_HOTEL_SEARCH = 'hotel';
        var app = window.app;

        var SearchFormData = require('../../include/_js/SearchFormData');

        var _require5 = require('../../include/_js/SearchFormValues'),
            SearchFormValues = _require5.SearchFormValues,
            STARS_ANY = _require5.STARS_ANY;

        var _require6 = require('../../include/_js/FormValidator'),
            FormValidator = _require6.FormValidator,
            formValidatorFields = _require6.formValidatorFields;

        var i18nPlural = window.brxUtils.i18n.plural;
        //const i18nTemplate = window.brxUtils.i18n.template;
        var i18nTemplate = window.utils.i18nTemplate;

        var FindFormDepartCitySelect = window.FindFormDepartCitySelect;
        var FindFormDestination = window.FindFormDestination;
        var FindFormCalendar = window.FindFormCalendar;
        var FindFormDuration = window.FindFormDuration;
        var FindFormTourists = window.FindFormTourists;
        var FindFormStars = window.FindFormStars;
        var FindFormMeals = window.FindFormMeals;
        var FindFormOperators = window.FindFormOperators;
        var FindFormAirlines = window.FindFormAirlines;

        var panelsId = {
            mainForm: 'find-form-main-panel',
            people: 'find-form-people-panel',
            datepicker: 'find-form-datepicker',
            duration: 'find-form-duration-panel'
        };

        var hiddenFieldNames = {
            city: 'departCity',
            country: 'country',
            regions: 'regions',
            hotels: 'hotels',
            adult: 'adult',
            child: 'child',
            childAges: 'childAges',
            splitRooms: 'splitRooms',
            starsList: 'starsList',
            durationFrom: 'nightsFrom',
            durationTo: 'nightsTo',
            selectedDate: 'dateFrom',
            dateDelta: 'delta',
            meals: 'meals',
            operators: 'operators',
            airlines: 'airlines',
            search: 'search'
        };

        var SearchForm = function () {
            /**
             * @param {{}} data
             * @param {{}} values
             * @param {{ mode: string }} options
             */
            function SearchForm(data, values, options) {
                var _this39 = this;

                _classCallCheck(this, SearchForm);

                this.submitIndex = 0;
                this.searchStartNewIndex = 0;
                /**
                 * @protected
                 * @type {SearchFormData}
                 */
                this.data = new SearchFormData(data); // shared with DestinationForm
                /**
                 * @protected
                 * @type {SearchFormValues}
                 */
                this.values = new SearchFormValues(values);
                this.mode = 'mode' in options ? options.mode : '';
                /**
                 * @protected
                 * @type {null|boolean}
                 */
                this.isDestroyed = null;
                /**
                 * @protected
                 * @type {SearchFormValuesLabel}
                 */
                this.valuesLabel = new window.SearchFormValuesLabel(this.data, this.values);

                this.translates = window.findFormTranslates;

                this.messages = {
                    calendarTitle: this.translates.departDate,
                    labelDestPlaceholder: this.translates.notChosen,
                    labelDateDiff: this.translates.labelDateDiff,
                    info: {
                        noDirection: this.translates.noDirection
                    },
                    validator: {
                        noCountry: this.translates.noCountry,
                        noChildAge: this.translates.noChildAge
                    }
                };

                this.elements = {
                    $form: $('#' + panelsId.mainForm), // Основная форма поиска. Блок с оберткой
                    // Описание состояния формы поиска на странице, снаружи формы поиска
                    $stateDescription: $('.js-find-form-state')
                };
                this.elements.$stateFlag = this.elements.$stateDescription.find('.country-flag');
                this.countryMenu = new CountryMenu();

                // Загрузка данных и инициализация формы поиска
                if (this.data.isLoaded.data) {
                    this.init();
                } else {
                    var countryId = null;
                    if (this.mode === MODE_ONLY_CURRENT_HOTEL_SEARCH && this.values.countryId) {
                        countryId = this.values.countryId;
                    }
                    this.data.load(function () {
                        _this39.init();
                    }, countryId);
                }
            }

            _createClass(SearchForm, [{
                key: "processValues",


                /**
                 * Обработать значения формы на основе загруженных данных.
                 * Если выбранного направления нет в ответе - сбросить
                 */
                value: function processValues() {
                    // Если в шапке выбрали город, по которому у нас нет вылетов, то ставим Алматы
                    if (!this.data.isCityExists(this.values.departCityId)) {
                        this.values.setDefaultDepartCity();
                    }

                    if (this.values.countryId && !this.data.isDirectionAvailable(this.values.departCityId, this.values.countryId)) {
                        // Направление недоступно
                        this.values.resetDestination();
                    }

                    if (this.mode === MODE_ONLY_CURRENT_HOTEL_SEARCH && !this.values.countryId) {
                        // Выбор направления скрыты. Т.к. изменить направление нет возможности - удаляем форму
                        this.destroy();
                        return false;
                    }

                    if (this.values.mealIds.length > 0) {
                        if (!this.data.meals.isValidIds(this.values.mealIds)) {
                            this.values.resetMealsList(); // Сбросить все
                            this.setHiddenValue(hiddenFieldNames.meals, this.values.mealIds.join(','));
                        }
                    }

                    if (this.values.operatorIds.length > 0) {
                        if (!this.data.operators.isValidIds(this.values.operatorIds)) {
                            this.values.resetOperatorsList(); // Сбросить все
                            this.setHiddenValue(hiddenFieldNames.operators, this.values.operatorIds.join(','));
                        }
                    }

                    if (this.values.airlineCodes.length > 0) {
                        if (!this.data.airlines.isValidCodes(this.values.airlineCodes)) {
                            this.values.resetAirlineCodesList(); // Сбросить все
                            this.setHiddenValue(hiddenFieldNames.airlines, this.values.airlineCodes.join(','));
                        }
                    }

                    // Т.к. выше направление могло быть изменено, обновляем значения в форме
                    this.setHiddenValue(hiddenFieldNames.city, this.values.departCityId);
                    this.setDestinationHiddenValues();

                    return true;
                }
            }, {
                key: "destroy",
                value: function destroy() {
                    this.isDestroyed = true;
                    $('.search-form-container').parent().remove(); // Форма поиска
                    $('.js-find-form-open-button').remove(); // Кнопки открытия формы поиска
                    $('.hide-on-search-form-destroy').addClass('hidden');

                    // Уведомление наружу "от формы ничего не ждать"
                    window.dispatchEvent(new CustomEvent('search-form:destroyed'));
                }
            }, {
                key: "init",
                value: function init() {
                    var _this40 = this;

                    if (!this.processValues()) {
                        // Переданы несовместимые значения,
                        // по какой-либо причине сбросить к дефолтному состоянию нельзя
                        console.log('SearchForm. Destroyed due to incompatible values', {
                            mode: this.mode,
                            countryId: this.values.countryId
                        });
                        this.destroy();
                        return;
                    }

                    this.initControls();
                    this.renderLabels();

                    this.elements.$form.removeClass('loading');
                    this.elements.$stateDescription.removeClass('loading');

                    this.bindFormEventListeners();
                    this.bindHotTableEventsListeners();
                    this.bindTabsEventListeners();
                    this.bindGlobalEventListeners();

                    this.durationSelect.init();
                    this.updateDurationRange();

                    this.setHiddenValue(hiddenFieldNames.search, 1);
                    if (this.values.isStartOnCurrentPage()) {
                        // Валидация формы и подсветка ошибок
                        if (this.validateForm()) {
                            // Начинаем поиск
                            // delay на загрузку angular (ready раньше чем обработка angular)
                            setTimeout(function () {
                                console.log('triggerFormSubmit', Date.now());
                                _this40.triggerFormSubmit();
                            }, 30);
                        } else {
                            // Показываем форму с подсвеченными ошибками
                            this.open();
                        }
                    }

                    // todo: вынести отдельно
                    app.lastDepartCityId = this.values.departCityId;
                    app.lastCountryToId = this.values.countryId;
                    app.adultCount = this.values.adult;
                    if (this.values.child) {
                        app.hasChild = true;
                    }
                    app.childCount = this.values.child;
                    if (this.values.childAges) {
                        app.hasInfant = this.values.childAges.some(function (age) {
                            return age >= 0 && age <= 2;
                        });
                    }
                }
            }, {
                key: "initControls",
                value: function initControls() {
                    var _this41 = this;

                    /**
                     * Выбор звезд
                     * @type {FindFormStars}
                     */
                    this.starsSelect = new FindFormStars({
                        onChange: function onChange(values) {
                            _this41.onStarsChange(values);
                        }
                    });
                    /**
                     * Выбор питания
                     * @type {FindFormMeals}
                     */
                    this.mealsSelect = new FindFormMeals({
                        onChange: function onChange(values) {
                            _this41.onMealsChange(values);
                        }
                    });
                    /**
                     * Выбор оператора
                     * @type {FindFormOperators}
                     */
                    this.operatorsSelect = new FindFormOperators({
                        onChange: function onChange(values) {
                            _this41.onOperatorsChange(values);
                        }
                    });
                    /**
                     * Выбор оператора
                     * @type {FindFormMeals}
                     */
                    this.airlinesSelect = new FindFormAirlines({
                        onChange: function onChange(values) {
                            _this41.onAirlinesChange(values);
                        }
                    });

                    /**
                     * Выбор города вылета
                     * @type {FindFormDepartCitySelect}
                     */
                    this.citySelect = new FindFormDepartCitySelect({
                        allowChangeCityOnLocation: !this.values.isStartOnCurrentPage(),
                        onChange: function onChange(departCityId) {
                            // При onLocation город может не быть доступен в поиске
                            _this41.onCityChange(Number(departCityId));
                        }
                    });
                    /**
                     * Выбор кол-ва туристов
                     * @type {FindFormTourists}
                     */
                    this.peopleCounter = new FindFormTourists(panelsId.people, {
                        getSelectionLabel: function getSelectionLabel(adult, child) {
                            return _this41.valuesLabel.tourists.getLabel({
                                adult: adult,
                                child: child,
                                full: true
                            });
                        },
                        onChange: function onChange() {
                            _this41.onPeopleChange();
                        }
                    });
                    this.peopleCounter.setValues(this.values.adult, this.values.child, this.values.childAges, this.values.splitRooms);
                    /**
                     * Выбор продолжительности (ночей)
                     * @type {FindFormDuration}
                     */
                    this.durationSelect = new FindFormDuration(panelsId.duration, {
                        onChange: function onChange() {
                            _this41.onDurationChange();
                        },
                        onHandleRelease: function onHandleRelease() {
                            _this41.toggleDurationRangeMessage();
                        },
                        onBeforeClose: function onBeforeClose() {
                            _this41.availableDates();
                        }
                    });
                    /**
                     * Выбор направления.
                     * Внутри могут быть доп. загружены данные в this.data.
                     * @type {FindFormDestination}
                     */
                    this.destinationSelect = new FindFormDestination(this.data, {
                        onChange: function onChange() {
                            _this41.onDestinationFormChange();
                        },
                        onBeforeClose: function onBeforeClose(isOpenedFindFormRequired) {
                            if (isOpenedFindFormRequired) {
                                _this41.open();
                            }
                            _this41.availableDates();
                        }
                    });

                    // Календарь не хранит актуальные значения!
                    // Значение в календаре устанавливается на момент открытия!
                    this.calendar = new FindFormCalendar({
                        containerId: panelsId.datepicker,
                        values: this.values,
                        messages: this.valuesLabel.messages.calendar,
                        getDateRangeLabel: function getDateRangeLabel() {
                            return _this41.valuesLabel.getDateRangeSummaryLabel();
                        },
                        onChange: function onChange(date, isSoftDates) {
                            _this41.onDepartDateChange(date, isSoftDates);
                        }
                    });
                }
            }, {
                key: "setHiddenValue",
                value: function setHiddenValue(inputName, value) {
                    this.elements.$form.find('input[name="' + inputName + '"]').val(value);
                }

                /** События внутри формы поиска (главный экран и модалки) */

            }, {
                key: "bindFormEventListeners",
                value: function bindFormEventListeners() {
                    var _this42 = this;

                    // enable submit button
                    this.elements.$form.find('.find-form-submit-button[disabled]').prop('disabled', false);

                    // Переключение между формами выбора параметров
                    this.elements.$form
                    // at the first interaction of the client with the form
                    // .one('click', '.find-form-field', () => {})
                    .on('submit', 'form', function (e) {
                        console.log('SearchForm submit handler', Date.now());
                        // $(this).blur(); // submit button blur // TODO:
                        var isValid = _this42.validateForm();
                        // search will start on current page or values is not valid
                        if (!isValid || _this42.values.isStartOnCurrentPage()) {
                            e.preventDefault();
                        }
                        if (!isValid) {
                            // validation error
                            _this42.scrollToFormTop();
                            return false;
                        }

                        if (_this42.values.isStartOnCurrentPage()) {
                            // Закрываем модалку
                            window.findFormModal.closeParent(_this42.elements.$form);
                        }
                        // Уведомление об отправке формы
                        // для страницы "Отеля" с календарем служит как событие запуска поиска
                        _this42.dispatchFormValuesSubmitEvent();
                        if (_this42.values.emitSearchParams) {
                            // search is started by external CustomEvent Submit listener
                            return false;
                        }

                        if (!_this42.values.isStartOnCurrentPage()) {
                            // if submit event is not prevented with validation success
                            _this42.elements.$form.find('.find-form-submit-button').prop('disabled', true);
                            _this42.elements.$form.addClass('loading sending');
                        } else {
                            // При поиске на текущей странице
                            var isSubmitDispatched = false;
                            var isSubmitFromModal = window.findFormModal.closeParent(_this42.elements.$form, function () {
                                // При открытой модалке скрол на body отключен.
                                // При старте поиска hot-table дергает scrollToTableTop.
                                // Запускаем поиск после закрытия модалки и включения скрола
                                if (!isSubmitDispatched) {
                                    _this42.dispatchStartNewSearchEvent();
                                    isSubmitDispatched = true;
                                }
                            });
                            if (!isSubmitFromModal) {
                                _this42.dispatchStartNewSearchEvent();
                                isSubmitDispatched = true;
                            }
                        }

                        return true;
                    }).on('click', '.form-field--depart-date', function () {
                        // Валидация поля "Куда", с подсветкой в случае ошибки
                        if (_this42.validateForm(true, [formValidatorFields.COUNTRY])) {
                            // Открывает только если со страной все ОК
                            _this42.openDatepicker();
                        } else {
                            // Показать ошибку валидации
                            _this42.scrollToFormTop();
                        }
                    }).on('click', '.form-field--depart-city', function () {
                        return _this42.openCities();
                    }).on('click', '.form-field--destination', function () {
                        return _this42.openDestinationForm('all');
                    }).on('click', '.form-field--stars', function () {
                        return _this42.openStars();
                    }).on('click', '.form-field--meals', function () {
                        return _this42.openMeals();
                    }).on('click', '.form-field--operators', function () {
                        return _this42.openOperators();
                    }).on('click', '.form-field--airlines', function () {
                        return _this42.openAirlines();
                    }).on('click', '.form-field--tourists', function () {
                        return _this42.peopleCounter.open();
                    }).on('click', '.form-field--duration', function () {
                        return _this42.durationSelect.open();
                    });
                }

                /** События общения с hot-table */

            }, {
                key: "bindHotTableEventsListeners",
                value: function bindHotTableEventsListeners() {
                    var _this43 = this;

                    // Выбор отеля в автокомлите
                    window.addEventListener('search:select-hotel', function (event) {
                        var hotel = event.detail.hotel;
                        _this43.destinationSelect.values.setHotel({
                            id: hotel.id,
                            name: hotel.name,
                            countryId: hotel.countryId
                        });
                        _this43.onDestinationFormChange();
                        _this43.open();
                    });
                    // Повторно запустить поиск
                    window.addEventListener('search:repeat-search', function () {
                        _this43.triggerFormSubmit();
                    });
                    window.addEventListener('search-form:open-hotels-search', function () {
                        _this43.openDestinationForm('only-hotels');
                    });
                    window.addEventListener('ng-hotel-price-calendar:start', function () {
                        _this43.dispatchStartNewSearchEvent();
                    });
                    // Подписка на клик по дате в календаре цен на отели
                    window.addEventListener('ng-hotel-price-calendar:select-date', function (event) {
                        var _event$detail = event.detail,
                            nightsFrom = _event$detail.nightsFrom,
                            nightsTo = _event$detail.nightsTo,
                            date = _event$detail.date;
                        // Дата в YYYY-MM-DD, но нам нужно в DD.MM.YYYY

                        var selectedDate = new Date(date);

                        // Изменяем форму поиска
                        // Сейчас в стороннем календаре на странице можно выбрать только конкретное кол-во ночей
                        // Если возникнет ситуация с range - форма поиска не будет изменена т.к. "-1" ночей недоступно
                        var nights = nightsFrom === nightsTo ? nightsFrom : -1;
                        _this43.setPageCalendarValues(selectedDate, nights);

                        _this43.dispatchStartNewCalendarSearchEvent({
                            nightsFrom: nightsFrom,
                            nightsTo: nightsTo,
                            selectedDate: selectedDate
                        });
                    });

                    window.addEventListener('search-form:submit', function (event) {
                        //Если это на странице отеля то показываем кнопку перехода к турам
                        if (_this43.mode === MODE_ONLY_CURRENT_HOTEL_SEARCH) {
                            var urlParams = event.detail.urlParams;

                            var customEvent = new CustomEvent('tour-list', { detail: urlParams });
                            window.dispatchEvent(customEvent);
                        }
                    });
                }

                /** События вне формы поиска (глобальные кнопки, и т.п.) */

            }, {
                key: "bindGlobalEventListeners",
                value: function bindGlobalEventListeners() {
                    var _this44 = this;

                    $('body')
                    // Кнопки открытия формы поиска
                    .on('click', '.js-find-form-open-button', function () {
                        _this44.open();
                        if (_this44.mode === MODE_ONLY_CURRENT_HOTEL_SEARCH) {
                            window.brxTracking.sendAnalyticsEvent('click_top_search_form_open');
                        }
                    });

                    // TODO: рефакторинг
                    // Выбор даты с графика цен/календаря на странице поиска
                    $(window).on('findToursChartBarClick', function (event, _ref5) {
                        var days = _ref5.days,
                            date = _ref5.date;

                        var selectedDate = date ? _this44.parseDate(date, 'DD.MM.YYYY') : null;
                        var nights = days - 1;

                        var _setPageCalendarValue = _this44.setPageCalendarValues(selectedDate, nights),
                            isDateAvailable = _setPageCalendarValue.isDateAvailable,
                            isNightsAvailable = _setPageCalendarValue.isNightsAvailable;

                        if (isDateAvailable && isNightsAvailable) {
                            // Начинаем поиск или перекидываем на страницу поиска
                            _this44.triggerFormSubmit();
                        } else if (_this44.values.isStartOnCurrentPage()) {
                            // Если одно из значений недоступно в поиске:
                            // Просто начинаем поиск НА ТЕКУЩЕЙ СТРАНИЦЕ, без изменения формы
                            _this44.dispatchStartNewCalendarSearchEvent({
                                selectedDate: selectedDate || _this44.values.selectedDate,
                                nightsFrom: nights,
                                nightsTo: nights
                            });
                        }
                        if (selectedDate && !isDateAvailable) {
                            console.warn('Невозможно установить указанную дату вылета: %s', selectedDate);
                        }
                    });
                }

                // todo: отделить от формы поиска

            }, {
                key: "bindTabsEventListeners",
                value: function bindTabsEventListeners() {
                    $(document).ready(function () {
                        $('.search-form-type').on('click', function () {
                            var $tab = $(this);
                            if ($tab.hasClass('active')) {
                                return;
                            }

                            var $searchFormTours = $('.sf-tab-content--tours');
                            var $hotToursTabDivLine = $('.search-form-tabs-container .div-line');

                            $('.search-form-type.active').removeClass('active');
                            $tab.addClass('active');
                            $searchFormTours.removeClass('hidden');
                            $hotToursTabDivLine.removeClass('hidden');
                        });

                        $('.search-form-type-hot-tours').click(function () {
                            window.showPageLoader();

                            if (window.cities[app.city.id]) {
                                window.location.href = '/hottours/for-' + window.cities[app.city.id].name_en;
                            } else {
                                window.location.href = '/hottours';
                            }
                        });

                        $('.search-form-type-cruises').click(function () {
                            window.showPageLoader();
                            window.location.href = '/cruise#';
                        });
                    });
                }

                /**
                 * Установить данные при выборе с календаря на странице (вне формы поиска)
                 * @param {Date} selectedDate
                 * @param {number} nights - точное значение, range на данный момент не поддерживается
                 * return {{
                 *     isDateAvailable: boolean,
                 *     isNightsAvailable: boolean,
                 * }}
                 */

            }, {
                key: "setPageCalendarValues",
                value: function setPageCalendarValues(selectedDate, nights) {
                    // Календарь ограничен до now+6month (установка даты за пределами диапазона не проверена)
                    // const isDateAvailable = selectedDate === null || this.calendar.canSelectDate(selectedDate);
                    var isDateAvailable = true;
                    // Кол-во вариаций ночей допустимых для выбора в форме поиска ограничено
                    var isNightsAvailable = this.setDurationNights(nights);

                    if (isDateAvailable && isNightsAvailable) {
                        if (selectedDate !== null) {
                            this.calendar.setSelectedDate(selectedDate, false);
                        }
                    }

                    if (selectedDate && !isDateAvailable) {
                        console.warn('Невозможно установить указанную дату вылета: %s', selectedDate);
                    }

                    return {
                        isDateAvailable: isDateAvailable,
                        isNightsAvailable: isNightsAvailable
                    };
                }
            }, {
                key: "renderLabels",
                value: function renderLabels() {
                    this.renderDepartCityLabel();
                    this.renderDestinationLabel();
                    this.renderPeopleLabel();
                    this.renderDurationLabel();
                    this.renderDepartDateLabel();
                    this.renderStarsLabel();
                    this.renderMealsLabel();
                    this.renderOperatorsLabel();
                    this.renderAirlinesLabel();
                }
            }, {
                key: "renderDepartCityLabel",
                value: function renderDepartCityLabel() {
                    var city = this.data.getCity(this.values.departCityId);
                    this.elements.$form.find('.form-field--depart-city .js-value').html(city.name);
                }
            }, {
                key: "renderDestinationLabel",
                value: function renderDestinationLabel() {
                    var destinationLabel = this.valuesLabel.getDestinationLabel();
                    if (destinationLabel === '') {
                        destinationLabel = this.messages.labelDestPlaceholder + '...';
                    }
                    var $destination = this.elements.$form.find('.form-field--destination');
                    $destination.find('.js-value').html(destinationLabel);
                    var countryId = this.values.countryId;
                    // Маркер "Выбрано"|"Не выбрано"
                    $destination.toggleClass('form-field--empty', !countryId);
                    // update state desctiption flag
                    if (this.elements.$stateFlag.length && countryId) {
                        // Флаг отражает текущее состояние формы поиска. Поэтому отдельно от меню
                        var code = this.data.getCountryCode(this.values.countryId);
                        var flag = "/fls/flag/round/" + code + ".svg";
                        this.elements.$stateFlag.css('backgroundImage', 'url(' + flag + ')');
                    }
                    // refresh country menu
                    if (this.values.isStartOnCurrentPage() && this.countryMenu.isCountryChanged(countryId)) {
                        // подмена меню должна выполняться только на страницах поиска
                        this.countryMenu.loadCountryMenu(countryId);
                    }
                }
            }, {
                key: "renderStarsLabel",
                value: function renderStarsLabel() {
                    this.elements.$form.find('.form-field--stars .js-value').html(this.valuesLabel.getStarsLabel());
                }
            }, {
                key: "renderDepartDateLabel",
                value: function renderDepartDateLabel() {
                    var daysRangeLabel = this.messages.labelDateDiff;
                    var active = this.values.isSoftDates ? 'active' : '';
                    var badge = "<span class=\"form-badge " + active + "\">" + daysRangeLabel + "</span>";
                    this.elements.$form.find('.form-field--depart-date .js-value').html(this.valuesLabel.getSelectedDateLabel() + badge);
                    this.elements.$stateDescription.find('.depart-date-label').text(this.valuesLabel.getDateRangeStateLabel());
                }
            }, {
                key: "renderDurationLabel",
                value: function renderDurationLabel() {
                    this.elements.$form.find('.form-field--duration .js-value').html(this.valuesLabel.getDurationFaceLabel());
                    this.durationSelect.renderSummary(this.valuesLabel.getDurationSummaryLabel());
                    this.elements.$stateDescription.find('.duration-label').text(this.valuesLabel.getDurationStateLabel());
                }
            }, {
                key: "renderPeopleLabel",
                value: function renderPeopleLabel() {
                    this.elements.$form.find('.form-field--tourists .js-value').html(this.valuesLabel.getTouristsLabelWithChildAges(true));
                    this.elements.$stateDescription.find('.tourists-label').text(this.valuesLabel.getTouristsLabel());
                }
            }, {
                key: "renderMealsLabel",
                value: function renderMealsLabel() {
                    this.elements.$form.find('.form-field--meals .js-value').html(this.valuesLabel.getMealsLabel());
                }
            }, {
                key: "renderOperatorsLabel",
                value: function renderOperatorsLabel() {
                    this.elements.$form.find('.form-field--operators .js-value').html(this.valuesLabel.getOperatorsLabel());
                }
            }, {
                key: "renderAirlinesLabel",
                value: function renderAirlinesLabel() {
                    this.elements.$form.find('.form-field--airlines .js-value').html(this.valuesLabel.getAirlinesLabel());
                }
            }, {
                key: "open",
                value: function open() {
                    window.findFormModal.open({
                        header: {
                            theme: findFormModal.themes.TRANSPARENT
                        },
                        content: {
                            htmlDetachSelectorId: panelsId.mainForm
                        }
                    });
                }
            }, {
                key: "openCities",
                value: function openCities() {
                    this.citySelect.open(this.data.getSortedCities(), this.values.departCityId);
                }
            }, {
                key: "openStars",
                value: function openStars() {
                    this.starsSelect.open(this.values.starsList);
                }
            }, {
                key: "openMeals",
                value: function openMeals() {
                    this.mealsSelect.open(this.data.meals.getListSorted(), this.values.mealIds);
                }
            }, {
                key: "openOperators",
                value: function openOperators() {
                    this.operatorsSelect.open(this.data.operators.getListSorted(this.values.operatorIds), this.values.operatorIds);
                }
            }, {
                key: "openAirlines",
                value: function openAirlines() {
                    this.airlinesSelect.open(this.data.airlines.getListSorted(this.values.airlineCodes), this.values.airlineCodes);
                }
            }, {
                key: "openDestinationForm",
                value: function openDestinationForm() {
                    var formMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';

                    this.citySelect.disableChangeOnLocation();
                    this.destinationSelect.setFormMode(formMode);
                    this.destinationSelect.open(this.values.countryId, this.values.departCityId);
                }
            }, {
                key: "openDatepicker",
                value: function openDatepicker() {
                    this.calendar.open({
                        values: this.values,
                        calendarTitle: this.messages.calendarTitle,
                        daysRangeLabel: this.messages.labelDateDiff,
                        availableDates: this.availableDates(),
                        /** @param {FindFormCalendar} instance */
                        onAfterInit: function onAfterInit(instance) {}
                    });
                }

                /**
                 * @private
                 * @param {number} nights
                 * @return {boolean}
                 */

            }, {
                key: "setDurationNights",
                value: function setDurationNights(nights) {
                    var isAvailable = this.durationSelect.isAvailable(nights);
                    if (isAvailable) {
                        // Оба значения доступны для выбора в форме поиска - меняем форму
                        this.values.nightsFrom = nights;
                        this.values.nightsTo = nights;
                        this.updateDurationRange();
                        this.onDurationChange();
                    } else {
                        console.log('Невозможно установить указанное кол-во ночей: %s', nights);
                    }

                    return isAvailable;
                }
            }, {
                key: "updateDurationRange",
                value: function updateDurationRange() {
                    // let nights = [];
                    // if (this.values.countryId) {
                    //     nights = this.data.getDirectionNights(
                    //         this.values.departCityId,
                    //         this.values.countryId
                    //     );
                    // }
                    this.durationSelect.setNightsValues(this.values.nightsFrom, this.values.nightsTo, []);
                    this.toggleDurationRangeMessage();
                }

                /** @param {number} departCityId */

            }, {
                key: "onCityChange",
                value: function onCityChange(departCityId) {
                    if (!this.data.isCityExists(departCityId)) {
                        // 1. При onLocation город может не быть доступен в поиске
                        // 2. При выборе отеля из автокомплита angular город не пробрасывается
                        console.warn('FindForm. Ignored attempt to set non exist city ' + departCityId);
                        return false;
                    }

                    this.values.departCityId = departCityId;
                    this.renderDepartCityLabel();
                    if (this.values.countryId) {
                        if (!this.data.isDirectionAvailable(this.values.departCityId, this.values.countryId)) {
                            // show tooltip about values reset
                            var country = this.data.getCountry(this.values.countryId);
                            var city = this.data.getCity(this.values.departCityId);
                            var message = i18nTemplate(this.messages.info.noDirection, {
                                country: country.name,
                                fromCity: city.nameFrom
                            });
                            var $field = this.elements.$form.find('.form-field--destination');
                            FormFieldTooltip.remove($field);
                            FormFieldTooltip.add($field, message, 3500);

                            // reset current values
                            this.values.resetDestination();
                            this.onDestinationChanged();
                        }
                    }
                    this.setHiddenValue(hiddenFieldNames.city, departCityId);
                    return true;
                }

                /** Изменение направления при выборе в модалке "Страна, Курорт, Отель" */

            }, {
                key: "onDestinationFormChange",
                value: function onDestinationFormChange() {
                    /**
                     * @type {DestinationFormValues}
                     */
                    var values = this.destinationSelect.values;
                    this.values.resetDestination();
                    this.values.countryId = values.countryId;
                    if (values.selectedHotel !== null) {
                        // Выбран отель
                        var hotel = values.selectedHotel;
                        this.values.setSelectedHotel(hotel.id, hotel.name, hotel.countryId);
                    } else if (values.regionIds.length !== 0) {
                        // Выбран регион
                        this.values.setRegionIds(values.regionIds);
                    }
                    // При выборе из автокомплита отелей angular города может не быть в форме
                    if (values.departCityId !== this.values.departCityId) {
                        this.onCityChange(values.departCityId);
                    }

                    this.onDestinationChanged();
                }
            }, {
                key: "onDestinationChanged",
                value: function onDestinationChanged() {
                    this.updateDurationRange();
                    this.setDestinationHiddenValues();
                    this.renderDestinationLabel();
                }

                /** @param {number[]} values */

            }, {
                key: "onMealsChange",
                value: function onMealsChange(values) {
                    this.values.setMealsList(values);
                    this.setHiddenValue(hiddenFieldNames.meals, values.join(','));
                    this.renderMealsLabel();
                }

                /** @param {number[]} values */

            }, {
                key: "onOperatorsChange",
                value: function onOperatorsChange(values) {
                    this.values.setOperatorIds(values);
                    this.setHiddenValue(hiddenFieldNames.operators, values.join(','));
                    this.renderOperatorsLabel();
                }

                /** @param {string[]} values */

            }, {
                key: "onAirlinesChange",
                value: function onAirlinesChange(values) {
                    this.values.setAirlineCodes(values);
                    this.setHiddenValue(hiddenFieldNames.airlines, values.join(','));
                    this.renderAirlinesLabel();
                }

                /** @param {number[]} values */

            }, {
                key: "onStarsChange",
                value: function onStarsChange(values) {
                    this.values.setStarsList(values);
                    this.setHiddenValue(hiddenFieldNames.starsList, values.join(','));
                    this.renderStarsLabel();
                }
            }, {
                key: "onPeopleChange",
                value: function onPeopleChange() {
                    this.values.adult = this.peopleCounter.values.adult;
                    this.values.child = this.peopleCounter.values.child;
                    this.values.childAges = this.peopleCounter.values.childAges;
                    this.values.splitRooms = this.peopleCounter.values.splitRooms;

                    this.setHiddenValue(hiddenFieldNames.adult, this.values.adult);
                    this.setHiddenValue(hiddenFieldNames.child, this.values.child);
                    this.setHiddenValue(hiddenFieldNames.childAges, this.values.childAges.join(','));
                    this.setHiddenValue(hiddenFieldNames.splitRooms, this.values.splitRooms ? 1 : 0);

                    this.renderPeopleLabel();
                }
            }, {
                key: "onDurationChange",
                value: function onDurationChange() {
                    var _durationSelect$value = this.durationSelect.values,
                        nightsFrom = _durationSelect$value.nightsFrom,
                        nightsTo = _durationSelect$value.nightsTo;

                    this.values.nightsFrom = nightsFrom;
                    this.values.nightsTo = nightsTo;

                    // В форме в ночах дни, исторически =(
                    this.setHiddenValue(hiddenFieldNames.durationFrom, this.values.nightsFrom + 1); // #nightsAsDays
                    this.setHiddenValue(hiddenFieldNames.durationTo, this.values.nightsTo + 1); // #nightsAsDays

                    this.renderDurationLabel();
                }

                /**
                 * @private
                 * Колбек при изменении даты в календаре
                 * @see this.calendar.setSelectedDate() для изменения
                 * @param {Date} selectedDate
                 * @param {boolean} isSoftDates
                 */

            }, {
                key: "onDepartDateChange",
                value: function onDepartDateChange(selectedDate, isSoftDates) {
                    this.values.isSoftDates = isSoftDates;
                    this.values.selectedDate = selectedDate;
                    this.setHiddenValue(hiddenFieldNames.selectedDate, this.values.getDateAsValue(selectedDate));
                    this.setHiddenValue(hiddenFieldNames.dateDelta, this.values.isSoftDates ? 1 : 0);

                    this.renderDepartDateLabel();
                }
            }, {
                key: "setDestinationHiddenValues",
                value: function setDestinationHiddenValues() {
                    this.setHiddenValue(hiddenFieldNames.country, this.values.countryId);
                    this.setHiddenValue(hiddenFieldNames.regions, this.values.regionIds.join(','));
                    this.setHiddenValue(hiddenFieldNames.hotels, this.values.getSelectedHotelsId().join(','));
                }

                /** TODO: делаем фичу? */

            }, {
                key: "toggleDurationRangeMessage",
                value: function toggleDurationRangeMessage() {}

                /**
                 * @param {boolean} highlightErrors
                 * @param {string[]|null} attributes
                 * @return {boolean}
                 */

            }, {
                key: "validateForm",
                value: function validateForm() {
                    var highlightErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                    var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    var validator = this.getValidator();
                    var isValid = validator.validate(this.values, attributes);
                    if (!isValid && highlightErrors) {
                        this.highlightErrors(validator);
                    }

                    return isValid;
                }

                /**
                 * @return {FormValidator}
                 */

            }, {
                key: "getValidator",
                value: function getValidator() {
                    return new FormValidator({
                        messages: this.messages.validator,
                        onHighlightErrorFieldAdd: function onHighlightErrorFieldAdd($field, message) {
                            FormFieldTooltip.add($field, message, 3500);
                        },
                        onHighlightErrorFieldRemove: function onHighlightErrorFieldRemove($field) {
                            FormFieldTooltip.remove($field);
                        }
                    });
                }

                /**
                 * @param {FormValidator} validator
                 */

            }, {
                key: "highlightErrors",
                value: function highlightErrors(validator) {
                    validator.highlightErrors(this.elements.$form, 'click');
                }
            }, {
                key: "scrollToFormTop",
                value: function scrollToFormTop() {
                    if (!this.values.isStartOnCurrentPage()) {
                        // scroll first error field into viewport
                        window.scrollToElement(this.elements.$form, 0, 400);
                    }
                }
            }, {
                key: "triggerFormSubmit",
                value: function triggerFormSubmit() {
                    this.$formElement.submit();
                }

                /** @private */

            }, {
                key: "dispatchFormValuesSubmitEvent",
                value: function dispatchFormValuesSubmitEvent() {
                    var event = new CustomEvent('search-form:submit', {
                        detail: {
                            values: this.values.getNgCalendarParams(),
                            index: ++this.submitIndex,
                            urlParams: this.$formElement.serialize()
                        }
                    });
                    window.dispatchEvent(event);
                }

                /**
                 * @private
                 * Запуск поиска при выборе даты в календаре
                 * ВАЖНО! В данном случае форма поиска не меняется!
                 *  Причина (теоретически):
                 *  снаружи может быть выбрана дата/ночи которые недоступны в форме поиска
                 *  e.g. На странице отеля (тура)
                 * @param {Date} selectedDate
                 * @param {number} nightsFrom
                 * @param {number} nightsTo
                 */

            }, {
                key: "dispatchStartNewCalendarSearchEvent",
                value: function dispatchStartNewCalendarSearchEvent(_ref6) {
                    var selectedDate = _ref6.selectedDate,
                        nightsFrom = _ref6.nightsFrom,
                        nightsTo = _ref6.nightsTo;

                    var values = this.values.clone();
                    values.nightsFrom = nightsFrom;
                    values.nightsTo = nightsTo;
                    values.isSoftDates = false;
                    values.selectedDate = selectedDate;

                    this.dispatchStartNewSearchEvent(values);
                }

                /**
                 * @private
                 * Начать поиск
                 * @param {SearchFormValues|null} customFormValues
                 */

            }, {
                key: "dispatchStartNewSearchEvent",
                value: function dispatchStartNewSearchEvent() {
                    var customFormValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                    var formParams = customFormValues !== null ? customFormValues.getSearchQuery() : this.values.getSearchQuery();

                    var searchEvent = new CustomEvent('search:start-new', {
                        detail: {
                            index: ++this.searchStartNewIndex,
                            formParams: formParams,
                            isOnlyHotels: false,
                            isSplitRooms: this.values.splitRooms
                        }
                    });

                    console.log('dispatchStartNewSearchEvent search:start-new', formParams, Date.now());
                    window.dispatchEvent(searchEvent);
                    this.trackStartNewSearch();
                }

                /** @private log search description. Translation is not required! */

            }, {
                key: "trackStartNewSearch",
                value: function trackStartNewSearch() {
                    var values = this.values;
                    var valuesLabel = this.valuesLabel;
                    var description = this.data.getCity(values.departCityId).name + "-" + valuesLabel.getDestinationLabel(true) + (" c " + valuesLabel.getDateRangeLabel()) + (" (\u043D\u0430 " + valuesLabel.getDurationStatLabel() + ")") + (", " + valuesLabel.getTouristsLabelWithChildAges()) + (values.starsList.length ? ", \u0437\u0432\u0435\u0437\u0434\u043D\u043E\u0441\u0442\u044C: " + valuesLabel.getStarsLabel() : '') + (values.mealIds.length ? ", \u043F\u0438\u0442\u0430\u043D\u0438\u0435: " + valuesLabel.getMealsLabel() : '') + (values.operatorIds.length ? ", \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440: " + valuesLabel.getOperatorsLabel() : '') + (values.airlineCodes.length ? ", \u0430\u0432\u0438\u0430: " + valuesLabel.getAirlinesLabel() : '') + (values.splitRooms ? ', Несколько комнат: Да' : '');

                    var $form = this.$formElement;
                    var href = $form.prop('action') + '?' + $form.serialize();
                    if (window.brxUserActivity) {
                        window.brxUserActivity.saveSearch(href, description);
                    }
                    $.cookie('search_form_last_params', JSON.stringify({
                        departCity: values.departCityId,
                        country: values.countryId,
                        stars: values.starsList
                    }), { expires: 7, path: '/' });
                }

                /**
                 *
                 * @param {string} date
                 * @param {string} format
                 * @return {Date|null}
                 */

            }, {
                key: "parseDate",
                value: function parseDate(date, format) {
                    if (!date) {
                        return null;
                    }
                    var dateObj = null;
                    if (format === 'DD.MM.YYYY') {
                        var items = date.split('.');
                        dateObj = items.length === 3 ? new Date(items[2], items[1] - 1, items[0]) : dateObj;
                    }

                    return dateObj;
                }

                /**
                 * Дергается снаружи формы пspinnerоиск глобально
                 * @return {{toCountry: string|null}}
                 */

            }, {
                key: "getAngularDescriptions",
                value: function getAngularDescriptions() {
                    var response = {
                        toCountry: null
                    };
                    if (this.values.countryId) {
                        var country = this.data.getCountry(this.values.countryId);
                        response.toCountry = country.to + ' ' + country.nameTo;
                    }
                    return response;
                }
            }, {
                key: "getAngularIsDestroyed",
                value: function getAngularIsDestroyed() {
                    return this.isDestroyed === true;
                }
            }, {
                key: "availableDates",
                value: function availableDates() {
                    var _this45 = this;

                    var selectedHotelId = null;
                    var _values = this.values,
                        departCityId = _values.departCityId,
                        countryId = _values.countryId,
                        regionIds = _values.regionIds,
                        selectedHotel = _values.selectedHotel,
                        nightsFrom = _values.nightsFrom,
                        nightsTo = _values.nightsTo;

                    var availableDates = [];
                    var isDatesLoaded = true;

                    if (selectedHotel) {
                        selectedHotelId = selectedHotel.id;
                    }

                    if (this.values.countryId) {
                        isDatesLoaded = this.data.isDatesLoaded(departCityId, countryId, regionIds, selectedHotelId, nightsFrom, nightsTo);
                        if (isDatesLoaded) {
                            availableDates = this.data.getDates(departCityId, countryId, regionIds, selectedHotelId, nightsFrom, nightsTo);
                        }
                    }

                    if (!isDatesLoaded) {
                        this.data.loadDates(departCityId, countryId, regionIds.join(","), selectedHotelId, nightsFrom, nightsTo, function () {
                            var sendFormBtn = _this45.elements.$form.find('.find-form-submit-button');
                            var dates = _this45.data.getDates(departCityId, countryId, regionIds, selectedHotelId, nightsFrom, nightsTo);

                            var isSendForm = false;

                            var selectedDate = _this45.values.selectedDate ? new Date(_this45.values.selectedDate) : null;
                            if (selectedDate) {
                                if (_this45.values.isSoftDates && _this45.values.rangeDays) {
                                    var from = new Date(selectedDate);
                                    var to = new Date(selectedDate);
                                    from.setDate(from.getDate() - _this45.values.rangeDays);
                                    to.setDate(to.getDate() + _this45.values.rangeDays);

                                    isSendForm = dates.some(function (date) {
                                        var _date$split$map = date.split('.').map(Number),
                                            _date$split$map2 = _slicedToArray(_date$split$map, 3),
                                            day = _date$split$map2[0],
                                            month = _date$split$map2[1],
                                            year = _date$split$map2[2];

                                        var d = new Date(year, month - 1, day);
                                        return d >= from && d <= to;
                                    });
                                } else {
                                    isSendForm = dates.some(function (date) {
                                        var _date$split$map3 = date.split('.').map(Number),
                                            _date$split$map4 = _slicedToArray(_date$split$map3, 3),
                                            day = _date$split$map4[0],
                                            month = _date$split$map4[1],
                                            year = _date$split$map4[2];

                                        var d = new Date(year, month - 1, day); // Месяц от 0 до 11
                                        return d.toDateString() === selectedDate.toDateString();
                                    });
                                }
                            }

                            var curText = sendFormBtn.text();
                            var dataText = sendFormBtn.data('text');

                            if (!isSendForm) {
                                if (!dataText) {
                                    sendFormBtn.data('text', curText);
                                }
                                sendFormBtn.text('Нет туров на эти даты');
                                window.brxTracking.sendAnalyticsEvent('search_form_dates_not_available');
                            } else {
                                if (dataText) {
                                    sendFormBtn.text(dataText);
                                    sendFormBtn.data('text', '');
                                }
                            }

                            sendFormBtn.prop('disabled', !isSendForm);

                            _this45.calendar.setLoadedAvailableDates(dates);
                        });
                    }

                    return availableDates;
                }
            }, {
                key: "$formElement",
                get: function get() {
                    return this.elements.$form.find('form');
                }
            }]);

            return SearchForm;
        }();

        window.SearchForm = SearchForm;
    }, { "../../include/_js/FormValidator": 8, "../../include/_js/SearchFormData": 9, "../../include/_js/SearchFormValues": 10 }], 8: [function (require, module, exports) {
        var FIELD_COUNTRY = 'country';
        var FIELD_DATE = 'date';
        var FIELD_NIGHTS = 'nights';
        var FIELD_TOURISTS = 'people';
        var FIELD_STARS = 'stars';
        var FIELD_MEALS = 'meals';

        var FormValidator = function () {
            /**
             * @param {{
             *     onHighlightErrorFieldAdd: Function,
             *     onHighlightErrorFieldRemove: Function,
             *     messages: { noCountry: string, noChildAge: string }
             * }} options
             */
            function FormValidator(options) {
                _classCallCheck(this, FormValidator);

                this.messages = options.messages;
                this.field = '.form-field';
                this.fields = this.getFieldsSelectors();

                this.onHighlightErrorFieldAdd = options.onHighlightErrorFieldAdd || null;
                this.onHighlightErrorFieldRemove = options.onHighlightErrorFieldRemove || null;

                this.errors = [];
            }

            /**
             * Список полей и соответствующие этим полям селекторы DOM
             * @return {{}}
             */


            _createClass(FormValidator, [{
                key: "getFieldsSelectors",
                value: function getFieldsSelectors() {
                    var fields = {};
                    fields[FIELD_COUNTRY] = this.field + '--destination';
                    fields[FIELD_DATE] = this.field + '--depart-date';
                    fields[FIELD_NIGHTS] = this.field + '--duration';
                    fields[FIELD_TOURISTS] = this.field + '--tourists';
                    fields[FIELD_STARS] = this.field + '--stars';
                    fields[FIELD_MEALS] = this.field + '--meals';

                    return fields;
                }

                /**
                 * @param {BaseSearchFormValues} values
                 * @param {string[]|null} attributes
                 * @return {boolean}
                 */

            }, {
                key: "validate",
                value: function validate(values) {
                    var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

                    this.errors = [];

                    if (attributes === null) {
                        attributes = [FIELD_COUNTRY, FIELD_TOURISTS];
                    }

                    if (!values.countryId && this.isFieldExist(attributes, FIELD_COUNTRY)) {
                        this.errors.push({ field: FIELD_COUNTRY, message: this.messages.noCountry });
                    }
                    if (values.child && values.child > values.childAges.length && this.isFieldExist(attributes, FIELD_TOURISTS)) {
                        this.errors.push({ field: FIELD_TOURISTS, message: this.messages.noChildAge });
                    }

                    return !this.errors.length;
                }

                /**
                 * @param {string[]} fields
                 * @param {string} field
                 */

            }, {
                key: "isFieldExist",
                value: function isFieldExist(fields, field) {
                    return fields.indexOf(field) !== -1;
                }

                /**
                 * @param {jQuery} $form
                 * @param {string} dismissEvent
                 * @return {boolean}
                 */

            }, {
                key: "highlightErrors",
                value: function highlightErrors($form, dismissEvent) {
                    if (this.errors.length === 0) {
                        return false;
                    }

                    var error = void 0;
                    var fieldSelector = void 0;
                    var $field = void 0;
                    for (var _i23 = 0; _i23 < this.errors.length; _i23++) {
                        error = this.errors[_i23];
                        fieldSelector = this.fields[error.field];
                        $field = $form.find(fieldSelector);
                        if ($field.length) {
                            this.highlightErrorField($field, dismissEvent, error.message);
                        }
                    }

                    return true;
                }

                /**
                 * @private
                 * @param {jQuery} $field
                 * @param {string} dismissEvent
                 * @param {string} errorMessage
                 */

            }, {
                key: "highlightErrorField",
                value: function highlightErrorField($field, dismissEvent, errorMessage) {
                    var _this46 = this;

                    $field.addClass('has-error');
                    if (dismissEvent === 'click') {
                        $field.one('click', function (e) {
                            var $targetField = $(e.currentTarget);
                            $targetField.removeClass('has-error');
                            _this46.dispatchOnHighlightErrorRemove($targetField);
                        });
                    } else {
                        $field.find('input').one('change', function (e) {
                            var $targetField = $(e.currentTarget).closest(_this46.field);
                            $targetField.removeClass('has-error');
                            _this46.dispatchOnHighlightErrorRemove($targetField);
                        });
                    }
                    this.dispatchOnHighlightErrorAdd($field, errorMessage);
                }
            }, {
                key: "dispatchOnHighlightErrorAdd",
                value: function dispatchOnHighlightErrorAdd($field, message) {
                    if (this.onHighlightErrorFieldAdd) {
                        this.onHighlightErrorFieldAdd($field, message);
                    }
                }
            }, {
                key: "dispatchOnHighlightErrorRemove",
                value: function dispatchOnHighlightErrorRemove($field) {
                    if (this.onHighlightErrorFieldRemove) {
                        this.onHighlightErrorFieldRemove($field);
                    }
                }
            }]);

            return FormValidator;
        }();

        module.exports = {
            FormValidator: FormValidator,
            formValidatorFields: {
                COUNTRY: FIELD_COUNTRY,
                TOURISTS: FIELD_TOURISTS
                // DATE: FIELD_DATE,
                // NIGHTS: FIELD_NIGHTS,
                // STARS: FIELD_STARS,
                // MEALS: FIELD_MEALS,
            }
        };
    }, {}], 9: [function (require, module, exports) {
        var BaseSearchFormData = require('../../../../../include/find-form/_js/BaseSearchFormData');

        var SearchFormData = function (_BaseSearchFormData) {
            _inherits(SearchFormData, _BaseSearchFormData);

            function SearchFormData(data) {
                _classCallCheck(this, SearchFormData);

                return _possibleConstructorReturn(this, (SearchFormData.__proto__ || Object.getPrototypeOf(SearchFormData)).call(this, data));
            }

            return SearchFormData;
        }(BaseSearchFormData);

        module.exports = SearchFormData;
    }, { "../../../../../include/find-form/_js/BaseSearchFormData": 1 }], 10: [function (require, module, exports) {
        var _require7 = require('../../../../../include/find-form/_js/BaseSearchFormValues'),
            BaseSearchFormValues = _require7.BaseSearchFormValues,
            STARS_ANY = _require7.STARS_ANY;

        var SearchFormValues = function (_BaseSearchFormValues) {
            _inherits(SearchFormValues, _BaseSearchFormValues);

            function SearchFormValues() {
                _classCallCheck(this, SearchFormValues);

                return _possibleConstructorReturn(this, (SearchFormValues.__proto__ || Object.getPrototypeOf(SearchFormValues)).apply(this, arguments));
            }

            _createClass(SearchFormValues, [{
                key: "clone",
                value: function clone() {
                    var values = Object.assign({}, this);
                    return new SearchFormValues(values);
                }
            }, {
                key: "getSelectedDateAsValue",
                value: function getSelectedDateAsValue() {
                    return this.getDateAsValue(this.selectedDate);
                }
            }, {
                key: "duration",

                /**
                 * Возвращает используемое на данный момент значение продолжительности (дни или ночи)
                 * @return {{from: number, to: number}}
                 */
                get: function get() {
                    return {
                        from: this.nightsFrom + 1,
                        to: this.nightsTo + 1
                    };
                }
            }]);

            return SearchFormValues;
        }(BaseSearchFormValues);

        module.exports = {
            SearchFormValues: SearchFormValues,
            STARS_ANY: STARS_ANY
        };
    }, { "../../../../../include/find-form/_js/BaseSearchFormValues": 5 }] }, {}, [7]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /**
         * TODO: скопирован старый код. Но он не работает
         * Закоментил чтобы было удалено при сборке
         * /
        class SearchFormHistory {
            //COPY PASTE TODO:
            //обновление параметров поиска в адресной строке
            refreshQuery() {
                var params = {};
                params.departCity = this.city_id;
                params.country = this.country_id;
                params.region = this.region_id ? this.region_id : '';
                params.nightsFrom = this.nights[0];
                params.nightsTo = this.nights[1];
                params.stars = this.stars ? this.stars : "any";
                params.adult = this.adult ? this.adult : 2;
                params.child = this.child ? this.child : 0;
                params.hotel = this.hotels.length ? this.hotels.join(',') : '';
                params.ch1 = (1 <= this.child) ? this.age[0] : 0;
                params.ch2 = (2 <= this.child) ? this.age[1] : 0;
                params.ch3 = (3 <= this.child) ? this.age[2] : 0;
                params.ch4 = (4 <= this.child) ? this.age[3] : 0;
                params.dateFrom = this.date.format('DD.MM.YYYY');
                params.delta = this.dateDelta ? 1 : 0;
                params.search = 1;
                if (this.splitRooms) {
                    params.splitRooms = 1;
                }
                var href = '/findtours?', t = '', k;
                for (k in params) {
                    href += t + k + '=' + params[k];
                    t = '&';
                }
                if (this.useHistory) {
                    history.pushState(params, 'Подбор тура из Астаны и Алматы, поиск тура онлайн', href);
                }
                var $footerThemeChange = $('footer.main .force-mobile a');
                $footerThemeChange.prop('href', href + '&forceMobile=' + $footerThemeChange.data('force-mobile'));
        
                window.brxUserActivity.saveSearch(
                    location.origin + href,
                    this.createHistoryDesc(params)
                );
        
                this.refreshHistory(params);
            }
        
            //COPY PASTE TODO:
            //инициализация истории: смотрим был ли поиск ранее и выводим его
            _initializeHistory() {
                if (!this.historyList) return;
                if ('localStorage' in window == false) return;
                var ls = window.localStorage;
                var sKeys = {}, html = '';
                var k = ls.getItem('search');
                if (null != k) sKeys = JSON.parse(k);
        
                for (k in sKeys) {
                    html += this.createHistoryRow(sKeys[k]);
                }
                if ('' == html) return;
                $('.hotHistory a').remove();		//очищаем поле
                $('.hotHistory span').after(html);
                $('.hotHistory').show();
            }
        
            //COPY PASTE  TODO:
            createHistoryRow(params) {
                if (!this.countries.hasOwnProperty(params.country)) return '';
                var html = this.countries[params.country].name;
                var nDate = moment(params.dateFrom, 'DD.MM.YYYY');
                //var toDate = moment(params.dateTo, 'DD.MM.YYYY');
                var dd = this.createDateRange(nDate, params.delta);
                nDate = dd.dateFrom.clone();
                var toDate = dd.dateTo.clone();
                if (nDate.unix() === toDate.unix()) {
                    html += ' на ' + $.datepicker.formatDate('d MM', nDate.toDate(), {});
                } else if (nDate.format('M.YYYY') === toDate.format('M.YYYY')) {
                    html += ' с ' + nDate.format('D') + ' по ' + $.datepicker.formatDate('d MM', toDate.toDate(), {});
                } else {
                    html += ' с ' + $.datepicker.formatDate('d MM', nDate.toDate(), {}) + ' по ' + $.datepicker.formatDate('d MM', toDate.toDate(), {});
                }
        
                var href = '/findtours?', t = '', k;
                for (k in params) {
                    if (params.hasOwnProperty(k)) {
                        href += t + k + '=' + params[k];
                        t = '&';
                    }
                }
        
                return '<a href="' + href + '" class="history-item">' + html + '</a>';
            }
        
            //COPY PASTE  TODO:
            createHistoryDesc(params) {
                if (!this.countries.hasOwnProperty(params.country) ||
                    !this.data.hasOwnProperty(params.departCity)) return '';
                var html = this.countries[params.country].name;
                html += ' из ' + this.data[params.departCity].name2;
                var nDate = moment(params.dateFrom, 'DD.MM.YYYY');
                //var toDate = moment(params.dateTo, 'DD.MM.YYYY');
                var dd = this.createDateRange(nDate, params.delta);
                nDate = dd.dateFrom.clone();
                var toDate = dd.dateTo.clone();
                if (nDate.unix() === toDate.unix()) {
                    html += ' на ' + $.datepicker.formatDate('d MM', nDate.toDate(), {});
                } else if (nDate.format('M.YYYY') === toDate.format('M.YYYY')) {
                    html += ' с ' + nDate.format('D') + ' по ' + $.datepicker.formatDate('d MM', toDate.toDate(), {});
                } else {
                    html += ' с ' + $.datepicker.formatDate('d MM', nDate.toDate(), {}) + ' по ' + $.datepicker.formatDate('d MM', toDate.toDate(), {});
                }
        
                html += ', на ' + params.nightsFrom + '-' + params.nightsTo + ' дней';
                html += ', ' + params.adult + 'взр';
                if (params.child > 0) {
                    html += '+' + params.child + 'реб(';
                    var ages = [params.ch1, params.ch2], t = '';
                    ages.forEach(function (age) {
                        if (age > 0) {
                            html += t + age;
                            t = ',';
                        }
                    });
                    html += ')';
                }
        
                return html;
            }
        
            //COPY PASTE TODO:
            //обновление поля "недавно искали"
            refreshHistory(params) {
                if (!this.historyList) return;
                if (!isLocalStorageNameSupported()) return;
                var ins = true;
                var ls = window.localStorage;
                //hex_md5(hash_st);
                //проверяем был ли такой поиск
                var hash = this.generateHistoryHash(params);
                this._initializeHistory();	//перерисовываем элементы
                var k = ls.getItem('search'), sKeys = {};
                if (null !== k) {
                    sKeys = JSON.parse(k);
                }
        
        
                var kk, item, hh;
                for (kk in sKeys) {
                    item = sKeys[kk];
                    hh = this.generateHistoryHash(item);
                    if (hh === hash) {
                        ins = false;
                        //поменять местами новый поиск и старый - удаляем старый, в начало дописываем новый
                        delete(sKeys[kk]);
        
                        sKeys = this.addHistoryElem(sKeys, item);
                        ls.setItem('search', JSON.stringify(sKeys));
                        break;
                    }
                }
        
                if (ins) {
                    //пишем в localstorage
                    sKeys = this.addHistoryElem(sKeys, params);
        
                    //обновляем html
                    // var html = this.createHistoryRow(params);
                    // $('.hotHistory span').after(html);
                    // $('.hotHistory').show();
                }
        
                if (count(sKeys) > 5) {
                    //удаляем последний
                    for (kk in sKeys) {
                    }	//в kk будет лежать последний индекс
                    delete(sKeys[kk]);
                }
                ls.setItem('search', JSON.stringify(sKeys));
                //if (ins) this._initializeHistory();	//перерисовываем элементы
            }
        
            //COPY PASTE TODO:
            addHistoryElem(sKeys, item) {
                var tmp = {};
                var k = this.generateHistoryKey();
                tmp[k] = item;
                for (var t in sKeys) {
                    if (sKeys.hasOwnProperty(t)) {
                        tmp[t] = sKeys[t];
                    }
                }
                return JSON.parse(JSON.stringify(tmp));
            }
        
            //COPY PASTE TODO:
            generateHistoryHash(params) {
                var h = '';
                h += 'city=' + params.departCity;
                h += 'country=' + params.country;
                h += 'region=' + params.region;
                h += 'date=' + params.dateFrom;
                h += 'dateDelta=' + params.delta;
                h += 'nightsFrom=' + params.nightsFrom;
                h += 'nightsTo=' + params.nightsTo;
                h += 'stars=' + params.stars;
                h += 'adult=' + params.adult;
                h += 'child=' + params.child;
                h += 'ch1' + params.ch1;
                h += 'ch2' + params.ch2;
                h += 'hotel' + params.hotel;
        
                return hex_md5(h);
            }
        
            //COPY PASTE TODO:
            generateHistoryKey() {
                if ('localStorage' in window === false) return '';
                var f = 1, key = '';
                while (f) {
                    var k = window.localStorage.getItem('search');
                    var sKeys = {};
                    if (null !== k) sKeys = JSON.parse(k);
        
                    key = 'k' + (Math.floor(Math.random() * 1000) + 1);
                    if (false === (key in sKeys)) f = 0;
                }
                return key;
            }
        }
        /* */
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var i18nPlural = window.brxUtils.i18n.plural;
        var i18nTemplate = window.brxUtils.i18n.template;
        var translates = window.findFormTranslates;

        /**
         * Формирование текстового описания текущих значений формы
         */

        var SearchFormTouristsLabel = function () {
            function SearchFormTouristsLabel() {
                _classCallCheck(this, SearchFormTouristsLabel);

                this.messages = {
                    pluralAdults: translates.pluralAdults.split('|'),
                    pluralChild: translates.pluralChild.split('|'),
                    labelAdultAndChild: '{adult}, {child}'
                };
            }

            /**
             * Кол-во туристов. Формат для лейбла формы поиска "Кто едет? ..."
             * @param {number} adult
             * @param {number} child
             * @param {boolean} full
             * @param {string[]|null} adultWords
             * @param {string[]|null} childWords
             * @return {string}
             */


            _createClass(SearchFormTouristsLabel, [{
                key: "getLabel",
                value: function getLabel(_ref7) {
                    var adult = _ref7.adult,
                        child = _ref7.child,
                        _ref7$full = _ref7.full,
                        full = _ref7$full === undefined ? false : _ref7$full,
                        _ref7$adultWords = _ref7.adultWords,
                        adultWords = _ref7$adultWords === undefined ? null : _ref7$adultWords,
                        _ref7$childWords = _ref7.childWords,
                        childWords = _ref7$childWords === undefined ? null : _ref7$childWords;

                    var adultWord = i18nPlural(adult, adultWords || this.messages.pluralAdults);
                    var adultLabel = adult + ' ' + (full ? adultWord : adultWord.slice(0, 3) + '.');
                    if (child > 0) {
                        var childWord = i18nPlural(child, childWords || this.messages.pluralChild);
                        return i18nTemplate(this.messages.labelAdultAndChild, {
                            adult: adultLabel,
                            child: child + ' ' + (full ? childWord : childWord.slice(0, 3) + '.')
                        });
                    }

                    return adultLabel;
                }
            }]);

            return SearchFormTouristsLabel;
        }();

        var SearchFormValuesLabel = function () {
            function SearchFormValuesLabel(data, values) {
                _classCallCheck(this, SearchFormValuesLabel);

                /** @type {SearchFormData} */
                this.data = data;
                /** @type {SearchFormValues} */
                this.values = values;
                this.messages = {
                    labelStarsAny: translates.labelStarsAny,
                    labelMealsAny: translates.labelMealsAny,
                    labelOperatorsAny: translates.labelOperatorsAny,
                    labelAirlinesAny: translates.labelAirlinesAny,
                    labelDuration: '{value}',
                    labelDurationRange: translates.labelDurationRange,
                    pluralStars: translates.pluralStars.split('|'),
                    pluralResorts: translates.pluralResorts.split('|'),
                    pluralDuration: translates.pluralDuration.split('|'),
                    calendar: {
                        months: translates.months,
                        monthsOn: translates.monthsOn,
                        dayNames: translates.dayNames
                    }
                };
                this.tourists = new SearchFormTouristsLabel();
            }

            /**
             * @param {string} rangeSeparator
             * @return {string}
             */


            _createClass(SearchFormValuesLabel, [{
                key: "getDurationLabel",
                value: function getDurationLabel() {
                    var rangeSeparator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-';
                    var _values$duration = this.values.duration,
                        from = _values$duration.from,
                        to = _values$duration.to;

                    return from + (from !== to ? rangeSeparator + to : '');
                }

                /**
                 * e.g. Модалка выбора длительности (под шапкой)
                 * @returns {string}
                 */

            }, {
                key: "getDurationSummaryLabel",
                value: function getDurationSummaryLabel() {
                    return this.getDurationLabel(' — ') + ' ' + i18nPlural(this.values.duration.from, this.messages.pluralDuration);
                }

                /**
                 * e.g. Кнопка в шапке сайта
                 * @returns {string}
                 */

            }, {
                key: "getDurationStateLabel",
                value: function getDurationStateLabel() {
                    return this.getDurationLabel() + ' ' + i18nPlural(this.values.duration.from, this.messages.pluralDuration);
                }

                /**
                 * Описание поискового запроса
                 * @returns {string}
                 */

            }, {
                key: "getDurationStatLabel",
                value: function getDurationStatLabel() {
                    return this.getDurationLabel() + ' ' + i18nPlural(this.values.duration.from, this.messages.pluralDuration);
                }

                /**
                 * @return {string}
                 */

            }, {
                key: "getDurationFaceLabel",
                value: function getDurationFaceLabel() {
                    var _values$duration2 = this.values.duration,
                        from = _values$duration2.from,
                        to = _values$duration2.to;

                    if (from === to) {
                        return i18nTemplate(this.messages.labelDuration, { value: from });
                    }
                    return i18nTemplate(this.messages.labelDurationRange, { from: from, to: to });
                }
            }, {
                key: "getStarsLabel",
                value: function getStarsLabel() {
                    var starsList = this.values.starsList;
                    if (starsList.length === 0) {
                        return this.messages.labelStarsAny;
                    }
                    var maxStars = starsList[starsList.length - 1];

                    return starsList.join(', ') + ' ' + i18nPlural(maxStars, this.messages.pluralStars);
                }
            }, {
                key: "getMealsLabel",
                value: function getMealsLabel() {
                    var mealIds = this.values.mealIds;
                    var mealsCount = mealIds.length;
                    var isShortNames = mealsCount > 1;
                    if (mealsCount === 0) {
                        return this.messages.labelMealsAny;
                    }
                    return this.data.meals.getNamesById(mealIds, isShortNames).join(', ');
                }
            }, {
                key: "getOperatorsLabel",
                value: function getOperatorsLabel() {
                    var ids = this.values.operatorIds;
                    var count = ids.length;
                    var isShortNames = count > 1;
                    if (count === 0) {
                        return this.messages.labelOperatorsAny;
                    }
                    return this.data.operators.getNamesById(ids, isShortNames).join(', ');
                }
            }, {
                key: "getAirlinesLabel",
                value: function getAirlinesLabel() {
                    var codes = this.values.airlineCodes;
                    if (codes.length === 0) {
                        return this.messages.labelAirlinesAny;
                    }
                    return codes.join(', ');
                }

                /**
                 * Кол-во туристов. Формат для лейбла формы поиска "Кто едет? ..."
                 * @param {boolean} full
                 * @param {string[]|null} adultWords
                 * @param {string[]|null} childWords
                 * @param {boolean} addChildAges
                 * @return {string}
                 */

            }, {
                key: "getTouristsLabel",
                value: function getTouristsLabel() {
                    var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                    var adultWords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                    var childWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                    var addChildAges = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                    var _values2 = this.values,
                        adult = _values2.adult,
                        child = _values2.child,
                        childAges = _values2.childAges;

                    var label = this.tourists.getLabel({
                        adult: adult,
                        child: child,
                        full: full,
                        adultWords: adultWords,
                        childWords: childWords
                    });
                    if (addChildAges && child > 0 && childAges.length) {
                        return label + ' (' + childAges.join(',') + ')';
                    }
                    return label;
                }

                /**
                 * Кол-во туристов с указанием возрастов
                 * @param {boolean} full
                 * @return {string}
                 */

            }, {
                key: "getTouristsLabelWithChildAges",
                value: function getTouristsLabelWithChildAges() {
                    var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    return this.getTouristsLabel(full, null, null, true);
                }

                /**
                 * Лейбл даты. На текущий момент одинаковый для мобильной и десктоп версии
                 * @return {string}
                 */

            }, {
                key: "getSelectedDateLabel",
                value: function getSelectedDateLabel() {
                    return this.makeDateLabel(this.values.selectedDate, false, false);
                }

                /**
                 * @return {string}
                 */

            }, {
                key: "getDateRangeLabel",
                value: function getDateRangeLabel() {
                    if (this.values.isSoftDates) {
                        var dateRange = this.values.dateRange;
                        return this.makeDateLabel(dateRange.from) + ' - ' + this.makeDateLabel(dateRange.to);
                    }

                    return this.makeDateLabel(this.values.selectedDate);
                }
            }, {
                key: "getDateRangeSummaryLabel",
                value: function getDateRangeSummaryLabel() {
                    var rangeSeparator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ' — ';
                    var forceAllShort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    if (this.values.isSoftDates) {
                        var _values$dateRange = this.values.dateRange,
                            from = _values$dateRange.from,
                            to = _values$dateRange.to;

                        if (from.getMonth() === to.getMonth()) {
                            return from.getDate() + rangeSeparator + to.getDate() + ' ' + this.getMonthLabel(to, forceAllShort);
                        } else {
                            return from.getDate() + ' ' + this.getMonthLabel(from, true) + rangeSeparator + to.getDate() + ' ' + this.getMonthLabel(to, true);
                        }
                    }
                    var selectedDate = this.values.selectedDate;
                    return selectedDate.getDate() + ' ' + this.getMonthLabel(selectedDate, forceAllShort);
                }
            }, {
                key: "getDateRangeStateLabel",
                value: function getDateRangeStateLabel() {
                    return this.getDateRangeSummaryLabel(' - ', true);
                }

                /**
                 * @private
                 * @param {Date} jsDate
                 * @param {boolean} inDigits
                 * @param {boolean} leadZero
                 * @return {string}
                 */

            }, {
                key: "makeDateLabel",
                value: function makeDateLabel(jsDate) {
                    var inDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var leadZero = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                    var day = leadZero ? ('0' + jsDate.getDate()).slice(-2) : jsDate.getDate();
                    if (inDigits) {
                        var monthNumber = jsDate.getMonth() + 1;
                        var month = leadZero ? ('0' + monthNumber).slice(-2) : monthNumber;
                        return day + '.' + month;
                    }
                    return day + ' ' + this.getMonthLabel(jsDate);
                }

                /**
                 * @private
                 * @param {Date} jsDate
                 * @param {boolean} short
                 */

            }, {
                key: "getMonthLabel",
                value: function getMonthLabel(jsDate) {
                    var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                    var month = this.messages.calendar.monthsOn[jsDate.getMonth()];
                    return short ? month.slice(0, 3) : month;
                }

                /**
                 * @param {boolean} allRegionNames - вывести названия всех выбранных регионов
                 * @return {string}
                 */

            }, {
                key: "getDestinationLabel",
                value: function getDestinationLabel() {
                    var allRegionNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    var destinationLabel = void 0;
                    var values = this.values;
                    if (values.selectedHotel) {
                        destinationLabel = values.selectedHotel.name; // TODO:
                    } else if (values.regionIds.length) {
                        destinationLabel = this.data.getCountry(values.countryId).name;
                        var regionsCount = values.regionIds.length;
                        if (allRegionNames) {
                            destinationLabel += ' (' + this.data.getRegionNames(values.countryId, values.regionIds) + ')';
                        } else if (regionsCount === 1) {
                            destinationLabel += ', ' + this.data.getRegionName(this.values.countryId, this.values.regionIds[0]);
                        } else {
                            destinationLabel += ' (' + regionsCount + ' ' + i18nPlural(regionsCount, this.messages.pluralResorts) + ')';
                        }
                    } else {
                        destinationLabel = this.values.countryId ? this.data.getCountry(this.values.countryId).name : '';
                    }

                    return destinationLabel;
                }
            }]);

            return SearchFormValuesLabel;
        }();

        window.SearchFormValuesLabel = SearchFormValuesLabel;
    }, {}] }, {}, [1]);